import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { fetcher } from '../app/fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
};

/** Generated programmatically from model: Action */
export type Action = {
  action?: Maybe<Scalars['String']>;
  action_line?: Maybe<Scalars['String']>;
  actionable_id?: Maybe<Scalars['Int']>;
  actionable_type?: Maybe<Scalars['String']>;
  admin?: Maybe<Admin>;
  admin_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ActivateAdapterAlarm */
export type ActivateAdapterAlarmPayload = {
  adapter?: Maybe<Adapter>;
};

/** Generated programmatically from model: Activation */
export type Activation = {
  actions?: Maybe<Array<Action>>;
  api_user?: Maybe<ApiUser>;
  api_user_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['String']>;
  created_at_iso?: Maybe<Scalars['String']>;
  disabled_at?: Maybe<Scalars['String']>;
  enabled_at?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  listing_service?: Maybe<ListingService>;
  listing_service_id?: Maybe<Scalars['Int']>;
  status?: Maybe<ActivationStatus>;
  updated_at?: Maybe<Scalars['String']>;
  warnings?: Maybe<Array<Scalars['String']>>;
};


/** Generated programmatically from model: Activation */
export type ActivationActionsArgs = {
  action?: InputMaybe<Scalars['String']>;
  actionable_id?: InputMaybe<Scalars['Int']>;
  actionable_type?: InputMaybe<Scalars['String']>;
  admin_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};

/** Generated programmatically */
export enum ActivationStatus {
  InProgress = 'in_progress',
  Live = 'live',
  OnHold = 'on_hold',
  PhasingOut = 'phasing_out'
}

/** Generated programmatically from model: Adapter */
export type Adapter = {
  absolute_lon?: Maybe<Scalars['Boolean']>;
  actions?: Maybe<Array<Action>>;
  adapter_alarms?: Maybe<Array<AdapterAlarm>>;
  adapter_type?: Maybe<AdapterAdapterType>;
  aggregated_stats?: Maybe<Array<Stat>>;
  alarm_profiles?: Maybe<Array<AlarmProfile>>;
  alarms?: Maybe<Array<Alarm>>;
  audience?: Maybe<Scalars['String']>;
  auth_endpoint?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  current_in_progress?: Maybe<Stat>;
  current_job?: Maybe<Scalars['String']>;
  current_task?: Maybe<Scalars['Int']>;
  disabled_alarms?: Maybe<Array<DisabledAlarm>>;
  es_status?: Maybe<AdapterEsStatus>;
  es_version?: Maybe<Scalars['Int']>;
  grant_type?: Maybe<AdapterGrantType>;
  health?: Maybe<AdapterHealth>;
  id: Scalars['ID'];
  is_paused?: Maybe<Scalars['Boolean']>;
  json_token_fetch?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  listing_services?: Maybe<Array<ListingService>>;
  metadata?: Maybe<Metadata>;
  mongo_cluster?: Maybe<AdapterMongoCluster>;
  mongo_export_status?: Maybe<Scalars['JSON']>;
  no_pagination?: Maybe<Scalars['Boolean']>;
  ownerships?: Maybe<Array<Ownership>>;
  password?: Maybe<Scalars['String']>;
  raw_export?: Maybe<Scalars['JSON']>;
  record_counts?: Maybe<RecordCounts>;
  replication_prefix?: Maybe<Scalars['Boolean']>;
  request_time_zone?: Maybe<Scalars['String']>;
  resource_basic_auth?: Maybe<Scalars['Boolean']>;
  resource_groups?: Maybe<Array<ResourceGroup>>;
  resources?: Maybe<Array<Resource>>;
  response_time_zone?: Maybe<Scalars['String']>;
  rets_version?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  service?: Maybe<AdapterService>;
  service_adapters?: Maybe<Array<ServiceAdapter>>;
  single_login?: Maybe<Scalars['Boolean']>;
  stats?: Maybe<Array<Stat>>;
  status?: Maybe<AdapterStatus>;
  update_dom?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['String']>;
  updates_by_hour?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  use_jwt_auth?: Maybe<Scalars['Boolean']>;
  use_replication_endpoint?: Maybe<Scalars['Boolean']>;
  user_agent?: Maybe<Scalars['String']>;
  user_agent_password?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
};


/** Generated programmatically from model: Adapter */
export type AdapterActionsArgs = {
  action?: InputMaybe<Scalars['String']>;
  actionable_id?: InputMaybe<Scalars['Int']>;
  actionable_type?: InputMaybe<Scalars['String']>;
  admin_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: Adapter */
export type AdapterAggregated_StatsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


/** Generated programmatically from model: Adapter */
export type AdapterAlarm_ProfilesArgs = {
  adapter_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  field?: InputMaybe<AlarmProfileField>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  job?: InputMaybe<AlarmProfileJob>;
  job_status?: InputMaybe<AlarmProfileJobStatus>;
  limit?: InputMaybe<Scalars['Int']>;
  max_threshold?: InputMaybe<Scalars['Int']>;
  min_threshold?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  operation?: InputMaybe<AlarmProfileOperation>;
  page?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<AlarmProfileRole>;
  sort?: InputMaybe<QuerySortType>;
  status?: InputMaybe<AlarmProfileStatus>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: Adapter */
export type AdapterAlarmsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  alarm_profile_id?: InputMaybe<Scalars['Int']>;
  alarmable_id?: InputMaybe<Scalars['Int']>;
  alarmable_type?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  cleared_at?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: Adapter */
export type AdapterDisabled_AlarmsArgs = {
  adapter_id?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: Adapter */
export type AdapterOwnershipsArgs = {
  admin_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  ownable_id?: InputMaybe<Scalars['Int']>;
  ownable_type?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: Adapter */
export type AdapterResource_GroupsArgs = {
  adapter_id?: InputMaybe<Scalars['Int']>;
  audit_data?: InputMaybe<Scalars['Boolean']>;
  audit_window?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  dom_calculation_v2?: InputMaybe<Scalars['Boolean']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  filter_photo_urls?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  index_data?: InputMaybe<Scalars['Boolean']>;
  latest_reverse_audit?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  mapping_current?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  page_size?: InputMaybe<Scalars['Int']>;
  pending_change?: InputMaybe<Scalars['Boolean']>;
  percolate_delay?: InputMaybe<Scalars['Int']>;
  photo_settings?: InputMaybe<Scalars['String']>;
  photo_strategy?: InputMaybe<ResourceGroupPhotoStrategy>;
  photos_updated_at_field?: InputMaybe<Scalars['String']>;
  populate_date_field?: InputMaybe<Scalars['String']>;
  preserve_photos?: InputMaybe<Scalars['Boolean']>;
  purge_listings_automatically?: InputMaybe<Scalars['Boolean']>;
  replication?: InputMaybe<Scalars['Boolean']>;
  reverse_audit_count?: InputMaybe<Scalars['Int']>;
  reverse_audit_interval?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<ResourceGroupRole>;
  search_data?: InputMaybe<Scalars['Boolean']>;
  skip_photos?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<QuerySortType>;
  status?: InputMaybe<ResourceGroupStatus>;
  track_fields?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
  unique_id_field?: InputMaybe<Scalars['String']>;
  update_window?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['String']>;
  updated_at_field?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};


/** Generated programmatically from model: Adapter */
export type AdapterResourcesArgs = {
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  latest_audit?: InputMaybe<Scalars['String']>;
  latest_monthly_audit?: InputMaybe<Scalars['String']>;
  latest_update?: InputMaybe<Scalars['String']>;
  latest_weekly_audit?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  resource_group_id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  source_class?: InputMaybe<Scalars['String']>;
  source_type?: InputMaybe<Scalars['String']>;
  update_data?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: Adapter */
export type AdapterService_AdaptersArgs = {
  adapter_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  listing_service_id?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: Adapter */
export type AdapterStatsArgs = {
  created_at?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  es_id?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  finished_at?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  job?: InputMaybe<StatJob>;
  limit?: InputMaybe<Scalars['Int']>;
  locked_at?: InputMaybe<Scalars['String']>;
  locked_by?: InputMaybe<Scalars['String']>;
  log_line?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  queued_at?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<QuerySortType>;
  started_at?: InputMaybe<Scalars['String']>;
  statable_id?: InputMaybe<Scalars['Int']>;
  statable_type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StatStatus>;
  took?: InputMaybe<Scalars['Float']>;
  total_records?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['String']>;
};

/** Generated programmatically */
export enum AdapterAdapterType {
  Bridge = 'bridge',
  Flex = 'flex',
  Mlsgrid = 'mlsgrid',
  MlsgridV2 = 'mlsgrid_v2',
  Paragon = 'paragon',
  Rapattoni = 'rapattoni',
  RapattoniMedia = 'rapattoni_media',
  Reso = 'reso',
  ResoToken = 'reso_token',
  ResoTransport = 'reso_transport',
  Rets = 'rets',
  RetsReso = 'rets_reso',
  RetsSubClass = 'rets_sub_class',
  Trestle = 'trestle'
}

export type AdapterAlarm = {
  description?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type AdapterAlarmInput = {
  adapter_id: Scalars['ID'];
  category: Scalars['String'];
  disable: Scalars['Boolean'];
};

/** Generated programmatically */
export enum AdapterEsStatus {
  Loading = 'loading',
  Pending = 'pending',
  Stable = 'stable',
  Stopped = 'stopped'
}

/** Generated programmatically */
export enum AdapterGrantType {
  ClientCredentials = 'client_credentials',
  Password = 'password'
}

export type AdapterHealth = {
  audit?: Maybe<Scalars['Int']>;
  audit_resolution?: Maybe<Scalars['Int']>;
  consumers?: Maybe<Scalars['Int']>;
  monthly_audit?: Maybe<Scalars['Int']>;
  sync?: Maybe<Scalars['Int']>;
  weekly_audit?: Maybe<Scalars['Int']>;
};

/** Generated programmatically */
export enum AdapterMongoCluster {
  Mongo_1 = 'mongo_1',
  Mongo_2 = 'mongo_2'
}

/** Generated programmatically */
export enum AdapterService {
  Down = 'down',
  Interrupted = 'interrupted',
  Stable = 'stable'
}

/** Generated programmatically */
export enum AdapterStatus {
  Deprecated = 'deprecated',
  InProgress = 'in_progress',
  Live = 'live',
  NotStarted = 'not_started'
}

/** Generated programmatically from model: Admin */
export type Admin = {
  actions?: Maybe<Array<Action>>;
  actions_made?: Maybe<Action>;
  activations?: Maybe<Array<Activation>>;
  alerts?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  last_login?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  reset_token?: Maybe<Scalars['String']>;
  reset_url?: Maybe<Scalars['String']>;
  role?: Maybe<AdminRole>;
  signup_token?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};


/** Generated programmatically from model: Admin */
export type AdminActionsArgs = {
  action?: InputMaybe<Scalars['String']>;
  actionable_id?: InputMaybe<Scalars['Int']>;
  actionable_type?: InputMaybe<Scalars['String']>;
  admin_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: Admin */
export type AdminActivationsArgs = {
  api_user_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  disabled_at?: InputMaybe<Scalars['String']>;
  enabled_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  listing_service_id?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  status?: InputMaybe<ActivationStatus>;
  updated_at?: InputMaybe<Scalars['String']>;
  warnings?: InputMaybe<Scalars['String']>;
};

/** Generated programmatically */
export enum AdminRole {
  Accounting = 'accounting',
  Developer = 'developer',
  Marketing = 'marketing',
  Mls = 'mls',
  Sales = 'sales',
  Super = 'super',
  Support = 'support'
}

export type AgentList = {
  MemberFax?: Maybe<Scalars['String']>;
  MemberMiddleName?: Maybe<Scalars['String']>;
  MemberStateLicense?: Maybe<Scalars['String']>;
  agent_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type AgentResultType = {
  MemberFax?: Maybe<Scalars['String']>;
  MemberMiddleName?: Maybe<Scalars['String']>;
  MemberStateLicense?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  agent_id?: Maybe<Scalars['String']>;
  ao_board_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastname?: Maybe<Scalars['String']>;
  login?: Maybe<Scalars['String']>;
  office_name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  raw?: Maybe<Scalars['String']>;
  raw_data?: Maybe<RawData>;
  updated_at?: Maybe<Scalars['String']>;
  wr_fetched_at?: Maybe<Scalars['String']>;
  wr_resource_id?: Maybe<Scalars['Int']>;
};

export type AgentSearch = {
  count?: Maybe<Scalars['Int']>;
  explain?: Maybe<Scalars['String']>;
  results?: Maybe<Array<AgentResultType>>;
};

export type AgentSell = {
  MemberFax?: Maybe<Scalars['String']>;
  MemberMiddleName?: Maybe<Scalars['String']>;
  MemberStateLicense?: Maybe<Scalars['String']>;
  agent_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

/** Generated programmatically from model: Alarm */
export type Alarm = {
  active?: Maybe<Scalars['Boolean']>;
  alarm_profile?: Maybe<AlarmProfile>;
  alarm_profile_id?: Maybe<Scalars['Int']>;
  alarmable?: Maybe<AlarmableUnion>;
  alarmable_id?: Maybe<Scalars['Int']>;
  alarmable_type?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  cleared_at?: Maybe<Scalars['String']>;
  cleared_at_iso?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  created_at_iso?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  updated_at?: Maybe<Scalars['String']>;
  url_path?: Maybe<Scalars['String']>;
};

/** Generated programmatically from model: AlarmProfile */
export type AlarmProfile = {
  adapter?: Maybe<Adapter>;
  adapter_id?: Maybe<Scalars['Int']>;
  alarms?: Maybe<Array<Alarm>>;
  created_at?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  explain?: Maybe<Scalars['String']>;
  field?: Maybe<AlarmProfileField>;
  id: Scalars['ID'];
  job?: Maybe<AlarmProfileJob>;
  job_status?: Maybe<AlarmProfileJobStatus>;
  max_threshold?: Maybe<Scalars['Int']>;
  min_threshold?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  operation?: Maybe<AlarmProfileOperation>;
  role?: Maybe<AlarmProfileRole>;
  status?: Maybe<AlarmProfileStatus>;
  updated_at?: Maybe<Scalars['String']>;
};


/** Generated programmatically from model: AlarmProfile */
export type AlarmProfileAlarmsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  alarm_profile_id?: InputMaybe<Scalars['Int']>;
  alarmable_id?: InputMaybe<Scalars['Int']>;
  alarmable_type?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  cleared_at?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};

/** Generated programmatically */
export enum AlarmProfileField {
  Took = 'took',
  TotalRecords = 'total_records'
}

/** Generated programmatically */
export enum AlarmProfileJob {
  AdapterAlarmer = 'adapter_alarmer',
  Alarmer = 'alarmer',
  Auditor = 'auditor',
  FactsConsumer = 'facts_consumer',
  FeedDownChecker = 'feed_down_checker',
  FetchGlobalCounts = 'fetch_global_counts',
  IndexCleaner = 'index_cleaner',
  MlsFieldCompiler = 'mls_field_compiler',
  MonthlyAuditor = 'monthly_auditor',
  MoveCollection = 'move_collection',
  Percolator = 'percolator',
  PhotoUploader = 'photo_uploader',
  PopulateDay = 'populate_day',
  Populator = 'populator',
  RecordsConsumer = 'records_consumer',
  RecordsDeleter = 'records_deleter',
  Recovery = 'recovery',
  ReindexConsumer = 'reindex_consumer',
  ReplicationConsumer = 'replication_consumer',
  RescheduleReadyJobs = 'reschedule_ready_jobs',
  RetsFeedImport = 'rets_feed_import',
  ReverseAuditResolver = 'reverse_audit_resolver',
  ReverseAuditor = 'reverse_auditor',
  SavedSearchConsumer = 'saved_search_consumer',
  StatPruner = 'stat_pruner',
  UpdateDom = 'update_dom',
  Updater = 'updater',
  UpdatesConsumer = 'updates_consumer',
  WeeklyAuditor = 'weekly_auditor'
}

/** Generated programmatically */
export enum AlarmProfileJobStatus {
  Error = 'error',
  Failed = 'failed',
  FinishedWithErrors = 'finished_with_errors',
  Hold = 'hold',
  InProgress = 'in_progress',
  Ready = 'ready',
  Stopped = 'stopped',
  Success = 'success',
  TooManyAttempts = 'too_many_attempts',
  Unresolved = 'unresolved'
}

/** Generated programmatically */
export enum AlarmProfileOperation {
  Max = 'max',
  Min = 'min',
  Sum = 'sum',
  Total = 'total'
}

/** Generated programmatically */
export enum AlarmProfileRole {
  Agent = 'agent',
  Listing = 'listing'
}

/** Generated programmatically */
export enum AlarmProfileStatus {
  Disabled = 'disabled',
  Enabled = 'enabled'
}

export type AlarmableUnion = Adapter | ListingService;

/** Generated programmatically from model: ApiUser */
export type ApiUser = {
  actions?: Maybe<Array<Action>>;
  activations?: Maybe<Array<Activation>>;
  api_key?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  default_criteria?: Maybe<Array<DefaultCriterium>>;
  environment?: Maybe<ApiUserEnvironment>;
  forge_api?: Maybe<Scalars['Boolean']>;
  full_access?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  jwt?: Maybe<Scalars['String']>;
  listing_services?: Maybe<Array<ListingService>>;
  lwa_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  percolator_endpoint?: Maybe<Scalars['String']>;
  percolator_notifications?: Maybe<ApiUserPercolatorNotification>;
  replication?: Maybe<Scalars['Boolean']>;
  saved_searches?: Maybe<Array<SavedSearch>>;
  search?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['String']>;
};


/** Generated programmatically from model: ApiUser */
export type ApiUserActionsArgs = {
  action?: InputMaybe<Scalars['String']>;
  actionable_id?: InputMaybe<Scalars['Int']>;
  actionable_type?: InputMaybe<Scalars['String']>;
  admin_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ApiUser */
export type ApiUserActivationsArgs = {
  api_user_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  disabled_at?: InputMaybe<Scalars['String']>;
  enabled_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  listing_service_id?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  status?: InputMaybe<ActivationStatus>;
  updated_at?: InputMaybe<Scalars['String']>;
  warnings?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ApiUser */
export type ApiUserDefault_CriteriaArgs = {
  cas_criterium?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['String']>;
  field_name?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  parent_id?: InputMaybe<Scalars['Int']>;
  parent_type?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ApiUser */
export type ApiUserListing_ServicesArgs = {
  address?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  default_search_criteria?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  lon?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  reso_ouid?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<QuerySortType>;
  special_flags?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  time_zone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ApiUser */
export type ApiUserSaved_SearchesArgs = {
  api_user_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  last_match_at?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  listing_service_id?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  raw_criteria?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};

/** Generated programmatically */
export enum ApiUserEnvironment {
  Development = 'development',
  Production = 'production',
  Staging = 'staging'
}

/** Generated programmatically */
export enum ApiUserPercolatorNotification {
  Graphql = 'graphql',
  JobQueue = 'job_queue',
  Rest = 'rest'
}

export enum ColTypeEnum {
  Array = 'array',
  Boolean = 'boolean',
  Date = 'date',
  Float = 'float',
  GeoPoint = 'geo_point',
  GeoShape = 'geo_shape',
  Integer = 'integer',
  Keyword = 'keyword',
  Long = 'long',
  Text = 'text'
}

/** Generated programmatically from model: ConsumerGroup */
export type ConsumerGroup = {
  created_at?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  index_name?: Maybe<Scalars['String']>;
  latest_offset?: Maybe<Scalars['Int']>;
  resource_group?: Maybe<ResourceGroup>;
  resource_group_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['String']>;
};

/** Generated programmatically from model: DefaultCriterium */
export type DefaultCriterium = {
  cas_criterium?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['String']>;
  field_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  parent_id?: Maybe<Scalars['Int']>;
  parent_type?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type DefaultSchemaField = {
  col_name?: Maybe<Scalars['String']>;
  col_type?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  standard_name?: Maybe<Scalars['String']>;
};

export type DefaultSearchInput = {
  eq: Array<Scalars['String']>;
  field: Scalars['String'];
  gte: Scalars['String'];
  lte: Scalars['String'];
  should: Scalars['String'];
  should_eq: Array<Scalars['String']>;
  should_gte: Scalars['String'];
  should_lte: Scalars['String'];
  within: Scalars['String'];
};

/** Autogenerated return type of DeleteRecord */
export type DeleteRecordPayload = {
  success?: Maybe<Scalars['Boolean']>;
};

export type DeletesStatus = {
  last_purge?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

/** Generated programmatically from model: DisabledAlarm */
export type DisabledAlarm = {
  adapter?: Maybe<Adapter>;
  adapter_id?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  updated_at?: Maybe<Scalars['String']>;
};

/** Generated programmatically from model: Field */
export type Field = {
  actions?: Maybe<Array<Action>>;
  agent_only?: Maybe<Scalars['Boolean']>;
  aliases?: Maybe<Array<Scalars['String']>>;
  autocomplete?: Maybe<Scalars['Boolean']>;
  calculate_dom?: Maybe<Scalars['Boolean']>;
  category_name?: Maybe<Scalars['String']>;
  col_name?: Maybe<Scalars['String']>;
  col_type?: Maybe<ColTypeEnum>;
  compose?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  draft_attrs?: Maybe<Scalars['String']>;
  draft_id?: Maybe<Scalars['Int']>;
  field_category?: Maybe<FieldCategory>;
  field_category_id?: Maybe<Scalars['Int']>;
  field_draft?: Maybe<Field>;
  id: Scalars['ID'];
  is_draft?: Maybe<Scalars['Boolean']>;
  lookups?: Maybe<Array<Lookup>>;
  map_values?: Maybe<FieldMapValue>;
  order?: Maybe<Scalars['Int']>;
  pending_changes?: Maybe<Field>;
  possible_categories?: Maybe<Array<FieldCategory>>;
  possible_sources?: Maybe<Array<PossibleSource>>;
  queryable?: Maybe<Scalars['Boolean']>;
  search_display?: Maybe<Scalars['String']>;
  search_values?: Maybe<Array<Scalars['String']>>;
  source_names?: Maybe<Array<Scalars['String']>>;
  sqft?: Maybe<Scalars['Boolean']>;
  standard_name?: Maybe<Scalars['String']>;
  subcategory_name?: Maybe<Scalars['String']>;
  suggestions?: Maybe<Scalars['Boolean']>;
  transforms?: Maybe<Array<Transform>>;
  updated_at?: Maybe<Scalars['String']>;
};


/** Generated programmatically from model: Field */
export type FieldActionsArgs = {
  action?: InputMaybe<Scalars['String']>;
  actionable_id?: InputMaybe<Scalars['Int']>;
  actionable_type?: InputMaybe<Scalars['String']>;
  admin_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: Field */
export type FieldLookupsArgs = {
  created_at?: InputMaybe<Scalars['String']>;
  field_id?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  mapped_value?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  source_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: Field */
export type FieldTransformsArgs = {
  created_at?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  field_id?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  operation?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  serialize_only?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};

/** Generated programmatically from model: FieldCategory */
export type FieldCategory = {
  actions?: Maybe<Array<Action>>;
  created_at?: Maybe<Scalars['String']>;
  field_count?: Maybe<Scalars['Int']>;
  fields?: Maybe<Array<Field>>;
  fine_tuning?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  ignored?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nested?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  private?: Maybe<Scalars['Boolean']>;
  resource_group?: Maybe<ResourceGroup>;
  resource_group_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['String']>;
};


/** Generated programmatically from model: FieldCategory */
export type FieldCategoryActionsArgs = {
  action?: InputMaybe<Scalars['String']>;
  actionable_id?: InputMaybe<Scalars['Int']>;
  actionable_type?: InputMaybe<Scalars['String']>;
  admin_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: FieldCategory */
export type FieldCategoryFieldsArgs = {
  agent_only?: InputMaybe<Scalars['Boolean']>;
  aliases?: InputMaybe<Scalars['String']>;
  autocomplete?: InputMaybe<Scalars['Boolean']>;
  calculate_dom?: InputMaybe<Scalars['Boolean']>;
  category_name?: InputMaybe<Scalars['String']>;
  col_name?: InputMaybe<Scalars['String']>;
  col_type?: InputMaybe<Scalars['String']>;
  compose?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  draft_attrs?: InputMaybe<Scalars['String']>;
  draft_id?: InputMaybe<Scalars['Int']>;
  field_category_id?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  is_draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  map_values?: InputMaybe<FieldMapValue>;
  order?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  queryable?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<QuerySortType>;
  source_names?: InputMaybe<Scalars['String']>;
  sqft?: InputMaybe<Scalars['Boolean']>;
  standard_name?: InputMaybe<Scalars['String']>;
  subcategory_name?: InputMaybe<Scalars['String']>;
  suggestions?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['String']>;
};

/** Generated programmatically */
export enum FieldMapValue {
  Ignore = 'ignore',
  Replace = 'replace',
  Replicate = 'replicate'
}

/** Generated programmatically from model: FieldTemplate */
export type FieldTemplate = {
  aliases?: Maybe<Array<Scalars['String']>>;
  alternate_names?: Maybe<Array<Scalars['String']>>;
  created_at?: Maybe<Scalars['String']>;
  dd_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  field_category_name?: Maybe<FieldTemplateFieldCategoryName>;
  field_type?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  raw?: Maybe<Scalars['String']>;
  record_type?: Maybe<FieldTemplateRecordType>;
  updated_at?: Maybe<Scalars['String']>;
};

/** Generated programmatically */
export enum FieldTemplateFieldCategoryName {
  AgentList = 'agent_list',
  AgentOnly = 'agent_only',
  AgentSell = 'agent_sell',
  Features = 'features',
  Ignored = 'ignored',
  OfficeList = 'office_list',
  OfficeSell = 'office_sell',
  Root = 'root',
  Standard = 'standard'
}

/** Generated programmatically */
export enum FieldTemplateRecordType {
  Agent = 'agent',
  Listing = 'listing',
  Office = 'office',
  Photo = 'photo'
}

export type FilterCriteria = {
  /** Is equal to */
  eq?: InputMaybe<Scalars['String']>;
  field: Scalars['String'];
  /** Greater than or equal to */
  gte?: InputMaybe<Scalars['String']>;
  /** Is in this list */
  in?: InputMaybe<Array<Scalars['String']>>;
  /** Less than or equal to */
  lte?: InputMaybe<Scalars['String']>;
  /** Is NOT equal to */
  not?: InputMaybe<Scalars['String']>;
  /** Is NOT in this list */
  not_in?: InputMaybe<Array<Scalars['String']>>;
};

export type FilterQueryType = {
  /** A JSON string of arrays of circles, ie: "[[lat,lon,distance],[lat,lon,distance]]" */
  circle?: InputMaybe<Scalars['String']>;
  /** Is equal to */
  eq?: InputMaybe<Array<Scalars['String']>>;
  field: Scalars['String'];
  filter_group?: InputMaybe<Array<FilterQueryType>>;
  /** Greater than or equal to */
  gte?: InputMaybe<Scalars['String']>;
  /** Less than or equal to */
  lte?: InputMaybe<Scalars['String']>;
  /** Run a full text search */
  matches?: InputMaybe<Scalars['String']>;
  /** Is NOT equal to */
  not?: InputMaybe<Array<Scalars['String']>>;
  /** A JSON string of arrays of proximity criteria, ie: "[[lat,lon,distance],[lat,lon,distance]]" */
  proximity?: InputMaybe<Scalars['String']>;
  /** All should criteria work together as an 'OR' */
  should?: InputMaybe<Array<Scalars['String']>>;
  /** Is equal to */
  should_eq?: InputMaybe<Array<Scalars['String']>>;
  /** Greater than or equal to */
  should_gte?: InputMaybe<Scalars['String']>;
  /** Less than or equal to */
  should_lte?: InputMaybe<Scalars['String']>;
  /** Run a full text search */
  should_match?: InputMaybe<Scalars['String']>;
  /** A JSON string of arrays of shapes, ie: "[[[lat,lon],[lat,lon],[lat,lon],[lat,lon]]]" */
  within?: InputMaybe<Scalars['String']>;
};

export type GlobalCounts = {
  adapters?: Maybe<Scalars['String']>;
  agents?: Maybe<Scalars['String']>;
  listing_services?: Maybe<Scalars['String']>;
  listings?: Maybe<Scalars['String']>;
  offices?: Maybe<Scalars['String']>;
  updates_today?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of IndexAllSuggestions */
export type IndexAllSuggestionsPayload = {
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of InitExport */
export type InitExportPayload = {
  info?: Maybe<Scalars['JSON']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Generated programmatically from model: Join */
export type Join = {
  created_at?: Maybe<Scalars['String']>;
  foreign_key?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  join_all?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  prefix_field?: Maybe<Scalars['String']>;
  primary_key?: Maybe<Scalars['String']>;
  resource_group?: Maybe<ResourceGroup>;
  resource_group_id?: Maybe<Scalars['Int']>;
  resource_id?: Maybe<Scalars['Int']>;
  source_class?: Maybe<Scalars['String']>;
  source_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type ListingPin = {
  count?: Maybe<Scalars['Int']>;
  geohash?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  records?: Maybe<Array<ListingPinListing>>;
};

export type ListingPinListing = {
  id?: Maybe<Scalars['String']>;
  mapped_status?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type ListingResultType = {
  AssociationName?: Maybe<Scalars['String']>;
  CoListAgentDirectPhone?: Maybe<Scalars['String']>;
  CoListAgentEmail?: Maybe<Scalars['String']>;
  CoListAgentFax?: Maybe<Scalars['String']>;
  CoListAgentFirstName?: Maybe<Scalars['String']>;
  CoListAgentFullName?: Maybe<Scalars['String']>;
  CoListAgentLastName?: Maybe<Scalars['String']>;
  CoListAgentMiddleName?: Maybe<Scalars['String']>;
  CoListAgentMlsId?: Maybe<Scalars['String']>;
  CoListAgentMobilePhone?: Maybe<Scalars['String']>;
  CoListAgentStateLicense?: Maybe<Scalars['String']>;
  CoListOfficeEmail?: Maybe<Scalars['String']>;
  CoListOfficeFax?: Maybe<Scalars['String']>;
  CoListOfficeKey?: Maybe<Scalars['String']>;
  CoListOfficeMlsID?: Maybe<Scalars['String']>;
  CoListOfficeName?: Maybe<Scalars['String']>;
  CoListOfficePhone?: Maybe<Scalars['String']>;
  MemberFax?: Maybe<Scalars['String']>;
  MemberMiddleName?: Maybe<Scalars['String']>;
  MemberStateLicense?: Maybe<Scalars['String']>;
  OfficeAddress1?: Maybe<Scalars['String']>;
  OfficeAddress2?: Maybe<Scalars['String']>;
  OfficeCity?: Maybe<Scalars['String']>;
  OfficeCorporateLicense?: Maybe<Scalars['String']>;
  OfficeFax?: Maybe<Scalars['String']>;
  OfficePostalCode?: Maybe<Scalars['String']>;
  OfficePostalCodePlus4?: Maybe<Scalars['String']>;
  OfficeStateOrProvince?: Maybe<Scalars['String']>;
  OwnerEmail?: Maybe<Scalars['String']>;
  OwnerName?: Maybe<Scalars['String']>;
  OwnerPhone?: Maybe<Scalars['String']>;
  PostalCodePlus4?: Maybe<Scalars['String']>;
  PublicSurveySection?: Maybe<Scalars['String']>;
  StreetDirPrefix?: Maybe<Scalars['String']>;
  StreetDirSuffix?: Maybe<Scalars['String']>;
  StreetSuffix?: Maybe<Scalars['String']>;
  TaxBlock?: Maybe<Scalars['String']>;
  TaxLegalDescription?: Maybe<Scalars['String']>;
  TaxLot?: Maybe<Scalars['String']>;
  TaxMapNumber?: Maybe<Scalars['String']>;
  ZoningDescription?: Maybe<Scalars['String']>;
  acres?: Maybe<Scalars['Float']>;
  address?: Maybe<Scalars['String']>;
  agent_list?: Maybe<AgentList>;
  agent_sell?: Maybe<AgentSell>;
  area?: Maybe<Scalars['String']>;
  assoc_fee?: Maybe<Scalars['Float']>;
  baths?: Maybe<Scalars['Float']>;
  baths_full?: Maybe<Scalars['Float']>;
  baths_half?: Maybe<Scalars['Float']>;
  baths_quarter?: Maybe<Scalars['Float']>;
  baths_search?: Maybe<Scalars['Float']>;
  baths_three_quarter?: Maybe<Scalars['Float']>;
  beds?: Maybe<Scalars['Int']>;
  cdom?: Maybe<Scalars['String']>;
  changes?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  date_expired?: Maybe<Scalars['String']>;
  date_list?: Maybe<Scalars['String']>;
  date_offmarket?: Maybe<Scalars['String']>;
  date_pending?: Maybe<Scalars['String']>;
  date_sold?: Maybe<Scalars['String']>;
  directions?: Maybe<Scalars['String']>;
  dom?: Maybe<Scalars['String']>;
  feature_categories?: Maybe<Scalars['String']>;
  features?: Maybe<Scalars['String']>;
  features_stories_total?: Maybe<Scalars['Int']>;
  full_address?: Maybe<Scalars['String']>;
  garages?: Maybe<Scalars['String']>;
  gps_loc?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lat?: Maybe<Scalars['Float']>;
  location?: Maybe<Scalars['String']>;
  lockbox_location?: Maybe<Scalars['String']>;
  lockbox_type?: Maybe<Scalars['String']>;
  lon?: Maybe<Scalars['Float']>;
  lotdim?: Maybe<Scalars['String']>;
  lotsize?: Maybe<Scalars['Float']>;
  mapped_prop_type?: Maybe<Scalars['String']>;
  mapped_status?: Maybe<Scalars['String']>;
  mlsnum?: Maybe<Scalars['String']>;
  office_list?: Maybe<OfficeList>;
  office_sell?: Maybe<OfficeSell>;
  parcel?: Maybe<Scalars['String']>;
  photo_count?: Maybe<Scalars['String']>;
  photos?: Maybe<Array<Scalars['String']>>;
  photos_updated_at?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  price_list?: Maybe<Scalars['Int']>;
  price_list_low?: Maybe<Scalars['Int']>;
  price_list_orig?: Maybe<Scalars['Int']>;
  price_list_per_sqft?: Maybe<Scalars['Float']>;
  price_sold?: Maybe<Scalars['Int']>;
  price_sold_per_sqft?: Maybe<Scalars['Float']>;
  prop_sub_type?: Maybe<Scalars['String']>;
  prop_type?: Maybe<Scalars['String']>;
  raw_data?: Maybe<RawData>;
  remarks?: Maybe<Scalars['String']>;
  remarks_private?: Maybe<Scalars['String']>;
  sale_rent?: Maybe<Scalars['String']>;
  school_district?: Maybe<Scalars['String']>;
  school_elementary?: Maybe<Scalars['String']>;
  school_high?: Maybe<Scalars['String']>;
  school_middle?: Maybe<Scalars['String']>;
  showing_inst?: Maybe<Scalars['String']>;
  sqft?: Maybe<Scalars['Int']>;
  sqft_fields?: Maybe<Scalars['JSON']>;
  sqft_source?: Maybe<Scalars['String']>;
  sqft_total?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  streetname?: Maybe<Scalars['String']>;
  streetnum?: Maybe<Scalars['String']>;
  style?: Maybe<Scalars['String']>;
  subdivision?: Maybe<Scalars['String']>;
  taxes?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  wr_fetched_at?: Maybe<Scalars['String']>;
  wr_resource_id?: Maybe<Scalars['Int']>;
  year_built?: Maybe<Scalars['Int']>;
  zip?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type ListingSearch = {
  count?: Maybe<Scalars['Int']>;
  explain?: Maybe<Scalars['String']>;
  meta?: Maybe<ListingSearchMetaType>;
  pins?: Maybe<Array<ListingPin>>;
  results?: Maybe<Array<ListingResultType>>;
};


export type ListingSearchPinsArgs = {
  precision?: InputMaybe<Scalars['Int']>;
};

export type ListingSearchMetaType = {
  count?: Maybe<Scalars['Int']>;
};

/** Generated programmatically from model: ListingService */
export type ListingService = {
  actions?: Maybe<Array<Action>>;
  activations?: Maybe<Array<Activation>>;
  adapters?: Maybe<Array<Adapter>>;
  address?: Maybe<Scalars['String']>;
  agents?: Maybe<AgentSearch>;
  alarms?: Maybe<Array<Alarm>>;
  api_users?: Maybe<Array<ApiUser>>;
  checks?: Maybe<ListingServiceChecks>;
  config?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  default_search?: Maybe<Scalars['String']>;
  default_search_criteria?: Maybe<Scalars['String']>;
  fields?: Maybe<Array<Field>>;
  flags?: Maybe<Array<SpecialFlag>>;
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  listings?: Maybe<ListingSearch>;
  lon?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  offices?: Maybe<OfficeSearch>;
  ownerships?: Maybe<Array<Ownership>>;
  reso_ouid?: Maybe<Scalars['String']>;
  saved_search_health?: Maybe<SavedSearchHealth>;
  saved_searches?: Maybe<Array<SavedSearch>>;
  service?: Maybe<Scalars['String']>;
  service_adapters?: Maybe<Array<ServiceAdapter>>;
  special_flags?: Maybe<Scalars['String']>;
  state?: Maybe<Array<Scalars['String']>>;
  status_mapping?: Maybe<StatusMapping>;
  time_zone?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};


/** Generated programmatically from model: ListingService */
export type ListingServiceActionsArgs = {
  action?: InputMaybe<Scalars['String']>;
  actionable_id?: InputMaybe<Scalars['Int']>;
  actionable_type?: InputMaybe<Scalars['String']>;
  admin_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ListingService */
export type ListingServiceActivationsArgs = {
  api_user_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  disabled_at?: InputMaybe<Scalars['String']>;
  enabled_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  listing_service_id?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  status?: InputMaybe<ActivationStatus>;
  updated_at?: InputMaybe<Scalars['String']>;
  warnings?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ListingService */
export type ListingServiceAdaptersArgs = {
  absolute_lon?: InputMaybe<Scalars['Boolean']>;
  adapter_type?: InputMaybe<AdapterAdapterType>;
  audience?: InputMaybe<Scalars['String']>;
  auth_endpoint?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  current_task?: InputMaybe<Scalars['Int']>;
  es_status?: InputMaybe<AdapterEsStatus>;
  es_version?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  grant_type?: InputMaybe<AdapterGrantType>;
  id?: InputMaybe<Scalars['ID']>;
  is_paused?: InputMaybe<Scalars['Boolean']>;
  json_token_fetch?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  mongo_cluster?: InputMaybe<AdapterMongoCluster>;
  no_pagination?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  replication_prefix?: InputMaybe<Scalars['Boolean']>;
  request_time_zone?: InputMaybe<Scalars['String']>;
  resource_basic_auth?: InputMaybe<Scalars['Boolean']>;
  response_time_zone?: InputMaybe<Scalars['String']>;
  rets_version?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<AdapterService>;
  single_login?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<QuerySortType>;
  status?: InputMaybe<AdapterStatus>;
  update_dom?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  use_jwt_auth?: InputMaybe<Scalars['Boolean']>;
  use_replication_endpoint?: InputMaybe<Scalars['Boolean']>;
  user_agent?: InputMaybe<Scalars['String']>;
  user_agent_password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  vendor?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ListingService */
export type ListingServiceAgentsArgs = {
  fields?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<Array<InputMaybe<FilterQueryType>>>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  source?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ListingService */
export type ListingServiceAlarmsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  alarm_profile_id?: InputMaybe<Scalars['Int']>;
  alarmable_id?: InputMaybe<Scalars['Int']>;
  alarmable_type?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  cleared_at?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ListingService */
export type ListingServiceApi_UsersArgs = {
  api_key?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<ApiUserEnvironment>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  forge_api?: InputMaybe<Scalars['Boolean']>;
  full_access?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  lwa_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  password_digest?: InputMaybe<Scalars['String']>;
  percolator_endpoint?: InputMaybe<Scalars['String']>;
  percolator_notifications?: InputMaybe<ApiUserPercolatorNotification>;
  replication?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ListingService */
export type ListingServiceListingsArgs = {
  fields?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<Array<InputMaybe<FilterQueryType>>>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  proximity?: InputMaybe<ProximityFilterType>;
  reload?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<QuerySortType>;
  source?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ListingService */
export type ListingServiceOfficesArgs = {
  fields?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<Array<InputMaybe<FilterQueryType>>>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  source?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ListingService */
export type ListingServiceOwnershipsArgs = {
  admin_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  ownable_id?: InputMaybe<Scalars['Int']>;
  ownable_type?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ListingService */
export type ListingServiceSaved_SearchesArgs = {
  api_user_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  last_match_at?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  listing_service_id?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  raw_criteria?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ListingService */
export type ListingServiceService_AdaptersArgs = {
  adapter_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  listing_service_id?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};

export type ListingServiceChecks = {
  missing_streams_fields?: Maybe<Array<Scalars['String']>>;
};

/** Autogenerated return type of Login */
export type LoginPayload = {
  admin?: Maybe<Admin>;
  token?: Maybe<Scalars['String']>;
};

/** Generated programmatically from model: Lookup */
export type Lookup = {
  created_at?: Maybe<Scalars['String']>;
  field?: Maybe<Field>;
  field_id?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  mapped_value?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  source_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type MdClass = {
  fields?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
};

export type MdObject = {
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** A simplified version of the  Metadata */
export type MdResource = {
  classes?: Maybe<Array<MdClass>>;
  name?: Maybe<Scalars['String']>;
  objects?: Maybe<Array<MdObject>>;
};

export type MdSystemInfo = {
  connected?: Maybe<Scalars['Boolean']>;
  date?: Maybe<Scalars['String']>;
  system_description?: Maybe<Scalars['String']>;
  system_id?: Maybe<Scalars['String']>;
  timezone_offset?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

/** A simplified version of the rets metadata */
export type Metadata = {
  logs?: Maybe<Scalars['String']>;
  resources?: Maybe<Array<MdResource>>;
  system_info?: Maybe<MdSystemInfo>;
};

export type ModificationTimestamp = {
  newest_timestamp?: Maybe<Scalars['String']>;
  oldest_timestamp?: Maybe<Scalars['String']>;
  recommended_request_timezone?: Maybe<Scalars['String']>;
  recommended_response_timezone?: Maybe<Scalars['String']>;
  timestamp_variance?: Maybe<Scalars['Float']>;
  total_records?: Maybe<Scalars['Int']>;
};

export type Mutation = {
  activateAdapterAlarm?: Maybe<ActivateAdapterAlarmPayload>;
  clearDeletes?: Maybe<Scalars['Boolean']>;
  createActivation?: Maybe<Activation>;
  createAdapter?: Maybe<Adapter>;
  createAdmin?: Maybe<Admin>;
  createAlarmProfile?: Maybe<AlarmProfile>;
  createApiUser?: Maybe<ApiUser>;
  createDefaultCriterium?: Maybe<DefaultCriterium>;
  createField?: Maybe<Field>;
  createFieldTemplate?: Maybe<FieldTemplate>;
  createListingService?: Maybe<ListingService>;
  createLookup?: Maybe<Lookup>;
  createLookupsFromAggs?: Maybe<Field>;
  createLookupsFromMetadata?: Maybe<Field>;
  createServiceAdapter?: Maybe<ServiceAdapter>;
  createStat?: Maybe<Stat>;
  createTransform?: Maybe<Transform>;
  deleteActivation?: Maybe<Scalars['Boolean']>;
  deleteAdapter?: Maybe<Scalars['Boolean']>;
  deleteAdmin?: Maybe<Scalars['Boolean']>;
  deleteAlarmProfile?: Maybe<Scalars['Boolean']>;
  deleteAllLookups?: Maybe<Field>;
  deleteApiUser?: Maybe<Scalars['Boolean']>;
  deleteDefaultCriterium?: Maybe<Scalars['Boolean']>;
  deleteField?: Maybe<Scalars['Boolean']>;
  deleteFieldTemplate?: Maybe<Scalars['Boolean']>;
  deleteListingService?: Maybe<Scalars['Boolean']>;
  deleteLookup?: Maybe<Scalars['Boolean']>;
  deleteRecord?: Maybe<DeleteRecordPayload>;
  deleteResource?: Maybe<Scalars['Boolean']>;
  deleteResourceGroup?: Maybe<Scalars['Boolean']>;
  deleteSavedSearch?: Maybe<Scalars['Boolean']>;
  deleteServiceAdapter?: Maybe<Scalars['Boolean']>;
  deleteTransform?: Maybe<Scalars['Boolean']>;
  importMetadata?: Maybe<ResourceGroup>;
  indexAllSuggestions?: Maybe<IndexAllSuggestionsPayload>;
  init_export?: Maybe<InitExportPayload>;
  login?: Maybe<LoginPayload>;
  purgeDeletes?: Maybe<Scalars['Boolean']>;
  reRegisterSavedSearch?: Maybe<ReRegisterSavedSearchPayload>;
  reRegisterSavedSearches?: Maybe<Scalars['Boolean']>;
  reorderLookups?: Maybe<Scalars['Boolean']>;
  reorderTransforms?: Maybe<Scalars['Boolean']>;
  resetPassword?: Maybe<Admin>;
  resumePopulateResource?: Maybe<Stat>;
  startPopulate?: Maybe<Stat>;
  transformPipeline?: Maybe<TransformPipelineResult>;
  updateActivation?: Maybe<Activation>;
  updateAdapter?: Maybe<Adapter>;
  updateAdmin?: Maybe<Admin>;
  updateAlarm?: Maybe<Alarm>;
  updateAlarmProfile?: Maybe<AlarmProfile>;
  updateApiUser?: Maybe<ApiUser>;
  updateDefaultCriterium?: Maybe<DefaultCriterium>;
  updateField?: Maybe<Field>;
  updateFieldTemplate?: Maybe<FieldTemplate>;
  updateListingService?: Maybe<ListingService>;
  updateLookup?: Maybe<Lookup>;
  updateResource?: Maybe<Resource>;
  updateResourceGroup?: Maybe<ResourceGroup>;
  updateSavedSearch?: Maybe<SavedSearch>;
  updateStat?: Maybe<Stat>;
  updateTransform?: Maybe<Transform>;
};


export type MutationActivateAdapterAlarmArgs = {
  input: AdapterAlarmInput;
};


export type MutationClearDeletesArgs = {
  resource_group_id: Scalars['ID'];
};


export type MutationCreateActivationArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  api_user_id?: InputMaybe<Scalars['Int']>;
  disabled_at?: InputMaybe<Scalars['String']>;
  enabled_at?: InputMaybe<Scalars['String']>;
  listing_service_id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ActivationStatus>;
  warnings?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationCreateAdapterArgs = {
  absolute_lon?: InputMaybe<Scalars['Boolean']>;
  action_type?: InputMaybe<Scalars['String']>;
  adapter_type?: InputMaybe<AdapterAdapterType>;
  audience?: InputMaybe<Scalars['String']>;
  auth_endpoint?: InputMaybe<Scalars['String']>;
  current_task?: InputMaybe<Scalars['Int']>;
  es_status?: InputMaybe<AdapterEsStatus>;
  es_version?: InputMaybe<Scalars['Int']>;
  grant_type?: InputMaybe<AdapterGrantType>;
  is_paused?: InputMaybe<Scalars['Boolean']>;
  json_token_fetch?: InputMaybe<Scalars['Boolean']>;
  key: Scalars['String'];
  mongo_cluster?: InputMaybe<AdapterMongoCluster>;
  no_pagination?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  replication_prefix?: InputMaybe<Scalars['Boolean']>;
  request_time_zone?: InputMaybe<Scalars['String']>;
  resource_basic_auth?: InputMaybe<Scalars['Boolean']>;
  response_time_zone?: InputMaybe<Scalars['String']>;
  rets_version?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<AdapterService>;
  single_login?: InputMaybe<Scalars['Boolean']>;
  status: AdapterStatus;
  update_dom?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
  use_jwt_auth?: InputMaybe<Scalars['Boolean']>;
  use_replication_endpoint?: InputMaybe<Scalars['Boolean']>;
  user_agent?: InputMaybe<Scalars['String']>;
  user_agent_password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  vendor?: InputMaybe<Scalars['String']>;
};


export type MutationCreateAdminArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  alerts?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  last_login?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  password_confirmation?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  reset_token?: InputMaybe<Scalars['String']>;
  role: AdminRole;
  signup_token?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationCreateAlarmProfileArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  adapter_id?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['Int']>;
  field?: InputMaybe<AlarmProfileField>;
  job?: InputMaybe<AlarmProfileJob>;
  job_status?: InputMaybe<AlarmProfileJobStatus>;
  max_threshold?: InputMaybe<Scalars['Int']>;
  min_threshold?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  operation?: InputMaybe<AlarmProfileOperation>;
  role?: InputMaybe<AlarmProfileRole>;
  status?: InputMaybe<AlarmProfileStatus>;
};


export type MutationCreateApiUserArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  api_key: Scalars['String'];
  environment?: InputMaybe<ApiUserEnvironment>;
  forge_api?: InputMaybe<Scalars['Boolean']>;
  full_access?: InputMaybe<Scalars['Boolean']>;
  lwa_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  percolator_endpoint?: InputMaybe<Scalars['String']>;
  percolator_notifications?: InputMaybe<ApiUserPercolatorNotification>;
  replication?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateDefaultCriteriumArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  cas_criterium?: InputMaybe<Scalars['Boolean']>;
  field_name?: InputMaybe<Scalars['String']>;
  parent_id?: InputMaybe<Scalars['Int']>;
  parent_type?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};


export type MutationCreateFieldArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  agent_only?: InputMaybe<Scalars['Boolean']>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autocomplete?: InputMaybe<Scalars['Boolean']>;
  calculate_dom?: InputMaybe<Scalars['Boolean']>;
  category_name?: InputMaybe<Scalars['String']>;
  col_name: Scalars['String'];
  col_type?: InputMaybe<ColTypeEnum>;
  compose?: InputMaybe<Scalars['Boolean']>;
  display_name?: InputMaybe<Scalars['String']>;
  draft_attrs?: InputMaybe<Scalars['String']>;
  draft_id?: InputMaybe<Scalars['Int']>;
  field_category_id?: InputMaybe<Scalars['Int']>;
  is_draft?: InputMaybe<Scalars['Boolean']>;
  map_values?: InputMaybe<FieldMapValue>;
  order?: InputMaybe<Scalars['Int']>;
  queryable?: InputMaybe<Scalars['Boolean']>;
  source_names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sqft?: InputMaybe<Scalars['Boolean']>;
  standard_name?: InputMaybe<Scalars['String']>;
  subcategory_name?: InputMaybe<Scalars['String']>;
  suggestions?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateFieldTemplateArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alternate_names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dd_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  field_category_name?: InputMaybe<FieldTemplateFieldCategoryName>;
  field_type: Scalars['String'];
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  raw?: InputMaybe<Scalars['String']>;
  record_type?: InputMaybe<FieldTemplateRecordType>;
};


export type MutationCreateListingServiceArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['String']>;
  default_search?: InputMaybe<Array<InputMaybe<DefaultSearchInput>>>;
  default_search_criteria?: InputMaybe<Scalars['String']>;
  flags?: InputMaybe<Array<SpecialFlagInput>>;
  key: Scalars['String'];
  lat?: InputMaybe<Scalars['Float']>;
  lon?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  reso_ouid?: InputMaybe<Scalars['String']>;
  special_flags?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  time_zone: Scalars['String'];
};


export type MutationCreateLookupArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  field_id?: InputMaybe<Scalars['Int']>;
  mapped_value?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  source_id: Scalars['String'];
  value: Scalars['String'];
};


export type MutationCreateLookupsFromAggsArgs = {
  field_id: Scalars['ID'];
};


export type MutationCreateLookupsFromMetadataArgs = {
  field_id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationCreateServiceAdapterArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  adapter_id?: InputMaybe<Scalars['Int']>;
  listing_service_id?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateStatArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  es_id?: InputMaybe<Scalars['String']>;
  finished_at?: InputMaybe<Scalars['String']>;
  job?: InputMaybe<StatJob>;
  locked_at?: InputMaybe<Scalars['String']>;
  locked_by?: InputMaybe<Scalars['String']>;
  log_line?: InputMaybe<Scalars['String']>;
  queued_at?: InputMaybe<Scalars['String']>;
  started_at?: InputMaybe<Scalars['String']>;
  statable_id?: InputMaybe<Scalars['Int']>;
  statable_type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StatStatus>;
  took?: InputMaybe<Scalars['Float']>;
  total_records?: InputMaybe<Scalars['Int']>;
};


export type MutationCreateTransformArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  field_id?: InputMaybe<Scalars['Int']>;
  operation?: InputMaybe<OperationEnum>;
  order?: InputMaybe<Scalars['Int']>;
  serialize_only?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDeleteActivationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAdapterArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAdminArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAlarmProfileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAllLookupsArgs = {
  field_id: Scalars['ID'];
};


export type MutationDeleteApiUserArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDefaultCriteriumArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFieldArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFieldTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteListingServiceArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteLookupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRecordArgs = {
  record_id: Scalars['ID'];
  resource_group_id: Scalars['ID'];
};


export type MutationDeleteResourceArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteResourceGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSavedSearchArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteServiceAdapterArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTransformArgs = {
  id: Scalars['ID'];
};


export type MutationImportMetadataArgs = {
  adapter_id: Scalars['ID'];
  class_names?: InputMaybe<Array<Scalars['String']>>;
  resource_name: Scalars['String'];
  role: ResourceGroupRole;
};


export type MutationIndexAllSuggestionsArgs = {
  id: Scalars['ID'];
};


export type MutationInit_ExportArgs = {
  key: Scalars['ID'];
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationPurgeDeletesArgs = {
  resource_group_id: Scalars['ID'];
};


export type MutationReRegisterSavedSearchArgs = {
  id: Scalars['Int'];
  raw_criteria: Scalars['String'];
};


export type MutationReRegisterSavedSearchesArgs = {
  id: Scalars['Int'];
};


export type MutationReorderLookupsArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationReorderTransformsArgs = {
  ids: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  password_confirmation: Scalars['String'];
  reset_token: Scalars['String'];
};


export type MutationResumePopulateResourceArgs = {
  stat_id: Scalars['ID'];
};


export type MutationStartPopulateArgs = {
  filters?: InputMaybe<Array<PopulateFilterType>>;
  resource_id?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['String']>;
};


export type MutationTransformPipelineArgs = {
  field_id: Scalars['ID'];
  raw_source?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateActivationArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  api_user_id?: InputMaybe<Scalars['Int']>;
  disabled_at?: InputMaybe<Scalars['String']>;
  enabled_at?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  listing_service_id?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ActivationStatus>;
  warnings?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationUpdateAdapterArgs = {
  absolute_lon?: InputMaybe<Scalars['Boolean']>;
  action_type?: InputMaybe<Scalars['String']>;
  adapter_type?: InputMaybe<AdapterAdapterType>;
  audience?: InputMaybe<Scalars['String']>;
  auth_endpoint?: InputMaybe<Scalars['String']>;
  current_task?: InputMaybe<Scalars['Int']>;
  es_status?: InputMaybe<AdapterEsStatus>;
  es_version?: InputMaybe<Scalars['Int']>;
  grant_type?: InputMaybe<AdapterGrantType>;
  id: Scalars['ID'];
  is_paused?: InputMaybe<Scalars['Boolean']>;
  json_token_fetch?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  mongo_cluster?: InputMaybe<AdapterMongoCluster>;
  no_pagination?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  replication_prefix?: InputMaybe<Scalars['Boolean']>;
  request_time_zone?: InputMaybe<Scalars['String']>;
  resource_basic_auth?: InputMaybe<Scalars['Boolean']>;
  response_time_zone?: InputMaybe<Scalars['String']>;
  rets_version?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<AdapterService>;
  single_login?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<AdapterStatus>;
  update_dom?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
  use_jwt_auth?: InputMaybe<Scalars['Boolean']>;
  use_replication_endpoint?: InputMaybe<Scalars['Boolean']>;
  user_agent?: InputMaybe<Scalars['String']>;
  user_agent_password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  vendor?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateAdminArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  alerts?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  last_login?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  password_confirmation?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  reset_token?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<AdminRole>;
  signup_token?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateAlarmArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  alarm_profile_id?: InputMaybe<Scalars['Int']>;
  alarmable_id?: InputMaybe<Scalars['Int']>;
  alarmable_type?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  cleared_at?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type MutationUpdateAlarmProfileArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  adapter_id?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['Int']>;
  field?: InputMaybe<AlarmProfileField>;
  id: Scalars['ID'];
  job?: InputMaybe<AlarmProfileJob>;
  job_status?: InputMaybe<AlarmProfileJobStatus>;
  max_threshold?: InputMaybe<Scalars['Int']>;
  min_threshold?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  operation?: InputMaybe<AlarmProfileOperation>;
  role?: InputMaybe<AlarmProfileRole>;
  status?: InputMaybe<AlarmProfileStatus>;
};


export type MutationUpdateApiUserArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  api_key?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<ApiUserEnvironment>;
  forge_api?: InputMaybe<Scalars['Boolean']>;
  full_access?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lwa_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  percolator_endpoint?: InputMaybe<Scalars['String']>;
  percolator_notifications?: InputMaybe<ApiUserPercolatorNotification>;
  replication?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateDefaultCriteriumArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  cas_criterium?: InputMaybe<Scalars['Boolean']>;
  field_name?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  parent_id?: InputMaybe<Scalars['Int']>;
  parent_type?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateFieldArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  agent_only?: InputMaybe<Scalars['Boolean']>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  autocomplete?: InputMaybe<Scalars['Boolean']>;
  calculate_dom?: InputMaybe<Scalars['Boolean']>;
  category_name?: InputMaybe<Scalars['String']>;
  col_name?: InputMaybe<Scalars['String']>;
  col_type?: InputMaybe<ColTypeEnum>;
  compose?: InputMaybe<Scalars['Boolean']>;
  display_name?: InputMaybe<Scalars['String']>;
  draft_attrs?: InputMaybe<Scalars['String']>;
  draft_id?: InputMaybe<Scalars['Int']>;
  field_category_id?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  is_draft?: InputMaybe<Scalars['Boolean']>;
  map_values?: InputMaybe<FieldMapValue>;
  order?: InputMaybe<Scalars['Int']>;
  queryable?: InputMaybe<Scalars['Boolean']>;
  source_names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sqft?: InputMaybe<Scalars['Boolean']>;
  standard_name?: InputMaybe<Scalars['String']>;
  subcategory_name?: InputMaybe<Scalars['String']>;
  suggestions?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateFieldTemplateArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  alternate_names?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  dd_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  field_category_name?: InputMaybe<FieldTemplateFieldCategoryName>;
  field_type?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  raw?: InputMaybe<Scalars['String']>;
  record_type?: InputMaybe<FieldTemplateRecordType>;
};


export type MutationUpdateListingServiceArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['String']>;
  default_search?: InputMaybe<Array<InputMaybe<DefaultSearchInput>>>;
  default_search_criteria?: InputMaybe<Scalars['String']>;
  flags?: InputMaybe<Array<SpecialFlagInput>>;
  id: Scalars['ID'];
  key?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lon?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  reso_ouid?: InputMaybe<Scalars['String']>;
  special_flags?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  time_zone?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateLookupArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  field_id?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  mapped_value?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  source_id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateResourceArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  latest_audit?: InputMaybe<Scalars['String']>;
  latest_monthly_audit?: InputMaybe<Scalars['String']>;
  latest_update?: InputMaybe<Scalars['String']>;
  latest_weekly_audit?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  resource_group_id?: InputMaybe<Scalars['Int']>;
  source_class?: InputMaybe<Scalars['String']>;
  source_type?: InputMaybe<Scalars['String']>;
  update_data?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateResourceGroupArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  adapter_id?: InputMaybe<Scalars['Int']>;
  audit_data?: InputMaybe<Scalars['Boolean']>;
  audit_window?: InputMaybe<Scalars['Int']>;
  dom_calculation_v2?: InputMaybe<Scalars['Boolean']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  filter_photo_urls?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  index_data?: InputMaybe<Scalars['Boolean']>;
  latest_reverse_audit?: InputMaybe<Scalars['String']>;
  mapping_current?: InputMaybe<Scalars['Boolean']>;
  page_size?: InputMaybe<Scalars['Int']>;
  pending_change?: InputMaybe<Scalars['Boolean']>;
  percolate_delay?: InputMaybe<Scalars['Int']>;
  photo_settings?: InputMaybe<PhotoSettingsInput>;
  photo_strategy?: InputMaybe<ResourceGroupPhotoStrategy>;
  photos_updated_at_field?: InputMaybe<Scalars['String']>;
  populate_date_field?: InputMaybe<Scalars['String']>;
  preserve_photos?: InputMaybe<Scalars['Boolean']>;
  purge_listings_automatically?: InputMaybe<Scalars['Boolean']>;
  replication?: InputMaybe<Scalars['Boolean']>;
  reverse_audit_count?: InputMaybe<Scalars['Int']>;
  reverse_audit_interval?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<ResourceGroupRole>;
  search_data?: InputMaybe<Scalars['Boolean']>;
  skip_photos?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ResourceGroupStatus>;
  track_fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  uid?: InputMaybe<Scalars['String']>;
  unique_id_field?: InputMaybe<Scalars['String']>;
  update_window?: InputMaybe<Scalars['Int']>;
  updated_at_field?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateSavedSearchArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  api_user_id?: InputMaybe<Scalars['Int']>;
  external_id?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  last_match_at?: InputMaybe<Scalars['String']>;
  listing_service_id?: InputMaybe<Scalars['Int']>;
  raw_criteria?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateStatArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  es_id?: InputMaybe<Scalars['String']>;
  finished_at?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  job?: InputMaybe<StatJob>;
  locked_at?: InputMaybe<Scalars['String']>;
  locked_by?: InputMaybe<Scalars['String']>;
  log_line?: InputMaybe<Scalars['String']>;
  queued_at?: InputMaybe<Scalars['String']>;
  started_at?: InputMaybe<Scalars['String']>;
  statable_id?: InputMaybe<Scalars['Int']>;
  statable_type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StatStatus>;
  took?: InputMaybe<Scalars['Float']>;
  total_records?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateTransformArgs = {
  action_type?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  field_id?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  operation?: InputMaybe<OperationEnum>;
  order?: InputMaybe<Scalars['Int']>;
  serialize_only?: InputMaybe<Scalars['Boolean']>;
};

export type OfficeList = {
  OfficeAddress1?: Maybe<Scalars['String']>;
  OfficeAddress2?: Maybe<Scalars['String']>;
  OfficeCity?: Maybe<Scalars['String']>;
  OfficeCorporateLicense?: Maybe<Scalars['String']>;
  OfficeFax?: Maybe<Scalars['String']>;
  OfficePostalCode?: Maybe<Scalars['String']>;
  OfficePostalCodePlus4?: Maybe<Scalars['String']>;
  OfficeStateOrProvince?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type OfficeResultType = {
  OfficeAddress1?: Maybe<Scalars['String']>;
  OfficeAddress2?: Maybe<Scalars['String']>;
  OfficeCity?: Maybe<Scalars['String']>;
  OfficeCorporateLicense?: Maybe<Scalars['String']>;
  OfficeFax?: Maybe<Scalars['String']>;
  OfficePostalCode?: Maybe<Scalars['String']>;
  OfficePostalCodePlus4?: Maybe<Scalars['String']>;
  OfficeStateOrProvince?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  office_id?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  raw?: Maybe<Scalars['String']>;
  raw_data?: Maybe<RawData>;
  updated_at?: Maybe<Scalars['String']>;
  wr_fetched_at?: Maybe<Scalars['String']>;
  wr_resource_id?: Maybe<Scalars['Int']>;
};

export type OfficeSearch = {
  count?: Maybe<Scalars['Int']>;
  explain?: Maybe<Scalars['String']>;
  results?: Maybe<Array<OfficeResultType>>;
};

export type OfficeSell = {
  OfficeAddress1?: Maybe<Scalars['String']>;
  OfficeAddress2?: Maybe<Scalars['String']>;
  OfficeCity?: Maybe<Scalars['String']>;
  OfficeCorporateLicense?: Maybe<Scalars['String']>;
  OfficeFax?: Maybe<Scalars['String']>;
  OfficePostalCode?: Maybe<Scalars['String']>;
  OfficePostalCodePlus4?: Maybe<Scalars['String']>;
  OfficeStateOrProvince?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export enum OperationEnum {
  AcresToSqft = 'acres_to_sqft',
  CalculateDom = 'calculate_dom',
  CalculateFloat = 'calculate_float',
  CheckValue = 'check_value',
  Condition = 'condition',
  ConditionLiteral = 'condition_literal',
  DelimitedJoin = 'delimited_join',
  DropWord = 'drop_word',
  ForceEncoding = 'force_encoding',
  GeoPoint = 'geo_point',
  GeoShape = 'geo_shape',
  Join = 'join',
  MapValue = 'map_value',
  Prepend = 'prepend',
  PriceSold = 'price_sold',
  RemoteField = 'remote_field',
  RetsObject = 'rets_object',
  SetTimestamp = 'set_timestamp',
  SplitZipcode = 'split_zipcode',
  SqftToAcre = 'sqft_to_acre',
  Static = 'static',
  Strip = 'strip',
  Sum = 'sum',
  Titleize = 'titleize'
}

/** Generated programmatically from model: Ownership */
export type Ownership = {
  admin_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ownable_id?: Maybe<Scalars['Int']>;
  ownable_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type PhotoSettings = {
  listing_id_field?: Maybe<Scalars['String']>;
  object_type?: Maybe<Scalars['String']>;
  order_field?: Maybe<Scalars['String']>;
  photos_count_field?: Maybe<Scalars['String']>;
  photos_updated_at_field?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['String']>;
  url_field?: Maybe<Scalars['String']>;
};

export type PhotoSettingsInput = {
  expand_media?: InputMaybe<Scalars['String']>;
  /** photo resource strategy */
  listing_id_field?: InputMaybe<Scalars['String']>;
  /** get object / download strategy */
  object_type?: InputMaybe<Scalars['String']>;
  /** photo resource strategy */
  order_field?: InputMaybe<Scalars['String']>;
  /** download strategy */
  photos_count_field?: InputMaybe<Scalars['String']>;
  /** download strategy */
  photos_updated_at_field?: InputMaybe<Scalars['String']>;
  /** get object / download strategy */
  resource?: InputMaybe<Scalars['String']>;
  /** photo resource strategy */
  resource_id?: InputMaybe<Scalars['String']>;
  /** photo resource strategy */
  url_field?: InputMaybe<Scalars['String']>;
};

export type PopulateFilterType = {
  field?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type PossibleSource = {
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ProximityFilterType = {
  distance?: InputMaybe<Scalars['String']>;
  lat: Scalars['String'];
  lon: Scalars['String'];
};

export type Query = {
  adapter?: Maybe<Adapter>;
  adapters?: Maybe<Array<Adapter>>;
  admin?: Maybe<Admin>;
  admins?: Maybe<Array<Admin>>;
  alarm?: Maybe<Alarm>;
  alarm_profile?: Maybe<AlarmProfile>;
  alarm_profiles?: Maybe<Array<AlarmProfile>>;
  alarms?: Maybe<Array<Alarm>>;
  all_flag_names?: Maybe<Array<Scalars['String']>>;
  api_user?: Maybe<ApiUser>;
  api_users?: Maybe<Array<ApiUser>>;
  collections_counts?: Maybe<Scalars['JSON']>;
  current_admin?: Maybe<Admin>;
  default_criteria?: Maybe<Array<DefaultCriterium>>;
  default_criterium?: Maybe<DefaultCriterium>;
  default_schema?: Maybe<Array<DefaultSchemaField>>;
  field?: Maybe<Field>;
  field_template?: Maybe<FieldTemplate>;
  field_templates?: Maybe<Array<FieldTemplate>>;
  fields?: Maybe<Array<Field>>;
  global_counts?: Maybe<GlobalCounts>;
  listing_service?: Maybe<ListingService>;
  listing_services?: Maybe<Array<ListingService>>;
  modification_timestamps?: Maybe<ModificationTimestamp>;
  resource?: Maybe<Resource>;
  resource_group?: Maybe<ResourceGroup>;
  resource_groups?: Maybe<Array<ResourceGroup>>;
  resources?: Maybe<Array<Resource>>;
  saved_search?: Maybe<SavedSearch>;
  saved_searches?: Maybe<Array<SavedSearch>>;
  search_adapters?: Maybe<Array<Adapter>>;
  stat?: Maybe<Stat>;
  stats?: Maybe<Array<Stat>>;
  stats_by_hour?: Maybe<Scalars['JSON']>;
  time_zones?: Maybe<Array<Scalars['String']>>;
};


export type QueryAdapterArgs = {
  absolute_lon?: InputMaybe<Scalars['Boolean']>;
  adapter_type?: InputMaybe<AdapterAdapterType>;
  audience?: InputMaybe<Scalars['String']>;
  auth_endpoint?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  current_task?: InputMaybe<Scalars['Int']>;
  es_status?: InputMaybe<AdapterEsStatus>;
  es_version?: InputMaybe<Scalars['Int']>;
  grant_type?: InputMaybe<AdapterGrantType>;
  id?: InputMaybe<Scalars['ID']>;
  is_paused?: InputMaybe<Scalars['Boolean']>;
  json_token_fetch?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  mongo_cluster?: InputMaybe<AdapterMongoCluster>;
  no_pagination?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  replication_prefix?: InputMaybe<Scalars['Boolean']>;
  request_time_zone?: InputMaybe<Scalars['String']>;
  resource_basic_auth?: InputMaybe<Scalars['Boolean']>;
  response_time_zone?: InputMaybe<Scalars['String']>;
  rets_version?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<AdapterService>;
  single_login?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<AdapterStatus>;
  update_dom?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  use_jwt_auth?: InputMaybe<Scalars['Boolean']>;
  use_replication_endpoint?: InputMaybe<Scalars['Boolean']>;
  user_agent?: InputMaybe<Scalars['String']>;
  user_agent_password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  vendor?: InputMaybe<Scalars['String']>;
};


export type QueryAdaptersArgs = {
  absolute_lon?: InputMaybe<Scalars['Boolean']>;
  adapter_type?: InputMaybe<AdapterAdapterType>;
  audience?: InputMaybe<Scalars['String']>;
  auth_endpoint?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  current_task?: InputMaybe<Scalars['Int']>;
  es_status?: InputMaybe<AdapterEsStatus>;
  es_version?: InputMaybe<Scalars['Int']>;
  grant_type?: InputMaybe<AdapterGrantType>;
  id?: InputMaybe<Scalars['ID']>;
  is_paused?: InputMaybe<Scalars['Boolean']>;
  json_token_fetch?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  mongo_cluster?: InputMaybe<AdapterMongoCluster>;
  no_pagination?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  password?: InputMaybe<Scalars['String']>;
  replication_prefix?: InputMaybe<Scalars['Boolean']>;
  request_time_zone?: InputMaybe<Scalars['String']>;
  resource_basic_auth?: InputMaybe<Scalars['Boolean']>;
  response_time_zone?: InputMaybe<Scalars['String']>;
  rets_version?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  service?: InputMaybe<AdapterService>;
  single_login?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<QuerySortType>;
  status?: InputMaybe<AdapterStatus>;
  update_dom?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  use_jwt_auth?: InputMaybe<Scalars['Boolean']>;
  use_replication_endpoint?: InputMaybe<Scalars['Boolean']>;
  user_agent?: InputMaybe<Scalars['String']>;
  user_agent_password?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  vendor?: InputMaybe<Scalars['String']>;
};


export type QueryAdminArgs = {
  alerts?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  last_login?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  password_digest?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  reset_token?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<AdminRole>;
  signup_token?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QueryAdminsArgs = {
  alerts?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  last_login?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  password_digest?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  reset_token?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<AdminRole>;
  signup_token?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<QuerySortType>;
  timezone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QueryAlarmArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  alarm_profile_id?: InputMaybe<Scalars['Int']>;
  alarmable_id?: InputMaybe<Scalars['Int']>;
  alarmable_type?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  cleared_at?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QueryAlarm_ProfileArgs = {
  adapter_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  field?: InputMaybe<AlarmProfileField>;
  id?: InputMaybe<Scalars['ID']>;
  job?: InputMaybe<AlarmProfileJob>;
  job_status?: InputMaybe<AlarmProfileJobStatus>;
  max_threshold?: InputMaybe<Scalars['Int']>;
  min_threshold?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  operation?: InputMaybe<AlarmProfileOperation>;
  role?: InputMaybe<AlarmProfileRole>;
  status?: InputMaybe<AlarmProfileStatus>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QueryAlarm_ProfilesArgs = {
  adapter_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  field?: InputMaybe<AlarmProfileField>;
  id?: InputMaybe<Scalars['ID']>;
  job?: InputMaybe<AlarmProfileJob>;
  job_status?: InputMaybe<AlarmProfileJobStatus>;
  limit?: InputMaybe<Scalars['Int']>;
  max_threshold?: InputMaybe<Scalars['Int']>;
  min_threshold?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  operation?: InputMaybe<AlarmProfileOperation>;
  page?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<AlarmProfileRole>;
  sort?: InputMaybe<QuerySortType>;
  status?: InputMaybe<AlarmProfileStatus>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QueryAlarmsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  alarm_profile_id?: InputMaybe<Scalars['Int']>;
  alarmable_id?: InputMaybe<Scalars['Int']>;
  alarmable_type?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  cleared_at?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QueryApi_UserArgs = {
  api_key?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<ApiUserEnvironment>;
  forge_api?: InputMaybe<Scalars['Boolean']>;
  full_access?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  lwa_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  password_digest?: InputMaybe<Scalars['String']>;
  percolator_endpoint?: InputMaybe<Scalars['String']>;
  percolator_notifications?: InputMaybe<ApiUserPercolatorNotification>;
  replication?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QueryApi_UsersArgs = {
  api_key?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<ApiUserEnvironment>;
  forge_api?: InputMaybe<Scalars['Boolean']>;
  full_access?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  lwa_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  password_digest?: InputMaybe<Scalars['String']>;
  percolator_endpoint?: InputMaybe<Scalars['String']>;
  percolator_notifications?: InputMaybe<ApiUserPercolatorNotification>;
  replication?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QueryDefault_CriteriaArgs = {
  cas_criterium?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['String']>;
  field_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  parent_id?: InputMaybe<Scalars['Int']>;
  parent_type?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};


export type QueryDefault_CriteriumArgs = {
  cas_criterium?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['String']>;
  field_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  parent_id?: InputMaybe<Scalars['Int']>;
  parent_type?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};


export type QueryDefault_SchemaArgs = {
  role?: InputMaybe<ResourceGroupRole>;
};


export type QueryFieldArgs = {
  agent_only?: InputMaybe<Scalars['Boolean']>;
  aliases?: InputMaybe<Array<Scalars['String']>>;
  autocomplete?: InputMaybe<Scalars['Boolean']>;
  calculate_dom?: InputMaybe<Scalars['Boolean']>;
  category_name?: InputMaybe<Scalars['String']>;
  col_name?: InputMaybe<Scalars['String']>;
  col_type?: InputMaybe<Scalars['String']>;
  compose?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  draft_attrs?: InputMaybe<Scalars['String']>;
  draft_id?: InputMaybe<Scalars['Int']>;
  field_category_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  is_draft?: InputMaybe<Scalars['Boolean']>;
  map_values?: InputMaybe<FieldMapValue>;
  order?: InputMaybe<Scalars['Int']>;
  queryable?: InputMaybe<Scalars['Boolean']>;
  source_names?: InputMaybe<Array<Scalars['String']>>;
  sqft?: InputMaybe<Scalars['Boolean']>;
  standard_name?: InputMaybe<Scalars['String']>;
  subcategory_name?: InputMaybe<Scalars['String']>;
  suggestions?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QueryField_TemplateArgs = {
  aliases?: InputMaybe<Array<Scalars['String']>>;
  alternate_names?: InputMaybe<Array<Scalars['String']>>;
  created_at?: InputMaybe<Scalars['String']>;
  dd_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  field_category_name?: InputMaybe<FieldTemplateFieldCategoryName>;
  field_type?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  raw?: InputMaybe<Scalars['String']>;
  record_type?: InputMaybe<FieldTemplateRecordType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QueryField_TemplatesArgs = {
  aliases?: InputMaybe<Array<Scalars['String']>>;
  alternate_names?: InputMaybe<Array<Scalars['String']>>;
  created_at?: InputMaybe<Scalars['String']>;
  dd_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  field_category_name?: InputMaybe<FieldTemplateFieldCategoryName>;
  field_type?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  raw?: InputMaybe<Scalars['String']>;
  record_type?: InputMaybe<FieldTemplateRecordType>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QueryFieldsArgs = {
  agent_only?: InputMaybe<Scalars['Boolean']>;
  aliases?: InputMaybe<Array<Scalars['String']>>;
  autocomplete?: InputMaybe<Scalars['Boolean']>;
  calculate_dom?: InputMaybe<Scalars['Boolean']>;
  category_name?: InputMaybe<Scalars['String']>;
  col_name?: InputMaybe<Scalars['String']>;
  col_type?: InputMaybe<Scalars['String']>;
  compose?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  draft_attrs?: InputMaybe<Scalars['String']>;
  draft_id?: InputMaybe<Scalars['Int']>;
  field_category_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  is_draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  map_values?: InputMaybe<FieldMapValue>;
  order?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  queryable?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<QuerySortType>;
  source_names?: InputMaybe<Array<Scalars['String']>>;
  sqft?: InputMaybe<Scalars['Boolean']>;
  standard_name?: InputMaybe<Scalars['String']>;
  subcategory_name?: InputMaybe<Scalars['String']>;
  suggestions?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QueryListing_ServiceArgs = {
  address?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  default_search_criteria?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lon?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  reso_ouid?: InputMaybe<Scalars['String']>;
  special_flags?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Array<Scalars['String']>>;
  time_zone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QueryListing_ServicesArgs = {
  address?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['String']>;
  default_search_criteria?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  key?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  limit?: InputMaybe<Scalars['Int']>;
  lon?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  reso_ouid?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<QuerySortType>;
  special_flags?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Array<Scalars['String']>>;
  time_zone?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QueryModification_TimestampsArgs = {
  id: Scalars['ID'];
};


export type QueryResourceArgs = {
  created_at?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  latest_audit?: InputMaybe<Scalars['String']>;
  latest_monthly_audit?: InputMaybe<Scalars['String']>;
  latest_update?: InputMaybe<Scalars['String']>;
  latest_weekly_audit?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  resource_group_id?: InputMaybe<Scalars['Int']>;
  source_class?: InputMaybe<Scalars['String']>;
  source_type?: InputMaybe<Scalars['String']>;
  update_data?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QueryResource_GroupArgs = {
  adapter_id?: InputMaybe<Scalars['Int']>;
  audit_data?: InputMaybe<Scalars['Boolean']>;
  audit_window?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  dom_calculation_v2?: InputMaybe<Scalars['Boolean']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  filter_photo_urls?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  index_data?: InputMaybe<Scalars['Boolean']>;
  latest_reverse_audit?: InputMaybe<Scalars['String']>;
  mapping_current?: InputMaybe<Scalars['Boolean']>;
  page_size?: InputMaybe<Scalars['Int']>;
  pending_change?: InputMaybe<Scalars['Boolean']>;
  percolate_delay?: InputMaybe<Scalars['Int']>;
  photo_settings?: InputMaybe<Scalars['String']>;
  photo_strategy?: InputMaybe<ResourceGroupPhotoStrategy>;
  photos_updated_at_field?: InputMaybe<Scalars['String']>;
  populate_date_field?: InputMaybe<Scalars['String']>;
  preserve_photos?: InputMaybe<Scalars['Boolean']>;
  purge_listings_automatically?: InputMaybe<Scalars['Boolean']>;
  replication?: InputMaybe<Scalars['Boolean']>;
  reverse_audit_count?: InputMaybe<Scalars['Int']>;
  reverse_audit_interval?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<ResourceGroupRole>;
  search_data?: InputMaybe<Scalars['Boolean']>;
  skip_photos?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ResourceGroupStatus>;
  track_fields?: InputMaybe<Array<Scalars['String']>>;
  uid?: InputMaybe<Scalars['String']>;
  unique_id_field?: InputMaybe<Scalars['String']>;
  update_window?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['String']>;
  updated_at_field?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryResource_GroupsArgs = {
  adapter_id?: InputMaybe<Scalars['Int']>;
  audit_data?: InputMaybe<Scalars['Boolean']>;
  audit_window?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  dom_calculation_v2?: InputMaybe<Scalars['Boolean']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  filter_photo_urls?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  index_data?: InputMaybe<Scalars['Boolean']>;
  latest_reverse_audit?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  mapping_current?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  page_size?: InputMaybe<Scalars['Int']>;
  pending_change?: InputMaybe<Scalars['Boolean']>;
  percolate_delay?: InputMaybe<Scalars['Int']>;
  photo_settings?: InputMaybe<Scalars['String']>;
  photo_strategy?: InputMaybe<ResourceGroupPhotoStrategy>;
  photos_updated_at_field?: InputMaybe<Scalars['String']>;
  populate_date_field?: InputMaybe<Scalars['String']>;
  preserve_photos?: InputMaybe<Scalars['Boolean']>;
  purge_listings_automatically?: InputMaybe<Scalars['Boolean']>;
  replication?: InputMaybe<Scalars['Boolean']>;
  reverse_audit_count?: InputMaybe<Scalars['Int']>;
  reverse_audit_interval?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<ResourceGroupRole>;
  search_data?: InputMaybe<Scalars['Boolean']>;
  skip_photos?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<QuerySortType>;
  status?: InputMaybe<ResourceGroupStatus>;
  track_fields?: InputMaybe<Array<Scalars['String']>>;
  uid?: InputMaybe<Scalars['String']>;
  unique_id_field?: InputMaybe<Scalars['String']>;
  update_window?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['String']>;
  updated_at_field?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};


export type QueryResourcesArgs = {
  created_at?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  latest_audit?: InputMaybe<Scalars['String']>;
  latest_monthly_audit?: InputMaybe<Scalars['String']>;
  latest_update?: InputMaybe<Scalars['String']>;
  latest_weekly_audit?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  resource_group_id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  source_class?: InputMaybe<Scalars['String']>;
  source_type?: InputMaybe<Scalars['String']>;
  update_data?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QuerySaved_SearchArgs = {
  api_user_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last_match_at?: InputMaybe<Scalars['String']>;
  listing_service_id?: InputMaybe<Scalars['Int']>;
  raw_criteria?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QuerySaved_SearchesArgs = {
  api_user_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  external_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last_match_at?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  listing_service_id?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  raw_criteria?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QuerySearch_AdaptersArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryStatArgs = {
  created_at?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  es_id?: InputMaybe<Scalars['String']>;
  finished_at?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  job?: InputMaybe<StatJob>;
  locked_at?: InputMaybe<Scalars['String']>;
  locked_by?: InputMaybe<Scalars['String']>;
  log_line?: InputMaybe<Scalars['String']>;
  queued_at?: InputMaybe<Scalars['String']>;
  started_at?: InputMaybe<Scalars['String']>;
  statable_id?: InputMaybe<Scalars['Int']>;
  statable_type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StatStatus>;
  took?: InputMaybe<Scalars['Float']>;
  total_records?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QueryStatsArgs = {
  created_at?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  es_id?: InputMaybe<Scalars['String']>;
  finished_at?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  job?: InputMaybe<StatJob>;
  limit?: InputMaybe<Scalars['Int']>;
  locked_at?: InputMaybe<Scalars['String']>;
  locked_by?: InputMaybe<Scalars['String']>;
  log_line?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  queued_at?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<QuerySortType>;
  started_at?: InputMaybe<Scalars['String']>;
  statable_id?: InputMaybe<Scalars['Int']>;
  statable_type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StatStatus>;
  took?: InputMaybe<Scalars['Float']>;
  total_records?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


export type QueryStats_By_HourArgs = {
  jobs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QuerySortType = {
  dir?: InputMaybe<SortDirectionEnum>;
  field: Scalars['String'];
};

export type RawData = {
  raw?: Maybe<Scalars['String']>;
  serialized?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of ReRegisterSavedSearch */
export type ReRegisterSavedSearchPayload = {
  results?: Maybe<Scalars['String']>;
  saved_search?: Maybe<SavedSearch>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RecordCounts = {
  agents?: Maybe<Scalars['String']>;
  agents_count?: Maybe<Scalars['Int']>;
  listings?: Maybe<Scalars['String']>;
  listings_count?: Maybe<Scalars['Int']>;
  offices?: Maybe<Scalars['String']>;
  offices_count?: Maybe<Scalars['Int']>;
  today?: Maybe<Scalars['String']>;
  today_count?: Maybe<Scalars['Int']>;
};

/** A union of ListingResult, AgentResult, and OfficeResult */
export type RecordReloadUnion = AgentResultType | ListingResultType | OfficeResultType;

export type RecordReloaderResponse = {
  logs?: Maybe<Scalars['String']>;
  records?: Maybe<Array<RecordReloadUnion>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Generated programmatically from model: Resource */
export type Resource = {
  actions?: Maybe<Array<Action>>;
  created_at?: Maybe<Scalars['String']>;
  current_action?: Maybe<Scalars['String']>;
  debug: ResourceDebugger;
  default_criteria?: Maybe<Array<DefaultCriterium>>;
  health?: Maybe<ResourceHealth>;
  id: Scalars['ID'];
  latest_audit?: Maybe<Scalars['String']>;
  latest_monthly_audit?: Maybe<Scalars['String']>;
  latest_update?: Maybe<Scalars['String']>;
  latest_weekly_audit?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  populate_status?: Maybe<Scalars['String']>;
  recent_audits?: Maybe<Array<Stat>>;
  recent_monthly_audits?: Maybe<Array<Stat>>;
  recent_updates?: Maybe<Array<Stat>>;
  recent_weekly_audits?: Maybe<Array<Stat>>;
  reload_record: RecordReloaderResponse;
  resource_group?: Maybe<ResourceGroup>;
  resource_group_id?: Maybe<Scalars['Int']>;
  sample_data?: Maybe<SampleData>;
  source_class?: Maybe<Scalars['String']>;
  source_type?: Maybe<Scalars['String']>;
  stats?: Maybe<Array<Stat>>;
  update_data?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['String']>;
  updates_by_hour?: Maybe<Scalars['String']>;
};


/** Generated programmatically from model: Resource */
export type ResourceActionsArgs = {
  action?: InputMaybe<Scalars['String']>;
  actionable_id?: InputMaybe<Scalars['Int']>;
  actionable_type?: InputMaybe<Scalars['String']>;
  admin_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: Resource */
export type ResourceDefault_CriteriaArgs = {
  cas_criterium?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['String']>;
  field_name?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  parent_id?: InputMaybe<Scalars['Int']>;
  parent_type?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: Resource */
export type ResourceReload_RecordArgs = {
  record_ids: Array<Scalars['String']>;
};


/** Generated programmatically from model: Resource */
export type ResourceStatsArgs = {
  created_at?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  es_id?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  finished_at?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  job?: InputMaybe<StatJob>;
  limit?: InputMaybe<Scalars['Int']>;
  locked_at?: InputMaybe<Scalars['String']>;
  locked_by?: InputMaybe<Scalars['String']>;
  log_line?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  queued_at?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<QuerySortType>;
  started_at?: InputMaybe<Scalars['String']>;
  statable_id?: InputMaybe<Scalars['Int']>;
  statable_type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StatStatus>;
  took?: InputMaybe<Scalars['Float']>;
  total_records?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['String']>;
};

export type ResourceDebugger = {
  debug_result?: Maybe<ListingResultType>;
  error?: Maybe<ResourceDebuggerError>;
};

export type ResourceDebuggerError = {
  request?: Maybe<Scalars['JSON']>;
  response?: Maybe<Scalars['JSON']>;
};

/** Generated programmatically from model: ResourceGroup */
export type ResourceGroup = {
  actions?: Maybe<Array<Action>>;
  adapter?: Maybe<Adapter>;
  adapter_id?: Maybe<Scalars['Int']>;
  agents?: Maybe<AgentSearch>;
  audit_data?: Maybe<Scalars['Boolean']>;
  audit_window?: Maybe<Scalars['Int']>;
  consumer_groups?: Maybe<Array<ConsumerGroup>>;
  created_at?: Maybe<Scalars['String']>;
  deletes_status?: Maybe<DeletesStatus>;
  dom_calculation_v2?: Maybe<Scalars['Boolean']>;
  draft?: Maybe<Scalars['Boolean']>;
  field_categories?: Maybe<Array<FieldCategory>>;
  fields?: Maybe<Array<Field>>;
  filter_photo_urls?: Maybe<Scalars['Boolean']>;
  health?: Maybe<AdapterHealth>;
  id: Scalars['ID'];
  index_data?: Maybe<Scalars['Boolean']>;
  joins?: Maybe<Array<Join>>;
  latest_reverse_audit?: Maybe<Scalars['String']>;
  listings?: Maybe<ListingSearch>;
  loading_progress?: Maybe<Scalars['String']>;
  mapping_current?: Maybe<Scalars['Boolean']>;
  needs_setup?: Maybe<Scalars['Boolean']>;
  offices?: Maybe<OfficeSearch>;
  page_size?: Maybe<Scalars['Int']>;
  pending_change?: Maybe<Scalars['Boolean']>;
  percolate_delay?: Maybe<Scalars['Int']>;
  photo_settings?: Maybe<PhotoSettings>;
  photo_strategy?: Maybe<ResourceGroupPhotoStrategy>;
  photos_updated_at_field?: Maybe<Scalars['String']>;
  populate_date_field?: Maybe<Scalars['String']>;
  possible_sources?: Maybe<Array<PossibleSource>>;
  preserve_photos?: Maybe<Scalars['Boolean']>;
  purge_listings_automatically?: Maybe<Scalars['Boolean']>;
  raw_records?: Maybe<Array<Scalars['String']>>;
  record_count?: Maybe<Scalars['Int']>;
  replication?: Maybe<Scalars['Boolean']>;
  replication_lag?: Maybe<Scalars['Int']>;
  resources?: Maybe<Array<Resource>>;
  reverse_audit_count?: Maybe<Scalars['Int']>;
  reverse_audit_interval?: Maybe<Scalars['Int']>;
  role?: Maybe<ResourceGroupRole>;
  search_data?: Maybe<Scalars['Boolean']>;
  skip_photos?: Maybe<Scalars['Boolean']>;
  stats?: Maybe<Array<Stat>>;
  status?: Maybe<ResourceGroupStatus>;
  track_fields?: Maybe<Array<Scalars['String']>>;
  uid?: Maybe<Scalars['String']>;
  unique_id_field?: Maybe<Scalars['String']>;
  update_window?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['String']>;
  updated_at_field?: Maybe<Scalars['String']>;
  updates_by_hour?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};


/** Generated programmatically from model: ResourceGroup */
export type ResourceGroupActionsArgs = {
  action?: InputMaybe<Scalars['String']>;
  actionable_id?: InputMaybe<Scalars['Int']>;
  actionable_type?: InputMaybe<Scalars['String']>;
  admin_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ResourceGroup */
export type ResourceGroupAgentsArgs = {
  fields?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<Array<InputMaybe<FilterQueryType>>>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  source?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ResourceGroup */
export type ResourceGroupConsumer_GroupsArgs = {
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  index_name?: InputMaybe<Scalars['String']>;
  latest_offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  resource_group_id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ResourceGroup */
export type ResourceGroupField_CategoriesArgs = {
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  fine_tuning?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  ignored?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nested?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  private?: InputMaybe<Scalars['Boolean']>;
  resource_group_id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ResourceGroup */
export type ResourceGroupFieldsArgs = {
  agent_only?: InputMaybe<Scalars['Boolean']>;
  aliases?: InputMaybe<Scalars['String']>;
  autocomplete?: InputMaybe<Scalars['Boolean']>;
  calculate_dom?: InputMaybe<Scalars['Boolean']>;
  category_name?: InputMaybe<Scalars['String']>;
  col_name?: InputMaybe<Scalars['String']>;
  col_type?: InputMaybe<Scalars['String']>;
  compose?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['String']>;
  display_name?: InputMaybe<Scalars['String']>;
  draft_attrs?: InputMaybe<Scalars['String']>;
  draft_id?: InputMaybe<Scalars['Int']>;
  field_category_id?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  is_draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  map_values?: InputMaybe<FieldMapValue>;
  order?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  queryable?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<QuerySortType>;
  source_names?: InputMaybe<Scalars['String']>;
  sqft?: InputMaybe<Scalars['Boolean']>;
  standard_name?: InputMaybe<Scalars['String']>;
  subcategory_name?: InputMaybe<Scalars['String']>;
  suggestions?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ResourceGroup */
export type ResourceGroupJoinsArgs = {
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  foreign_key?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  join_all?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  prefix_field?: InputMaybe<Scalars['String']>;
  primary_key?: InputMaybe<Scalars['String']>;
  resource_group_id?: InputMaybe<Scalars['Int']>;
  resource_id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  source_class?: InputMaybe<Scalars['String']>;
  source_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ResourceGroup */
export type ResourceGroupListingsArgs = {
  fields?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<Array<InputMaybe<FilterQueryType>>>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  proximity?: InputMaybe<ProximityFilterType>;
  reload?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<QuerySortType>;
  source?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ResourceGroup */
export type ResourceGroupOfficesArgs = {
  fields?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<Array<InputMaybe<FilterQueryType>>>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  source?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ResourceGroup */
export type ResourceGroupRaw_RecordsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


/** Generated programmatically from model: ResourceGroup */
export type ResourceGroupResourcesArgs = {
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  latest_audit?: InputMaybe<Scalars['String']>;
  latest_monthly_audit?: InputMaybe<Scalars['String']>;
  latest_update?: InputMaybe<Scalars['String']>;
  latest_weekly_audit?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  resource_group_id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  source_class?: InputMaybe<Scalars['String']>;
  source_type?: InputMaybe<Scalars['String']>;
  update_data?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['String']>;
};


/** Generated programmatically from model: ResourceGroup */
export type ResourceGroupStatsArgs = {
  created_at?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  es_id?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  finished_at?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  job?: InputMaybe<StatJob>;
  limit?: InputMaybe<Scalars['Int']>;
  locked_at?: InputMaybe<Scalars['String']>;
  locked_by?: InputMaybe<Scalars['String']>;
  log_line?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  queued_at?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<QuerySortType>;
  started_at?: InputMaybe<Scalars['String']>;
  statable_id?: InputMaybe<Scalars['Int']>;
  statable_type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StatStatus>;
  took?: InputMaybe<Scalars['Float']>;
  total_records?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['String']>;
};

/** Generated programmatically */
export enum ResourceGroupPhotoStrategy {
  DownloadPhotos = 'download_photos',
  GetObjectPhotos = 'get_object_photos',
  MlsgridPhotos = 'mlsgrid_photos',
  PhotosResource = 'photos_resource'
}

/** Generated programmatically */
export enum ResourceGroupRole {
  Agent = 'agent',
  Listing = 'listing',
  Office = 'office',
  Photo = 'photo'
}

/** Generated programmatically */
export enum ResourceGroupStatus {
  Draft = 'draft',
  Loading = 'loading',
  Pending = 'pending',
  Stable = 'stable'
}

export type ResourceHealth = {
  audit?: Maybe<Scalars['Int']>;
  audit_resolution?: Maybe<Scalars['Int']>;
  monthly_audit?: Maybe<Scalars['Int']>;
  sync?: Maybe<Scalars['Int']>;
  weekly_audit?: Maybe<Scalars['Int']>;
};

export type SampleData = {
  normalized?: Maybe<Scalars['String']>;
  normalized_draft?: Maybe<Scalars['String']>;
  raw?: Maybe<Scalars['String']>;
  serialized?: Maybe<Scalars['String']>;
  serialized_draft?: Maybe<Scalars['String']>;
  translated?: Maybe<Scalars['String']>;
  translated_draft?: Maybe<Scalars['String']>;
};

/** Generated programmatically from model: SavedSearch */
export type SavedSearch = {
  api_user?: Maybe<ApiUser>;
  api_user_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['String']>;
  external_id?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  last_match_at?: Maybe<Scalars['String']>;
  last_match_at_iso?: Maybe<Scalars['String']>;
  listing_service?: Maybe<ListingService>;
  listing_service_id?: Maybe<Scalars['Int']>;
  match_count?: Maybe<Scalars['Int']>;
  parsed_criteria?: Maybe<Scalars['String']>;
  percolator_query?: Maybe<Scalars['String']>;
  queries?: Maybe<Scalars['String']>;
  raw_criteria?: Maybe<Scalars['String']>;
  search_criteria?: Maybe<Array<SearchCriterium>>;
  updated_at?: Maybe<Scalars['String']>;
};


/** Generated programmatically from model: SavedSearch */
export type SavedSearchSearch_CriteriaArgs = {
  created_at?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  lookups?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  saved_search_id?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type SavedSearchHealth = {
  count?: Maybe<Scalars['Int']>;
  registered_count?: Maybe<Scalars['Int']>;
  unregistered?: Maybe<Array<SavedSearch>>;
};


export type SavedSearchHealthUnregisteredArgs = {
  page?: InputMaybe<Scalars['Int']>;
};

/** Generated programmatically from model: SearchCriterium */
export type SearchCriterium = {
  created_at?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lookups?: Maybe<Array<Scalars['String']>>;
  saved_search?: Maybe<SavedSearch>;
  saved_search_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Generated programmatically from model: ServiceAdapter */
export type ServiceAdapter = {
  actions?: Maybe<Array<Action>>;
  adapter?: Maybe<Adapter>;
  adapter_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  listing_service?: Maybe<ListingService>;
  listing_service_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['String']>;
};


/** Generated programmatically from model: ServiceAdapter */
export type ServiceAdapterActionsArgs = {
  action?: InputMaybe<Scalars['String']>;
  actionable_id?: InputMaybe<Scalars['Int']>;
  actionable_type?: InputMaybe<Scalars['String']>;
  admin_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};

export enum SortDirectionEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export type SpecialFlag = {
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SpecialFlagInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Generated programmatically from model: Stat */
export type Stat = {
  accuracy_rate?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['String']>;
  created_at_iso?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  es_id?: Maybe<Scalars['String']>;
  filters?: Maybe<Scalars['String']>;
  finished_at?: Maybe<Scalars['String']>;
  human_created_ago?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  job?: Maybe<StatJob>;
  json_data?: Maybe<Scalars['String']>;
  locked_at?: Maybe<Scalars['String']>;
  locked_by?: Maybe<Scalars['String']>;
  log_line?: Maybe<Scalars['String']>;
  missed?: Maybe<Scalars['Int']>;
  progress?: Maybe<Scalars['String']>;
  queued_at?: Maybe<Scalars['String']>;
  resolved_rate?: Maybe<Scalars['Int']>;
  started_at?: Maybe<Scalars['String']>;
  statable?: Maybe<StatableUnion>;
  statable_id?: Maybe<Scalars['Int']>;
  statable_type?: Maybe<Scalars['String']>;
  stats?: Maybe<Array<Stat>>;
  status?: Maybe<StatStatus>;
  took?: Maybe<Scalars['Float']>;
  took_human?: Maybe<Scalars['String']>;
  total_records?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['String']>;
  updated_at_iso?: Maybe<Scalars['String']>;
};


/** Generated programmatically from model: Stat */
export type StatStatsArgs = {
  created_at?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  es_id?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  finished_at?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  job?: InputMaybe<StatJob>;
  limit?: InputMaybe<Scalars['Int']>;
  locked_at?: InputMaybe<Scalars['String']>;
  locked_by?: InputMaybe<Scalars['String']>;
  log_line?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  queued_at?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<QuerySortType>;
  started_at?: InputMaybe<Scalars['String']>;
  statable_id?: InputMaybe<Scalars['Int']>;
  statable_type?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StatStatus>;
  took?: InputMaybe<Scalars['Float']>;
  total_records?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['String']>;
};

/** Generated programmatically */
export enum StatJob {
  AdapterAlarmer = 'adapter_alarmer',
  Alarmer = 'alarmer',
  Auditor = 'auditor',
  FactsConsumer = 'facts_consumer',
  FeedDownChecker = 'feed_down_checker',
  FetchGlobalCounts = 'fetch_global_counts',
  IndexCleaner = 'index_cleaner',
  MlsFieldCompiler = 'mls_field_compiler',
  MonthlyAuditor = 'monthly_auditor',
  MoveCollection = 'move_collection',
  Percolator = 'percolator',
  PhotoUploader = 'photo_uploader',
  PopulateDay = 'populate_day',
  Populator = 'populator',
  RecordsConsumer = 'records_consumer',
  RecordsDeleter = 'records_deleter',
  Recovery = 'recovery',
  ReindexConsumer = 'reindex_consumer',
  ReplicationConsumer = 'replication_consumer',
  RescheduleReadyJobs = 'reschedule_ready_jobs',
  RetsFeedImport = 'rets_feed_import',
  ReverseAuditResolver = 'reverse_audit_resolver',
  ReverseAuditor = 'reverse_auditor',
  SavedSearchConsumer = 'saved_search_consumer',
  StatPruner = 'stat_pruner',
  UpdateDom = 'update_dom',
  Updater = 'updater',
  UpdatesConsumer = 'updates_consumer',
  WeeklyAuditor = 'weekly_auditor'
}

/** Generated programmatically */
export enum StatStatus {
  Error = 'error',
  Failed = 'failed',
  FinishedWithErrors = 'finished_with_errors',
  Hold = 'hold',
  InProgress = 'in_progress',
  Ready = 'ready',
  Stopped = 'stopped',
  Success = 'success',
  TooManyAttempts = 'too_many_attempts',
  Unresolved = 'unresolved'
}

export type StatableUnion = Adapter | Resource | ResourceGroup | Stat;

export type StatusMapping = {
  active?: Maybe<Array<Scalars['String']>>;
  backup?: Maybe<Array<Scalars['String']>>;
  closed?: Maybe<Array<Scalars['String']>>;
  pending?: Maybe<Array<Scalars['String']>>;
  sold?: Maybe<Array<Scalars['String']>>;
};

export type Subscription = {
  /** The latest info for adapters */
  adapters_updated?: Maybe<Array<Adapter>>;
  /** A stat was created or updated */
  stat_updated?: Maybe<Stat>;
};

/** Generated programmatically from model: Transform */
export type Transform = {
  actions?: Maybe<Array<Action>>;
  created_at?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  field?: Maybe<Field>;
  field_id?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  operation?: Maybe<OperationEnum>;
  order?: Maybe<Scalars['Int']>;
  serialize_only?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['String']>;
};


/** Generated programmatically from model: Transform */
export type TransformActionsArgs = {
  action?: InputMaybe<Scalars['String']>;
  actionable_id?: InputMaybe<Scalars['Int']>;
  actionable_type?: InputMaybe<Scalars['String']>;
  admin_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<Array<FilterCriteria>>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  updated_at?: InputMaybe<Scalars['String']>;
};

export type TransformPipelineResult = {
  final_output?: Maybe<Scalars['String']>;
  raw_source?: Maybe<Scalars['String']>;
  steps?: Maybe<Array<TransformPipelineStep>>;
};

export type TransformPipelineStep = {
  file?: Maybe<Scalars['String']>;
  input?: Maybe<Scalars['String']>;
  output?: Maybe<Scalars['String']>;
};

export type DefaultSchemaPartsFragment = { path?: string | null, colName?: string | null, colType?: string | null, standardName?: string | null };

export type DefaultSchemaQueryVariables = Exact<{
  role?: InputMaybe<ResourceGroupRole>;
}>;


export type DefaultSchemaQuery = { defaultSchema?: Array<{ path?: string | null, colName?: string | null, colType?: string | null, standardName?: string | null }> | null };

export type MetadataResourceFieldsFragment = { name?: string | null, objects?: Array<{ name?: string | null, description?: string | null }> | null, classes?: Array<{ name?: string | null, fields?: any | null }> | null };

export type AdapterFieldsFragment = { id: string, key?: string | null, url?: string | null, username?: string | null, password?: string | null, status?: AdapterStatus | null, scope?: string | null, adapterType?: AdapterAdapterType | null, retsVersion?: string | null, grantType?: AdapterGrantType | null, userAgent?: string | null, userAgentPassword?: string | null, requestTimeZone?: string | null, responseTimeZone?: string | null, currentJob?: string | null, authEndpoint?: string | null, updateDom?: boolean | null, esVersion?: number | null, esStatus?: AdapterEsStatus | null, useJwtAuth?: boolean | null, resourceBasicAuth?: boolean | null, useReplicationEndpoint?: boolean | null, replicationPrefix?: boolean | null, recordCounts?: { today?: string | null, listings?: string | null, agents?: string | null, offices?: string | null } | null };

export type MetadataFieldsFragment = { logs?: string | null, systemInfo?: { connected?: boolean | null, date?: string | null, version?: string | null, systemDescription?: string | null, systemId?: string | null, timezoneOffset?: string | null } | null, resources?: Array<{ name?: string | null, objects?: Array<{ name?: string | null, description?: string | null }> | null, classes?: Array<{ name?: string | null, fields?: any | null }> | null }> | null };

export type AdapterQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type AdapterQuery = { adapter?: { id: string, key?: string | null, url?: string | null, username?: string | null, password?: string | null, status?: AdapterStatus | null, scope?: string | null, updatesByHour?: string | null, adapterType?: AdapterAdapterType | null, retsVersion?: string | null, grantType?: AdapterGrantType | null, userAgent?: string | null, userAgentPassword?: string | null, requestTimeZone?: string | null, responseTimeZone?: string | null, currentJob?: string | null, authEndpoint?: string | null, updateDom?: boolean | null, esVersion?: number | null, esStatus?: AdapterEsStatus | null, useJwtAuth?: boolean | null, resourceBasicAuth?: boolean | null, useReplicationEndpoint?: boolean | null, replicationPrefix?: boolean | null, alarms?: Array<{ id: string, description?: string | null, createdAtIso?: string | null }> | null, resourceGroups?: Array<{ id: string, role?: ResourceGroupRole | null, status?: ResourceGroupStatus | null, indexData?: boolean | null }> | null, resources?: Array<{ id: string, name?: string | null }> | null, listingServices?: Array<{ id: string, key?: string | null, name?: string | null, address?: string | null, lat?: number | null, lon?: number | null, state?: Array<string> | null, timeZone?: string | null, defaultSearch?: string | null, flags?: Array<{ key?: string | null, value?: string | null }> | null, activations?: Array<{ id: string, apiUser?: { id: string, name?: string | null } | null }> | null }> | null, recordCounts?: { today?: string | null, listings?: string | null, agents?: string | null, offices?: string | null } | null } | null };

export type CreateAdapterMutationVariables = Exact<{
  key: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  retsVersion?: InputMaybe<Scalars['String']>;
  status: AdapterStatus;
  requestTimeZone?: InputMaybe<Scalars['String']>;
  responseTimeZone?: InputMaybe<Scalars['String']>;
  adapterType?: InputMaybe<AdapterAdapterType>;
  userAgent?: InputMaybe<Scalars['String']>;
  userAgentPassword?: InputMaybe<Scalars['String']>;
  authEndpoint?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  grantType?: InputMaybe<AdapterGrantType>;
  updateDom?: InputMaybe<Scalars['Boolean']>;
  useJwtAuth?: InputMaybe<Scalars['Boolean']>;
  resourceBasicAuth?: InputMaybe<Scalars['Boolean']>;
  useReplicationEndpoint?: InputMaybe<Scalars['Boolean']>;
  replicationPrefix?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateAdapterMutation = { createAdapter?: { id: string, key?: string | null, url?: string | null, username?: string | null, password?: string | null, status?: AdapterStatus | null, scope?: string | null, adapterType?: AdapterAdapterType | null, retsVersion?: string | null, grantType?: AdapterGrantType | null, userAgent?: string | null, userAgentPassword?: string | null, requestTimeZone?: string | null, responseTimeZone?: string | null, currentJob?: string | null, authEndpoint?: string | null, updateDom?: boolean | null, esVersion?: number | null, esStatus?: AdapterEsStatus | null, useJwtAuth?: boolean | null, resourceBasicAuth?: boolean | null, useReplicationEndpoint?: boolean | null, replicationPrefix?: boolean | null, recordCounts?: { today?: string | null, listings?: string | null, agents?: string | null, offices?: string | null } | null } | null };

export type AdapterHealthQueryVariables = Exact<{
  adapterId: Scalars['ID'];
}>;


export type AdapterHealthQuery = { adapter?: { health?: { consumers?: number | null, sync?: number | null, audit?: number | null, auditResolution?: number | null, weeklyAudit?: number | null, monthlyAudit?: number | null } | null } | null };

export type AdapterMetadataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type AdapterMetadataQuery = { adapter?: { metadata?: { logs?: string | null, systemInfo?: { connected?: boolean | null, date?: string | null, version?: string | null, systemDescription?: string | null, systemId?: string | null, timezoneOffset?: string | null } | null, resources?: Array<{ name?: string | null, objects?: Array<{ name?: string | null, description?: string | null }> | null, classes?: Array<{ name?: string | null, fields?: any | null }> | null }> | null } | null } | null };

export type StopStatMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StopStatMutation = { updateStat?: { id: string, job?: StatJob | null, status?: StatStatus | null, progress?: string | null, totalRecords?: number | null, createdAt?: string | null, createdAtIso?: string | null, updatedAt?: string | null, updatedAtIso?: string | null, tookHuman?: string | null, jsonData?: string | null, humanCreatedAgo?: string | null, accuracyRate?: number | null, resolvedRate?: number | null, logLine?: string | null, statable?: { __typename: 'Adapter', id: string, key?: string | null } | { __typename: 'Resource', id: string, name?: string | null, resourceGroup?: { id: string, adapter?: { id: string, key?: string | null } | null } | null } | { __typename: 'ResourceGroup', id: string, adapter?: { id: string, key?: string | null } | null } | { __typename: 'Stat', id: string } | null, stats?: Array<{ id: string, job?: StatJob | null, status?: StatStatus | null, updatedAtIso?: string | null, logLine?: string | null, tookHuman?: string | null, totalRecords?: number | null }> | null } | null };

export type StatFieldsFragment = { id: string, job?: StatJob | null, status?: StatStatus | null, progress?: string | null, totalRecords?: number | null, createdAt?: string | null, createdAtIso?: string | null, updatedAt?: string | null, updatedAtIso?: string | null, tookHuman?: string | null, jsonData?: string | null, humanCreatedAgo?: string | null, accuracyRate?: number | null, resolvedRate?: number | null, logLine?: string | null, statable?: { __typename: 'Adapter', id: string, key?: string | null } | { __typename: 'Resource', id: string, name?: string | null, resourceGroup?: { id: string, adapter?: { id: string, key?: string | null } | null } | null } | { __typename: 'ResourceGroup', id: string, adapter?: { id: string, key?: string | null } | null } | { __typename: 'Stat', id: string } | null, stats?: Array<{ id: string, job?: StatJob | null, status?: StatStatus | null, updatedAtIso?: string | null, logLine?: string | null, tookHuman?: string | null, totalRecords?: number | null }> | null };

export type AdapterStatsQueryVariables = Exact<{
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type AdapterStatsQuery = { adapterStats?: { id: string, currentJob?: string | null, currentInProgress?: { id: string, job?: StatJob | null, status?: StatStatus | null, progress?: string | null, totalRecords?: number | null, createdAt?: string | null, createdAtIso?: string | null, updatedAt?: string | null, updatedAtIso?: string | null, tookHuman?: string | null, jsonData?: string | null, humanCreatedAgo?: string | null, accuracyRate?: number | null, resolvedRate?: number | null, logLine?: string | null, statable?: { __typename: 'Adapter', id: string, key?: string | null } | { __typename: 'Resource', id: string, name?: string | null, resourceGroup?: { id: string, adapter?: { id: string, key?: string | null } | null } | null } | { __typename: 'ResourceGroup', id: string, adapter?: { id: string, key?: string | null } | null } | { __typename: 'Stat', id: string } | null, stats?: Array<{ id: string, job?: StatJob | null, status?: StatStatus | null, updatedAtIso?: string | null, logLine?: string | null, tookHuman?: string | null, totalRecords?: number | null }> | null } | null, aggregatedStats?: Array<{ id: string, job?: StatJob | null, status?: StatStatus | null, progress?: string | null, totalRecords?: number | null, createdAt?: string | null, createdAtIso?: string | null, updatedAt?: string | null, updatedAtIso?: string | null, tookHuman?: string | null, jsonData?: string | null, humanCreatedAgo?: string | null, accuracyRate?: number | null, resolvedRate?: number | null, logLine?: string | null, statable?: { __typename: 'Adapter', id: string, key?: string | null } | { __typename: 'Resource', id: string, name?: string | null, resourceGroup?: { id: string, adapter?: { id: string, key?: string | null } | null } | null } | { __typename: 'ResourceGroup', id: string, adapter?: { id: string, key?: string | null } | null } | { __typename: 'Stat', id: string } | null, stats?: Array<{ id: string, job?: StatJob | null, status?: StatStatus | null, updatedAtIso?: string | null, logLine?: string | null, tookHuman?: string | null, totalRecords?: number | null }> | null }> | null } | null };

export type AdapterTimestampsQueryVariables = Exact<{
  resourceId: Scalars['ID'];
}>;


export type AdapterTimestampsQuery = { adapterTimestamps?: { oldestTimestamp?: string | null, newestTimestamp?: string | null, timestampVariance?: number | null, totalRecords?: number | null, recommendedRequestTimezone?: string | null, recommendedResponseTimezone?: string | null } | null };

export type AdaptersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<AdapterStatus>;
}>;


export type AdaptersQuery = { adapters?: Array<{ id: string, key?: string | null, status?: AdapterStatus | null, adapterType?: AdapterAdapterType | null, currentJob?: string | null }> | null };

export type AlarmProfileQueryVariables = Exact<{
  alarmProfileId?: InputMaybe<Scalars['ID']>;
}>;


export type AlarmProfileQuery = { alarmProfile?: { id: string, name?: string | null, status?: AlarmProfileStatus | null, role?: AlarmProfileRole | null, job?: AlarmProfileJob | null, field?: AlarmProfileField | null, operation?: AlarmProfileOperation | null, duration?: number | null, jobStatus?: AlarmProfileJobStatus | null, maxThreshold?: number | null, minThreshold?: number | null } | null };

export type AlarmProfilesQueryVariables = Exact<{
  adapterId?: InputMaybe<Scalars['Int']>;
}>;


export type AlarmProfilesQuery = { alarmProfiles?: Array<{ id: string, name?: string | null, explain?: string | null, status?: AlarmProfileStatus | null }> | null };

export type CreateAlarmProfileMutationVariables = Exact<{
  adapterId?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['Int']>;
  field?: InputMaybe<AlarmProfileField>;
  job?: InputMaybe<AlarmProfileJob>;
  jobStatus?: InputMaybe<AlarmProfileJobStatus>;
  maxThreshold?: InputMaybe<Scalars['Int']>;
  minThreshold?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  operation?: InputMaybe<AlarmProfileOperation>;
  role?: InputMaybe<AlarmProfileRole>;
  status?: InputMaybe<AlarmProfileStatus>;
}>;


export type CreateAlarmProfileMutation = { createAlarmProfile?: { id: string } | null };

export type DeleteAdapterMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAdapterMutation = { deleteAdapter?: boolean | null };

export type DeleteAlarmProfileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAlarmProfileMutation = { deleteAlarmProfile?: boolean | null };

export type ResourceDebugQueryVariables = Exact<{
  adapterId?: InputMaybe<Scalars['ID']>;
  resourceId?: InputMaybe<Scalars['ID']>;
}>;


export type ResourceDebugQuery = { adapter?: { resources?: Array<{ debug: { error?: { request?: any | null, response?: any | null } | null, debugResult?: { acres?: number | null, address?: string | null, area?: string | null, baths?: number | null, beds?: number | null, cdom?: string | null, changes?: string | null, city?: string | null, county?: string | null, directions?: string | null, dom?: string | null, features?: string | null, garages?: string | null, lat?: number | null, location?: string | null, lon?: number | null, lotdim?: string | null, lotsize?: number | null, mlsnum?: string | null, parcel?: string | null, photos?: Array<string> | null, price?: number | null, remarks?: string | null, sqft?: number | null, state?: string | null, status?: string | null, streetname?: string | null, streetnum?: string | null, style?: string | null, subdivision?: string | null, taxes?: number | null, unit?: string | null, updated_at?: string | null, zip?: string | null, zipcode?: string | null, assocFee?: number | null, bathsFull?: number | null, bathsHalf?: number | null, bathsQuarter?: number | null, bathsSearch?: number | null, bathsThreeQuarter?: number | null, createdAt?: string | null, dateExpired?: string | null, dateList?: string | null, dateOffMarket?: string | null, datePending?: string | null, dateSold?: string | null, featureCategories?: string | null, featuresStoriesTotal?: number | null, fullAddress?: string | null, gpsLoc?: string | null, lockboxLocation?: string | null, lockboxType?: string | null, mappedPropType?: string | null, mappedStatus?: string | null, photoCount?: string | null, photosUpdatedAt?: string | null, priceList?: number | null, priceListLow?: number | null, priceListOrig?: number | null, priceListPerSqft?: number | null, priceSold?: number | null, priceSoldPerSqft?: number | null, propSubType?: string | null, propType?: string | null, remarksPrivate?: string | null, saleRent?: string | null, schoolDistrict?: string | null, schoolElementary?: string | null, schoolHigh?: string | null, schoolMiddle?: string | null, showingInst?: string | null, sqftFields?: any | null, sqftSource?: string | null, sqftTotal?: number | null, wrResourceId?: number | null, yearBuilt?: number | null, agentList?: { email?: string | null, id?: string | null, name?: string | null, phone?: string | null, agentId?: string | null } | null, agentSell?: { id?: string | null, name?: string | null, phone?: string | null, email?: string | null, agentId?: string | null } | null, officeList?: { email?: string | null, id?: string | null, name?: string | null, phone?: string | null } | null, officeSell?: { email?: string | null, id?: string | null, name?: string | null, phone?: string | null } | null, rawData?: { raw?: string | null, serialized?: string | null } | null } | null } }> | null } | null };

export type UpdateAdapterMutationVariables = Exact<{
  id: Scalars['ID'];
  key?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  retsVersion?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AdapterStatus>;
  adapterType?: InputMaybe<AdapterAdapterType>;
  userAgent?: InputMaybe<Scalars['String']>;
  userAgentPassword?: InputMaybe<Scalars['String']>;
  requestTimeZone?: InputMaybe<Scalars['String']>;
  responseTimeZone?: InputMaybe<Scalars['String']>;
  authEndpoint?: InputMaybe<Scalars['String']>;
  grantType?: InputMaybe<AdapterGrantType>;
  scope?: InputMaybe<Scalars['String']>;
  updateDom?: InputMaybe<Scalars['Boolean']>;
  esStatus?: InputMaybe<AdapterEsStatus>;
  useJwtAuth?: InputMaybe<Scalars['Boolean']>;
  resourceBasicAuth?: InputMaybe<Scalars['Boolean']>;
  useReplicationEndpoint?: InputMaybe<Scalars['Boolean']>;
  replicationPrefix?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateAdapterMutation = { updateAdapter?: { id: string, key?: string | null, url?: string | null, username?: string | null, password?: string | null, status?: AdapterStatus | null, scope?: string | null, adapterType?: AdapterAdapterType | null, retsversion?: string | null, userAgent?: string | null, userAgentPassword?: string | null, requestTimeZone?: string | null, responseTimeZone?: string | null, authEndPoint?: string | null, updateDom?: boolean | null, esStatus?: AdapterEsStatus | null, useJwtAuth?: boolean | null, grantType?: AdapterGrantType | null, resourceBasicAuth?: boolean | null, useReplicationEndpoint?: boolean | null, replicationPrefix?: boolean | null, recordCounts?: { today?: string | null, listings?: string | null, agents?: string | null, offices?: string | null } | null } | null };

export type UpdateAlarmProfileMutationVariables = Exact<{
  alarmProfileId: Scalars['ID'];
  adapterId?: InputMaybe<Scalars['Int']>;
  duration?: InputMaybe<Scalars['Int']>;
  field?: InputMaybe<AlarmProfileField>;
  job?: InputMaybe<AlarmProfileJob>;
  jobStatus?: InputMaybe<AlarmProfileJobStatus>;
  maxThreshold?: InputMaybe<Scalars['Int']>;
  minThreshold?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  operation?: InputMaybe<AlarmProfileOperation>;
  role?: InputMaybe<AlarmProfileRole>;
  status?: InputMaybe<AlarmProfileStatus>;
}>;


export type UpdateAlarmProfileMutation = { updateAlarmProfile?: { id: string } | null };

export type AdminUserQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type AdminUserQuery = { admin?: { id: string, name?: string | null, email?: string | null, phone?: string | null, role?: AdminRole | null, alerts?: boolean | null, timezone?: string | null } | null };

export type AdminFieldsFragment = { id: string, email?: string | null, name?: string | null, phone?: string | null, timezone?: string | null, role?: AdminRole | null, alerts?: boolean | null, resetUrl?: string | null, lastLogin?: string | null, updatedAt?: string | null };

export type AdminsQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminsQuery = { admins?: Array<{ id: string, email?: string | null, name?: string | null, phone?: string | null, timezone?: string | null, role?: AdminRole | null, alerts?: boolean | null, resetUrl?: string | null, lastLogin?: string | null, updatedAt?: string | null }> | null };

export type CreateAdminMutationVariables = Exact<{
  name: Scalars['String'];
  email: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  role: AdminRole;
  alerts?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateAdminMutation = { createAdmin?: { id: string } | null };

export type DeleteAdminMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAdminMutation = { deleteAdmin?: boolean | null };

export type UpdateAdminMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  resetToken?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<AdminRole>;
  alerts?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  passwordConfirmation?: InputMaybe<Scalars['String']>;
}>;


export type UpdateAdminMutation = { updateAdmin?: { id: string } | null };

export type AgentSearchResultFragment = { active?: boolean | null, agent_id?: string | null, email?: string | null, firstname?: string | null, full_name?: string | null, id?: string | null, lastname?: string | null, login?: string | null, office_name?: string | null, phone?: string | null, updated_at?: string | null, wr_resource_id?: number | null, raw_data?: { serialized?: string | null, raw?: string | null } | null };

export type AgentSearchFieldPartsFragment = { aliases?: Array<string> | null, id: string, colName?: string | null };

export type AgentSearchQueryVariables = Exact<{
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Array<InputMaybe<FilterQueryType>> | InputMaybe<FilterQueryType>>;
  sort?: InputMaybe<QuerySortType>;
  source?: InputMaybe<Scalars['String']>;
}>;


export type AgentSearchQuery = { agentRg?: { id: string, agents?: { count?: number | null, explain?: string | null, results?: Array<{ active?: boolean | null, agent_id?: string | null, email?: string | null, firstname?: string | null, full_name?: string | null, id?: string | null, lastname?: string | null, login?: string | null, office_name?: string | null, phone?: string | null, updated_at?: string | null, wr_resource_id?: number | null, raw_data?: { serialized?: string | null, raw?: string | null } | null }> | null } | null } | null, resourceGroupFieldsSearchValues?: { id: string, fields?: Array<{ aliases?: Array<string> | null, id: string, colName?: string | null }> | null } | null };

export type DefaultCriteriaFieldsFragment = { id: string, value?: string | null, scope?: string | null, parentId?: number | null, parentType?: string | null, fieldName?: string | null, casCriterium?: boolean | null, createdAt?: string | null, updatedAt?: string | null };

export type ApiUserFieldsFragment = { id: string, name?: string | null, search?: boolean | null, replication?: boolean | null, jwt?: string | null, environment?: ApiUserEnvironment | null, apiKey?: string | null, forgeApi?: boolean | null, fullAccess?: boolean | null, percolatorNotifications?: ApiUserPercolatorNotification | null, percolatorEndpoint?: string | null, defaultCriteria?: Array<{ id: string, value?: string | null, scope?: string | null, parentId?: number | null, parentType?: string | null, fieldName?: string | null, casCriterium?: boolean | null, createdAt?: string | null, updatedAt?: string | null }> | null, activations?: Array<{ id: string, createdAtIso?: string | null, updatedAt?: string | null, listingService?: { id: string, key?: string | null, name?: string | null } | null }> | null };

export type ApiUserQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type ApiUserQuery = { apiUser?: { id: string, name?: string | null, search?: boolean | null, replication?: boolean | null, jwt?: string | null, environment?: ApiUserEnvironment | null, apiKey?: string | null, forgeApi?: boolean | null, fullAccess?: boolean | null, percolatorNotifications?: ApiUserPercolatorNotification | null, percolatorEndpoint?: string | null, defaultCriteria?: Array<{ id: string, value?: string | null, scope?: string | null, parentId?: number | null, parentType?: string | null, fieldName?: string | null, casCriterium?: boolean | null, createdAt?: string | null, updatedAt?: string | null }> | null, activations?: Array<{ id: string, createdAtIso?: string | null, updatedAt?: string | null, listingService?: { id: string, key?: string | null, name?: string | null } | null }> | null } | null };

export type ApiUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiUsersQuery = { apiUsers?: Array<{ id: string, name?: string | null, search?: boolean | null, replication?: boolean | null, jwt?: string | null, environment?: ApiUserEnvironment | null, apiKey?: string | null, forgeApi?: boolean | null, percolatorNotification?: ApiUserPercolatorNotification | null, percolatorEndpoint?: string | null, activations?: Array<{ id: string, createdAtIso?: string | null, listingService?: { id: string, key?: string | null, name?: string | null } | null }> | null }> | null };

export type CreateApiUserMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  apiKey: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<ApiUserEnvironment>;
  percolatorNotifications?: InputMaybe<ApiUserPercolatorNotification>;
  percolatorEndpoint?: InputMaybe<Scalars['String']>;
}>;


export type CreateApiUserMutation = { createApiUser?: { id: string, name?: string | null, apiKey?: string | null, updatedAt?: string | null } | null };

export type DeleteApiUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteApiUserMutation = { deleteApiUser?: boolean | null };

export type UpdateApiUserMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['Boolean']>;
  replication?: InputMaybe<Scalars['Boolean']>;
  forgeApi?: InputMaybe<Scalars['Boolean']>;
  fullAccess?: InputMaybe<Scalars['Boolean']>;
  environment?: InputMaybe<ApiUserEnvironment>;
  percolatorNotifications?: InputMaybe<ApiUserPercolatorNotification>;
  percolatorEndpoint?: InputMaybe<Scalars['String']>;
}>;


export type UpdateApiUserMutation = { updateApiUser?: { id: string, name?: string | null, search?: boolean | null, replication?: boolean | null, jwt?: string | null, environment?: ApiUserEnvironment | null, apiKey?: string | null, forgeApi?: boolean | null, fullAccess?: boolean | null, percolatorNotifications?: ApiUserPercolatorNotification | null, percolatorEndpoint?: string | null, defaultCriteria?: Array<{ id: string, value?: string | null, scope?: string | null, parentId?: number | null, parentType?: string | null, fieldName?: string | null, casCriterium?: boolean | null, createdAt?: string | null, updatedAt?: string | null }> | null, activations?: Array<{ id: string, createdAtIso?: string | null, updatedAt?: string | null, listingService?: { id: string, key?: string | null, name?: string | null } | null }> | null } | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { adapters?: Array<{ id: string }> | null };

export type AdminUserFragment = { id: string, name?: string | null, email?: string | null, role?: AdminRole | null };

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { login?: { token?: string | null, admin?: { id: string, name?: string | null, email?: string | null, role?: AdminRole | null } | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  resetToken: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
}>;


export type ResetPasswordMutation = { resetPassword?: { id: string, email?: string | null, name?: string | null, phone?: string | null, role?: AdminRole | null } | null };

export type DashboardAlarmsQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type DashboardAlarmsQuery = { alarms?: Array<{ id: string, active?: boolean | null, description?: string | null, createdAtIso?: string | null, clearedAtIso?: string | null, urlPath?: string | null, alarmable?: { __typename: 'Adapter', id: string, key?: string | null } | { __typename: 'ListingService', id: string, key?: string | null } | null }> | null };

export type GlobalCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalCountsQuery = { counts?: { adapters?: string | null, listings?: string | null, agents?: string | null, offices?: string | null, listingServices?: string | null, updatesToday?: string | null } | null };

export type DashboardResourceGroupsQueryVariables = Exact<{
  status?: InputMaybe<ResourceGroupStatus>;
}>;


export type DashboardResourceGroupsQuery = { resourceGroups?: Array<{ id: string, role?: ResourceGroupRole | null, status?: ResourceGroupStatus | null, loadingProgress?: string | null, adapter?: { id: string, key?: string | null } | null }> | null };

export type DashboardStatsByHourQueryVariables = Exact<{
  jobs?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type DashboardStatsByHourQuery = { statsByHour?: any | null };

export type ResourceGroupsQueryVariables = Exact<{
  adapterId?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<ResourceGroupRole>;
}>;


export type ResourceGroupsQuery = { resourceGroups?: Array<{ id: string, uid?: string | null, role?: ResourceGroupRole | null, version?: number | null, status?: ResourceGroupStatus | null, indexData?: boolean | null, searchData?: boolean | null, auditData?: boolean | null, skipPhotos?: boolean | null, needsSetup?: boolean | null, loadingProgress?: string | null, deletesStatus?: { total?: number | null, pending?: number | null, lastPurge?: string | null } | null, resources?: Array<{ id: string, name?: string | null, resourceGroupId?: number | null, updateData?: boolean | null, populateStatus?: string | null, health?: { sync?: number | null, audit?: number | null, auditResolution?: number | null, weeklyAudit?: number | null, monthlyAudit?: number | null } | null }> | null }> | null };

export type CreateCriteriaMutationVariables = Exact<{
  parentId?: InputMaybe<Scalars['Int']>;
  parentType?: InputMaybe<Scalars['String']>;
  fieldName?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  actionType?: InputMaybe<Scalars['String']>;
  casCriterium?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateCriteriaMutation = { createDefaultCriterium?: { parentId?: number | null } | null };

export type DeleteCriteriumMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCriteriumMutation = { deleteDefaultCriterium?: boolean | null };

export type CreateFieldMutationVariables = Exact<{
  colName: Scalars['String'];
  colType?: InputMaybe<ColTypeEnum>;
  displayName?: InputMaybe<Scalars['String']>;
  queryable?: InputMaybe<Scalars['Boolean']>;
  autocomplete?: InputMaybe<Scalars['Boolean']>;
  calculateDom?: InputMaybe<Scalars['Boolean']>;
  fieldCategoryId?: InputMaybe<Scalars['Int']>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  sourceNames?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  mapValues?: InputMaybe<FieldMapValue>;
  compose?: InputMaybe<Scalars['Boolean']>;
  standardName?: InputMaybe<Scalars['String']>;
  agentOnly?: InputMaybe<Scalars['Boolean']>;
  categoryName?: InputMaybe<Scalars['String']>;
  subcategoryName?: InputMaybe<Scalars['String']>;
}>;


export type CreateFieldMutation = { createField?: { id: string, aliases?: Array<string> | null, compose?: boolean | null, queryable?: boolean | null, autocomplete?: boolean | null, sqft?: boolean | null, colName?: string | null, colType?: ColTypeEnum | null, displayName?: string | null, fieldCategoryId?: number | null, mapValues?: FieldMapValue | null, calculateDom?: boolean | null, sourceNames?: Array<string> | null, searchValues?: Array<string> | null, isDraft?: boolean | null, standardName?: string | null, agentOnly?: boolean | null, categoryName?: string | null, subcategoryName?: string | null, fieldCategory?: { id: string, name?: string | null, resourceGroupId?: number | null, resourceGroup?: { adapterId?: number | null } | null } | null, lookups?: Array<{ id: string, order?: number | null, value?: string | null, mappedValue?: string | null, sourceId?: string | null, fieldId?: number | null }> | null, possibleCategories?: Array<{ id: string, name?: string | null }> | null, possileSources?: Array<{ label?: string | null, value?: string | null }> | null, pendingChanges?: { aliases?: Array<string> | null, compose?: boolean | null, queryable?: boolean | null, autocomplete?: boolean | null, sqft?: boolean | null, categoryName?: string | null, subcategoryName?: string | null, colName?: string | null, colType?: ColTypeEnum | null, displayName?: string | null, fieldCategoryId?: number | null, mapValues?: FieldMapValue | null, agentOnly?: boolean | null, calculateDom?: boolean | null, standardName?: string | null, sourceNames?: Array<string> | null, fieldCategory?: { id: string, name?: string | null, resourceGroupId?: number | null } | null } | null, transforms?: Array<{ id: string, order?: number | null, operation?: OperationEnum | null, data?: string | null, serializeOnly?: boolean | null, fieldId?: number | null }> | null } | null };

export type DeleteFieldMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFieldMutation = { deleteField?: boolean | null };

export type TransformPartsFragment = { id: string, order?: number | null, operation?: OperationEnum | null, data?: string | null, serializeOnly?: boolean | null, fieldId?: number | null };

export type LookupPartsFragment = { id: string, order?: number | null, value?: string | null, mappedValue?: string | null, sourceId?: string | null, fieldId?: number | null };

export type FieldPartsFragment = { id: string, aliases?: Array<string> | null, compose?: boolean | null, queryable?: boolean | null, autocomplete?: boolean | null, sqft?: boolean | null, colName?: string | null, colType?: ColTypeEnum | null, displayName?: string | null, fieldCategoryId?: number | null, mapValues?: FieldMapValue | null, calculateDom?: boolean | null, sourceNames?: Array<string> | null, searchValues?: Array<string> | null, isDraft?: boolean | null, standardName?: string | null, agentOnly?: boolean | null, categoryName?: string | null, subcategoryName?: string | null, fieldCategory?: { id: string, name?: string | null, resourceGroupId?: number | null, resourceGroup?: { adapterId?: number | null } | null } | null, lookups?: Array<{ id: string, order?: number | null, value?: string | null, mappedValue?: string | null, sourceId?: string | null, fieldId?: number | null }> | null, possibleCategories?: Array<{ id: string, name?: string | null }> | null, possileSources?: Array<{ label?: string | null, value?: string | null }> | null, pendingChanges?: { aliases?: Array<string> | null, compose?: boolean | null, queryable?: boolean | null, autocomplete?: boolean | null, sqft?: boolean | null, categoryName?: string | null, subcategoryName?: string | null, colName?: string | null, colType?: ColTypeEnum | null, displayName?: string | null, fieldCategoryId?: number | null, mapValues?: FieldMapValue | null, agentOnly?: boolean | null, calculateDom?: boolean | null, standardName?: string | null, sourceNames?: Array<string> | null, fieldCategory?: { id: string, name?: string | null, resourceGroupId?: number | null } | null } | null, transforms?: Array<{ id: string, order?: number | null, operation?: OperationEnum | null, data?: string | null, serializeOnly?: boolean | null, fieldId?: number | null }> | null };

export type FieldQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FieldQuery = { field?: { id: string, aliases?: Array<string> | null, compose?: boolean | null, queryable?: boolean | null, autocomplete?: boolean | null, sqft?: boolean | null, colName?: string | null, colType?: ColTypeEnum | null, displayName?: string | null, fieldCategoryId?: number | null, mapValues?: FieldMapValue | null, calculateDom?: boolean | null, sourceNames?: Array<string> | null, searchValues?: Array<string> | null, isDraft?: boolean | null, standardName?: string | null, agentOnly?: boolean | null, categoryName?: string | null, subcategoryName?: string | null, fieldCategory?: { id: string, name?: string | null, resourceGroupId?: number | null, resourceGroup?: { adapterId?: number | null } | null } | null, lookups?: Array<{ id: string, order?: number | null, value?: string | null, mappedValue?: string | null, sourceId?: string | null, fieldId?: number | null }> | null, possibleCategories?: Array<{ id: string, name?: string | null }> | null, possileSources?: Array<{ label?: string | null, value?: string | null }> | null, pendingChanges?: { aliases?: Array<string> | null, compose?: boolean | null, queryable?: boolean | null, autocomplete?: boolean | null, sqft?: boolean | null, categoryName?: string | null, subcategoryName?: string | null, colName?: string | null, colType?: ColTypeEnum | null, displayName?: string | null, fieldCategoryId?: number | null, mapValues?: FieldMapValue | null, agentOnly?: boolean | null, calculateDom?: boolean | null, standardName?: string | null, sourceNames?: Array<string> | null, fieldCategory?: { id: string, name?: string | null, resourceGroupId?: number | null } | null } | null, transforms?: Array<{ id: string, order?: number | null, operation?: OperationEnum | null, data?: string | null, serializeOnly?: boolean | null, fieldId?: number | null }> | null } | null };

export type UpdateFieldMutationVariables = Exact<{
  id: Scalars['ID'];
  colName?: InputMaybe<Scalars['String']>;
  colType?: InputMaybe<ColTypeEnum>;
  displayName?: InputMaybe<Scalars['String']>;
  queryable?: InputMaybe<Scalars['Boolean']>;
  autocomplete?: InputMaybe<Scalars['Boolean']>;
  calculateDom?: InputMaybe<Scalars['Boolean']>;
  fieldCategoryId?: InputMaybe<Scalars['Int']>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  sourceNames?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  mapValues?: InputMaybe<FieldMapValue>;
  compose?: InputMaybe<Scalars['Boolean']>;
  standardName?: InputMaybe<Scalars['String']>;
  agentOnly?: InputMaybe<Scalars['Boolean']>;
  categoryName?: InputMaybe<Scalars['String']>;
  subcategoryName?: InputMaybe<Scalars['String']>;
  sqft?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateFieldMutation = { updateField?: { id: string } | null };

export type CreateFieldTemplateMutationVariables = Exact<{
  recordType?: InputMaybe<FieldTemplateRecordType>;
  displayName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  fieldType: Scalars['String'];
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  alternateNames?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  fieldCategoryName?: InputMaybe<FieldTemplateFieldCategoryName>;
}>;


export type CreateFieldTemplateMutation = { createFieldTemplate?: { id: string, name?: string | null, aliases?: Array<string> | null, displayName?: string | null, alternateNames?: Array<string> | null, fieldCategoryName?: FieldTemplateFieldCategoryName | null, fieldType?: string | null, recordType?: FieldTemplateRecordType | null } | null };

export type DeleteFieldTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFieldTemplateMutation = { deleteFieldTemplate?: boolean | null };

export type FieldTemplateQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type FieldTemplateQuery = { fieldTemplate?: { id: string, name?: string | null, aliases?: Array<string> | null, displayName?: string | null, alternateNames?: Array<string> | null, fieldCategoryName?: FieldTemplateFieldCategoryName | null, fieldType?: string | null, recordType?: FieldTemplateRecordType | null } | null };

export type FieldTemplateFieldsFragment = { id: string, name?: string | null, aliases?: Array<string> | null, displayName?: string | null, alternateNames?: Array<string> | null, fieldCategoryName?: FieldTemplateFieldCategoryName | null, fieldType?: string | null, recordType?: FieldTemplateRecordType | null };

export type FieldTemplatesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type FieldTemplatesQuery = { fieldTemplates?: Array<{ id: string, name?: string | null, aliases?: Array<string> | null, displayName?: string | null, alternateNames?: Array<string> | null, fieldCategoryName?: FieldTemplateFieldCategoryName | null, fieldType?: string | null, recordType?: FieldTemplateRecordType | null }> | null };

export type UpdateFieldTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  recordType?: InputMaybe<FieldTemplateRecordType>;
  displayName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  fieldType: Scalars['String'];
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  alternateNames?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  fieldCategoryName?: InputMaybe<FieldTemplateFieldCategoryName>;
}>;


export type UpdateFieldTemplateMutation = { updateFieldTemplate?: { id: string, name?: string | null, aliases?: Array<string> | null, displayName?: string | null, alternateNames?: Array<string> | null, fieldCategoryName?: FieldTemplateFieldCategoryName | null, fieldType?: string | null, recordType?: FieldTemplateRecordType | null } | null };

export type JumperDataListingServiceFragment = { __typename: 'ListingService', id: string, key?: string | null, name?: string | null };

export type JumperDataAdapterFragment = { __typename: 'Adapter', id: string, key?: string | null, resourceGroups?: Array<{ id: string }> | null };

export type JumperDataQueryVariables = Exact<{ [key: string]: never; }>;


export type JumperDataQuery = { listingServices?: Array<{ __typename: 'ListingService', id: string, key?: string | null, name?: string | null }> | null, adapters?: Array<{ __typename: 'Adapter', id: string, key?: string | null, resourceGroups?: Array<{ id: string }> | null }> | null };

export type ListingSearchResultFragment = { acres?: number | null, address?: string | null, area?: string | null, assoc_fee?: number | null, baths?: number | null, baths_full?: number | null, baths_half?: number | null, baths_search?: number | null, beds?: number | null, city?: string | null, county?: string | null, created_at?: string | null, date_list?: string | null, date_offmarket?: string | null, date_pending?: string | null, date_sold?: string | null, directions?: string | null, dom?: string | null, features?: string | null, features_stories_total?: number | null, full_address?: string | null, garages?: string | null, gps_loc?: string | null, id?: string | null, lat?: number | null, location?: string | null, lon?: number | null, lotdim?: string | null, lotsize?: number | null, mapped_prop_type?: string | null, mapped_status?: string | null, mlsnum?: string | null, parcel?: string | null, photo_count?: string | null, photos?: Array<string> | null, photos_updated_at?: string | null, price?: number | null, price_list?: number | null, price_list_orig?: number | null, price_list_per_sqft?: number | null, price_sold?: number | null, prop_sub_type?: string | null, prop_type?: string | null, remarks?: string | null, remarks_private?: string | null, school_district?: string | null, school_elementary?: string | null, school_high?: string | null, school_middle?: string | null, showing_inst?: string | null, sqft?: number | null, state?: string | null, status?: string | null, streetname?: string | null, streetnum?: string | null, style?: string | null, subdivision?: string | null, taxes?: number | null, unit?: string | null, updated_at?: string | null, year_built?: number | null, zipcode?: string | null, wr_resource_id?: number | null, agent_list?: { id?: string | null, name?: string | null, phone?: string | null, email?: string | null } | null, office_list?: { id?: string | null, name?: string | null, phone?: string | null, email?: string | null } | null, agent_sell?: { id?: string | null, name?: string | null, phone?: string | null, email?: string | null } | null, office_sell?: { id?: string | null, name?: string | null, phone?: string | null, email?: string | null } | null, raw_data?: { serialized?: string | null, raw?: string | null } | null };

export type ListingSearchFieldPartsFragment = { aliases?: Array<string> | null, id: string, colName?: string | null };

export type ListingSearchQueryVariables = Exact<{
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Array<InputMaybe<FilterQueryType>> | InputMaybe<FilterQueryType>>;
  sort?: InputMaybe<QuerySortType>;
  source?: InputMaybe<Scalars['String']>;
}>;


export type ListingSearchQuery = { listingRg?: { id: string, listings?: { count?: number | null, explain?: string | null, results?: Array<{ acres?: number | null, address?: string | null, area?: string | null, assoc_fee?: number | null, baths?: number | null, baths_full?: number | null, baths_half?: number | null, baths_search?: number | null, beds?: number | null, city?: string | null, county?: string | null, created_at?: string | null, date_list?: string | null, date_offmarket?: string | null, date_pending?: string | null, date_sold?: string | null, directions?: string | null, dom?: string | null, features?: string | null, features_stories_total?: number | null, full_address?: string | null, garages?: string | null, gps_loc?: string | null, id?: string | null, lat?: number | null, location?: string | null, lon?: number | null, lotdim?: string | null, lotsize?: number | null, mapped_prop_type?: string | null, mapped_status?: string | null, mlsnum?: string | null, parcel?: string | null, photo_count?: string | null, photos?: Array<string> | null, photos_updated_at?: string | null, price?: number | null, price_list?: number | null, price_list_orig?: number | null, price_list_per_sqft?: number | null, price_sold?: number | null, prop_sub_type?: string | null, prop_type?: string | null, remarks?: string | null, remarks_private?: string | null, school_district?: string | null, school_elementary?: string | null, school_high?: string | null, school_middle?: string | null, showing_inst?: string | null, sqft?: number | null, state?: string | null, status?: string | null, streetname?: string | null, streetnum?: string | null, style?: string | null, subdivision?: string | null, taxes?: number | null, unit?: string | null, updated_at?: string | null, year_built?: number | null, zipcode?: string | null, wr_resource_id?: number | null, agent_list?: { id?: string | null, name?: string | null, phone?: string | null, email?: string | null } | null, office_list?: { id?: string | null, name?: string | null, phone?: string | null, email?: string | null } | null, agent_sell?: { id?: string | null, name?: string | null, phone?: string | null, email?: string | null } | null, office_sell?: { id?: string | null, name?: string | null, phone?: string | null, email?: string | null } | null, raw_data?: { serialized?: string | null, raw?: string | null } | null }> | null } | null } | null, resourceGroupFieldsSearchValues?: { id: string, fields?: Array<{ aliases?: Array<string> | null, id: string, colName?: string | null }> | null } | null };

export type ActivateListingServiceApiUserMutationVariables = Exact<{
  listingServiceId?: InputMaybe<Scalars['Int']>;
  apiUserId?: InputMaybe<Scalars['Int']>;
}>;


export type ActivateListingServiceApiUserMutation = { createActivation?: { id: string, createdAt?: string | null, apiUser?: { id: string, name?: string | null } | null } | null };

export type CreateListingServiceMutationVariables = Exact<{
  name: Scalars['String'];
  key: Scalars['String'];
  timeZone: Scalars['String'];
  address?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  lat?: InputMaybe<Scalars['Float']>;
  lon?: InputMaybe<Scalars['Float']>;
}>;


export type CreateListingServiceMutation = { createListingService?: { id: string } | null };

export type CreateServiceAdapterMutationVariables = Exact<{
  listingServiceId?: InputMaybe<Scalars['Int']>;
  adapterId?: InputMaybe<Scalars['Int']>;
}>;


export type CreateServiceAdapterMutation = { createServiceAdapter?: { id: string, adapter?: { id: string, key?: string | null, recordCounts?: { today?: string | null, listings?: string | null, agents?: string | null, offices?: string | null } | null } | null } | null };

export type DeleteListingServiceActivationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteListingServiceActivationMutation = { deleteActivation?: boolean | null };

export type DeleteListingServiceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteListingServiceMutation = { deleteListingService?: boolean | null };

export type DeleteServiceAdapterMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteServiceAdapterMutation = { deleteServiceAdapter?: boolean | null };

export type ServiceAdapterFieldsFragment = { id: string, adapter?: { id: string, key?: string | null, recordCounts?: { today?: string | null, listings?: string | null, agents?: string | null, offices?: string | null } | null } | null };

export type ListingServiceQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type ListingServiceQuery = { listingService?: { id: string, key?: string | null, name?: string | null, address?: string | null, lat?: number | null, lon?: number | null, state?: Array<string> | null, config?: string | null, timeZone?: string | null, defaultSearch?: string | null, flags?: Array<{ key?: string | null, value?: string | null }> | null, activations?: Array<{ id: string, apiUser?: { id: string, name?: string | null } | null }> | null, serviceAdapters?: Array<{ id: string, adapter?: { id: string, key?: string | null, recordCounts?: { today?: string | null, listings?: string | null, agents?: string | null, offices?: string | null } | null } | null }> | null } | null };

export type ListingServicesListingServiceFragment = { id: string, key?: string | null, name?: string | null, lat?: number | null, lon?: number | null, address?: string | null, state?: Array<string> | null, activations?: Array<{ id: string, apiUser?: { id: string, name?: string | null } | null }> | null };

export type ListingServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListingServicesQuery = { listingServices?: Array<{ id: string, key?: string | null, name?: string | null, lat?: number | null, lon?: number | null, address?: string | null, state?: Array<string> | null, activations?: Array<{ id: string, apiUser?: { id: string, name?: string | null } | null }> | null }> | null };

export type ReRegisterSavedSearchesMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ReRegisterSavedSearchesMutation = { reRegisterSavedSearches?: boolean | null };

export type SavedSearchQueryVariables = Exact<{
  listingServiceId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
}>;


export type SavedSearchQuery = { savedSearch?: { queries?: string | null, rawCriteria?: string | null } | null };

export type SavedSearchesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  listingServiceId?: InputMaybe<Scalars['ID']>;
}>;


export type SavedSearchesQuery = { listingService?: { id: string, savedSearchHealth?: { count?: number | null, registeredCount?: number | null, unregistered?: Array<{ id: string, matchCount?: number | null, lastMatchAt?: string | null }> | null } | null } | null };

export type UpdateListingServiceMutationVariables = Exact<{
  id: Scalars['ID'];
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lon?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  defaultSearch?: InputMaybe<Array<InputMaybe<DefaultSearchInput>> | InputMaybe<DefaultSearchInput>>;
  config?: InputMaybe<Scalars['String']>;
}>;


export type UpdateListingServiceMutation = { updateListingService?: { id: string, key?: string | null, name?: string | null, config?: string | null, createAt?: string | null, updateAt?: string | null } | null };

export type UpdateSavedSearchMutationVariables = Exact<{
  id: Scalars['ID'];
  listingServiceId?: InputMaybe<Scalars['Int']>;
  rawCriteria?: InputMaybe<Scalars['String']>;
}>;


export type UpdateSavedSearchMutation = { updateSavedSearch?: { id: string } | null };

export type CreateLookupMutationVariables = Exact<{
  fieldId?: InputMaybe<Scalars['Int']>;
  sourceId: Scalars['String'];
  value: Scalars['String'];
  mappedValue?: InputMaybe<Scalars['String']>;
}>;


export type CreateLookupMutation = { createLookup?: { id: string } | null };

export type CreateLookupsFromAggsMutationVariables = Exact<{
  fieldId: Scalars['ID'];
}>;


export type CreateLookupsFromAggsMutation = { createLookupsFromAggs?: { id: string, lookups?: Array<{ id: string, order?: number | null, value?: string | null, mappedValue?: string | null, sourceId?: string | null }> | null } | null };

export type CreateLookupsFromMetadataMutationVariables = Exact<{
  fieldId: Scalars['ID'];
  name: Scalars['String'];
}>;


export type CreateLookupsFromMetadataMutation = { createLookupsFromMetadata?: { id: string, lookups?: Array<{ id: string, order?: number | null, value?: string | null, mappedValue?: string | null, sourceId?: string | null }> | null } | null };

export type DestroyAllLookupsMutationVariables = Exact<{
  fieldId: Scalars['ID'];
}>;


export type DestroyAllLookupsMutation = { deleteAllLookups?: { id: string } | null };

export type DestroyLookupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyLookupMutation = { deleteLookup?: boolean | null };

export type ReorderLookupsMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type ReorderLookupsMutation = { reorderLookups?: boolean | null };

export type UpdateLookupMutationVariables = Exact<{
  id: Scalars['ID'];
  fieldId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  mappedValue?: InputMaybe<Scalars['String']>;
}>;


export type UpdateLookupMutation = { updateLookup?: { id: string, field?: { id: string, lookups?: Array<{ id: string, order?: number | null, value?: string | null, mappedValue?: string | null, sourceId?: string | null }> | null } | null } | null };

export type ImportMetadataMutationVariables = Exact<{
  adapterId: Scalars['ID'];
  resourceName: Scalars['String'];
  classNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  role: ResourceGroupRole;
}>;


export type ImportMetadataMutation = { importMetadata?: { id: string, adapterId?: number | null } | null };

export type OfficeSearchResultFragment = { email?: string | null, id?: string | null, name?: string | null, office_id?: string | null, phone?: string | null, updated_at?: string | null, active?: boolean | null, wr_resource_id?: number | null, raw_data?: { serialized?: string | null, raw?: string | null } | null };

export type OfficeSearchFieldPartsFragment = { aliases?: Array<string> | null, id: string, colName?: string | null };

export type OfficeSearchQueryVariables = Exact<{
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Array<InputMaybe<FilterQueryType>> | InputMaybe<FilterQueryType>>;
  sort?: InputMaybe<QuerySortType>;
  source?: InputMaybe<Scalars['String']>;
}>;


export type OfficeSearchQuery = { officeRg?: { id: string, offices?: { count?: number | null, explain?: string | null, results?: Array<{ email?: string | null, id?: string | null, name?: string | null, office_id?: string | null, phone?: string | null, updated_at?: string | null, active?: boolean | null, wr_resource_id?: number | null, raw_data?: { serialized?: string | null, raw?: string | null } | null }> | null } | null } | null, resourceGroupFieldsSearchValues?: { id: string, fields?: Array<{ aliases?: Array<string> | null, id: string, colName?: string | null }> | null } | null };

export type DeleteResourceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteResourceMutation = { deleteResource?: boolean | null };

export type PopulateMutationVariables = Exact<{
  resourceId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<PopulateFilterType> | PopulateFilterType>;
}>;


export type PopulateMutation = { startPopulate?: { id: string, totalRecords?: number | null, statableId?: number | null } | null };

export type ResourceQueryVariables = Exact<{
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  job?: InputMaybe<StatJob>;
}>;


export type ResourceQuery = { resource?: { id: string, name?: string | null, latestAudit?: string | null, updatesByHour?: string | null, defaultCriteria?: Array<{ id: string, scope?: string | null, value?: string | null, casCriterium?: boolean | null, createdAt?: string | null, fieldName?: string | null, parentId?: number | null, parentType?: string | null, updatedAt?: string | null }> | null, recentAudits?: Array<{ id: string, status?: StatStatus | null, createdAt?: string | null, humanCreatedAgo?: string | null, accuracyRate?: number | null, resolvedRate?: number | null, tookHuman?: string | null, totalRecords?: number | null }> | null, stats?: Array<{ id: string, job?: StatJob | null, status?: StatStatus | null, progress?: string | null, totalRecords?: number | null, createdAt?: string | null, createdAtIso?: string | null, updatedAt?: string | null, updatedAtIso?: string | null, tookHuman?: string | null, jsonData?: string | null, humanCreatedAgo?: string | null, accuracyRate?: number | null, resolvedRate?: number | null, logLine?: string | null, statable?: { __typename: 'Adapter', id: string, key?: string | null } | { __typename: 'Resource', id: string, name?: string | null, resourceGroup?: { id: string, adapter?: { id: string, key?: string | null } | null } | null } | { __typename: 'ResourceGroup', id: string, adapter?: { id: string, key?: string | null } | null } | { __typename: 'Stat', id: string } | null, stats?: Array<{ id: string, job?: StatJob | null, status?: StatStatus | null, updatedAtIso?: string | null, logLine?: string | null, tookHuman?: string | null, totalRecords?: number | null }> | null }> | null } | null };

export type ResourceHealthQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResourceHealthQuery = { resource?: { id: string, name?: string | null, updateData?: boolean | null, health?: { audit?: number | null, sync?: number | null, auditResolution?: number | null, monthlyAudit?: number | null, weeklyAudit?: number | null } | null } | null };

export type ResourceSampleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResourceSampleQuery = { resource?: { id: string, name?: string | null, sourceType?: string | null, sourceClass?: string | null, sampleData?: { raw?: string | null, serialized?: string | null, translated?: string | null, normalized?: string | null, serializedDraft?: string | null, translatedDraft?: string | null, normalizedDraft?: string | null } | null } | null };

export type ResumePopulateResourceMutationVariables = Exact<{
  statId: Scalars['ID'];
}>;


export type ResumePopulateResourceMutation = { resumePopulateResource?: { id: string } | null };

export type SyncRecordsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  recordIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type SyncRecordsQuery = { resource?: { reloadRecord: { success?: boolean | null, logs?: string | null, records?: Array<{ active?: boolean | null, email?: string | null, firstname?: string | null, id?: string | null, lastname?: string | null, login?: string | null, phone?: string | null, agentId?: string | null, fullName?: string | null, officeName?: string | null, updatedAt?: string | null, wrResourceId?: number | null, rawData?: { serialized?: string | null, raw?: string | null } | null } | { acres?: number | null, address?: string | null, area?: string | null, baths?: number | null, beds?: number | null, city?: string | null, county?: string | null, directions?: string | null, dom?: string | null, features?: string | null, garages?: string | null, id?: string | null, lat?: number | null, location?: string | null, lon?: number | null, lotdim?: string | null, lotsize?: number | null, mlsnum?: string | null, parcel?: string | null, photos?: Array<string> | null, price?: number | null, remarks?: string | null, sqft?: number | null, state?: string | null, status?: string | null, streetname?: string | null, streetnum?: string | null, style?: string | null, subdivision?: string | null, taxes?: number | null, unit?: string | null, updated_at?: string | null, zip?: string | null, zipcode?: string | null, assocFee?: number | null, bathsFull?: number | null, bathsHalf?: number | null, bathsSearch?: number | null, createdAt?: string | null, dateList?: string | null, dateOffmarket?: string | null, datePending?: string | null, dateSold?: string | null, featuresStoriesTotal?: number | null, fullAddress?: string | null, gpsLoc?: string | null, mappedPropType?: string | null, mappedStatus?: string | null, photoCount?: string | null, photosUpdatedAt?: string | null, priceList?: number | null, priceListOrig?: number | null, priceListPerSqft?: number | null, priceSold?: number | null, propSubType?: string | null, propType?: string | null, remarksPrivate?: string | null, schoolDistrict?: string | null, schoolElementary?: string | null, schoolHigh?: string | null, schoolMiddle?: string | null, showingInst?: string | null, yearBuilt?: number | null, wrResourceId?: number | null, agentList?: { id?: string | null, name?: string | null, phone?: string | null, email?: string | null } | null, officeList?: { id?: string | null, name?: string | null, phone?: string | null, email?: string | null } | null, agentSell?: { id?: string | null, name?: string | null, phone?: string | null, email?: string | null } | null, officeSell?: { id?: string | null, name?: string | null, phone?: string | null, email?: string | null } | null, rawData?: { serialized?: string | null, raw?: string | null } | null } | { email?: string | null, id?: string | null, name?: string | null, phone?: string | null, active?: boolean | null, officeId?: string | null, updatedAt?: string | null, wrResourceId?: number | null, rawData?: { serialized?: string | null, raw?: string | null } | null }> | null } } | null };

export type UpdateResourceMutationVariables = Exact<{
  id: Scalars['ID'];
  resourceGroupId?: InputMaybe<Scalars['Int']>;
  updateData?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateResourceMutation = { updateResource?: { id: string } | null };

export type AdapterResourceGroupFragment = { id: string, uid?: string | null, role?: ResourceGroupRole | null, version?: number | null, status?: ResourceGroupStatus | null, indexData?: boolean | null, searchData?: boolean | null, auditData?: boolean | null, skipPhotos?: boolean | null, needsSetup?: boolean | null, loadingProgress?: string | null, deletesStatus?: { pending?: number | null, status?: string | null, total?: number | null, lastPurge?: string | null } | null, resources?: Array<{ id: string, name?: string | null, populateStatus?: string | null, updateData?: boolean | null }> | null };

export type AdapterResourceGroupsQueryVariables = Exact<{
  id: Scalars['ID'];
  adapterId?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<ResourceGroupRole>;
}>;


export type AdapterResourceGroupsQuery = { adapter?: { id: string, key?: string | null, resourceGroups?: Array<{ id: string, uid?: string | null, role?: ResourceGroupRole | null, version?: number | null, status?: ResourceGroupStatus | null, indexData?: boolean | null, searchData?: boolean | null, auditData?: boolean | null, skipPhotos?: boolean | null, needsSetup?: boolean | null, loadingProgress?: string | null, deletesStatus?: { pending?: number | null, status?: string | null, total?: number | null, lastPurge?: string | null } | null, resources?: Array<{ id: string, name?: string | null, populateStatus?: string | null, updateData?: boolean | null }> | null }> | null } | null };

export type DeleteRecordMutationVariables = Exact<{
  id: Scalars['ID'];
  record_id: Scalars['ID'];
}>;


export type DeleteRecordMutation = { deleteRecord?: { success?: boolean | null } | null };

export type DeleteResourceGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteResourceGroupMutation = { deleteResourceGroup?: boolean | null };

export type FieldCategoryPartsFragment = { id: string, name?: string | null };

export type AdapterResourceGroupFieldsFragment = { id: string, role?: ResourceGroupRole | null, status?: ResourceGroupStatus | null, replication?: boolean | null, updatesByHour?: string | null, loadingProgress?: string | null, skipPhotos?: boolean | null, replicationLag?: number | null, uniqueIdField?: string | null, updatedAtField?: string | null, trackFields?: Array<string> | null, populateDateField?: string | null, photosUpdatedAtField?: string | null, photoStrategy?: ResourceGroupPhotoStrategy | null, purgeListingsAutomatically?: boolean | null, domCalculationV2?: boolean | null, reverseAuditInterval?: number | null, fieldCategories?: Array<{ id: string, name?: string | null }> | null, deletesStatus?: { total?: number | null, pending?: number | null, last_purge?: string | null } | null, resources?: Array<{ id: string, name?: string | null, resourceGroupId?: number | null, updateData?: boolean | null }> | null, possibleSources?: Array<{ label?: string | null, value?: string | null }> | null, adapter?: { id: string, adapterType?: AdapterAdapterType | null, updateDom?: boolean | null, resources?: Array<{ id: string, name?: string | null, resourceGroupId?: number | null }> | null, resourceGroups?: Array<{ possibleSources?: Array<{ label?: string | null, value?: string | null }> | null }> | null } | null, photoSettings?: { listingIdField?: string | null, objectType?: string | null, orderField?: string | null, photosCountField?: string | null, photosUpdatedAtField?: string | null, resource?: string | null, resourceId?: string | null, urlField?: string | null } | null };

export type ResourceGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResourceGroupQuery = { resourceGroup?: { id: string, role?: ResourceGroupRole | null, status?: ResourceGroupStatus | null, replication?: boolean | null, updatesByHour?: string | null, loadingProgress?: string | null, skipPhotos?: boolean | null, replicationLag?: number | null, uniqueIdField?: string | null, updatedAtField?: string | null, trackFields?: Array<string> | null, populateDateField?: string | null, photosUpdatedAtField?: string | null, photoStrategy?: ResourceGroupPhotoStrategy | null, purgeListingsAutomatically?: boolean | null, domCalculationV2?: boolean | null, reverseAuditInterval?: number | null, fieldCategories?: Array<{ id: string, name?: string | null }> | null, deletesStatus?: { total?: number | null, pending?: number | null, last_purge?: string | null } | null, resources?: Array<{ id: string, name?: string | null, resourceGroupId?: number | null, updateData?: boolean | null }> | null, possibleSources?: Array<{ label?: string | null, value?: string | null }> | null, adapter?: { id: string, adapterType?: AdapterAdapterType | null, updateDom?: boolean | null, resources?: Array<{ id: string, name?: string | null, resourceGroupId?: number | null }> | null, resourceGroups?: Array<{ possibleSources?: Array<{ label?: string | null, value?: string | null }> | null }> | null } | null, photoSettings?: { listingIdField?: string | null, objectType?: string | null, orderField?: string | null, photosCountField?: string | null, photosUpdatedAtField?: string | null, resource?: string | null, resourceId?: string | null, urlField?: string | null } | null } | null };

export type ResourceGroupFieldsSearchValuesPartsFragment = { id: string, aliases?: Array<string> | null, colName?: string | null, searchDisplay?: string | null, searchValues?: Array<string> | null };

export type ResourceGroupFieldsSearchValuesQueryVariables = Exact<{
  resourceGroupId: Scalars['ID'];
  includeSearchValues: Scalars['Boolean'];
  fields?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ResourceGroupFieldsSearchValuesQuery = { resourceGroupFieldsSearchValues?: { id: string, fields?: Array<{ id: string, aliases?: Array<string> | null, colName?: string | null, searchDisplay?: string | null, searchValues?: Array<string> | null }> | null } | null };

export type ResourceGroupFieldPartsFragment = { id: string, aliases?: Array<string> | null, queryable?: boolean | null, calculateDom?: boolean | null, colName?: string | null, colType?: ColTypeEnum | null, displayName?: string | null, fieldCategoryId?: number | null, isDraft?: boolean | null, searchDisplay?: string | null, sourceNames?: Array<string> | null, fieldCategory?: { id: string, name?: string | null } | null, pendingChanges?: { aliases?: Array<string> | null, compose?: boolean | null, queryable?: boolean | null, autocomplete?: boolean | null, colName?: string | null, colType?: ColTypeEnum | null, displayName?: string | null, fieldCategoryId?: number | null, mapValue?: FieldMapValue | null, calculateDom?: boolean | null, sourceNames?: Array<string> | null, fieldCategory?: { id: string, name?: string | null, resourceGroupId?: number | null } | null } | null };

export type ResourceGroupFieldsQueryVariables = Exact<{
  resourceGroupId: Scalars['ID'];
}>;


export type ResourceGroupFieldsQuery = { resourceGroupFields?: { id: string, fields?: Array<{ id: string, aliases?: Array<string> | null, queryable?: boolean | null, calculateDom?: boolean | null, colName?: string | null, colType?: ColTypeEnum | null, displayName?: string | null, fieldCategoryId?: number | null, isDraft?: boolean | null, searchDisplay?: string | null, sourceNames?: Array<string> | null, fieldCategory?: { id: string, name?: string | null } | null, pendingChanges?: { aliases?: Array<string> | null, compose?: boolean | null, queryable?: boolean | null, autocomplete?: boolean | null, colName?: string | null, colType?: ColTypeEnum | null, displayName?: string | null, fieldCategoryId?: number | null, mapValue?: FieldMapValue | null, calculateDom?: boolean | null, sourceNames?: Array<string> | null, fieldCategory?: { id: string, name?: string | null, resourceGroupId?: number | null } | null } | null }> | null } | null };

export type PurgeDeletesMutationVariables = Exact<{
  resourceGroupId: Scalars['ID'];
}>;


export type PurgeDeletesMutation = { purgeDeletes?: boolean | null };

export type ClearPurgeMutationVariables = Exact<{
  resourceGroupId: Scalars['ID'];
}>;


export type ClearPurgeMutation = { clearDeletes?: boolean | null };

export type ResourceGroupSearchQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type ResourceGroupSearchQuery = { resourceGroup?: { id: string, role?: ResourceGroupRole | null, needsSetup?: boolean | null, adapter?: { key?: string | null } | null } | null };

export type ResourceGroupSearchResultsQueryVariables = Exact<{
  resourceGroupId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<QuerySortType>;
  filter?: InputMaybe<Array<InputMaybe<FilterQueryType>> | InputMaybe<FilterQueryType>>;
}>;


export type ResourceGroupSearchResultsQuery = { resourceGroup?: { role?: ResourceGroupRole | null, listings?: { count?: number | null, results?: Array<{ address?: string | null, baths?: number | null, beds?: number | null, city?: string | null, dom?: string | null, id?: string | null, lat?: number | null, lon?: number | null, mapped_status?: string | null, photos?: Array<string> | null, price?: number | null, sqft?: number | null, state?: string | null, status?: string | null, year_built?: number | null, zipcode?: string | null }> | null } | null, agents?: { count?: number | null, results?: Array<{ active?: boolean | null, agent_id?: string | null, email?: string | null, firstname?: string | null, full_name?: string | null, id?: string | null, lastname?: string | null, office_name?: string | null, phone?: string | null }> | null } | null, offices?: { count?: number | null, results?: Array<{ id?: string | null, email?: string | null, name?: string | null, office_id?: string | null, phone?: string | null, active?: boolean | null }> | null } | null } | null };

export type ResourceGroupSearchDetailsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<Array<InputMaybe<FilterQueryType>> | InputMaybe<FilterQueryType>>;
}>;


export type ResourceGroupSearchDetailsQuery = { resourceGroup?: { id: string, role?: ResourceGroupRole | null, needsSetup?: boolean | null, listings?: { count?: number | null, results?: Array<{ acres?: number | null, address?: string | null, area?: string | null, assoc_fee?: number | null, baths?: number | null, baths_full?: number | null, baths_half?: number | null, baths_search?: number | null, beds?: number | null, city?: string | null, county?: string | null, created_at?: string | null, date_list?: string | null, date_offmarket?: string | null, date_pending?: string | null, date_sold?: string | null, directions?: string | null, dom?: string | null, features?: string | null, features_stories_total?: number | null, full_address?: string | null, garages?: string | null, gps_loc?: string | null, id?: string | null, lat?: number | null, location?: string | null, lon?: number | null, lotdim?: string | null, lotsize?: number | null, mapped_prop_type?: string | null, mapped_status?: string | null, mlsnum?: string | null, parcel?: string | null, photo_count?: string | null, photos?: Array<string> | null, photos_updated_at?: string | null, price?: number | null, price_list?: number | null, price_list_orig?: number | null, price_list_per_sqft?: number | null, price_sold?: number | null, prop_sub_type?: string | null, prop_type?: string | null, remarks?: string | null, remarks_private?: string | null, school_district?: string | null, school_elementary?: string | null, school_high?: string | null, school_middle?: string | null, showing_inst?: string | null, sqft?: number | null, state?: string | null, status?: string | null, streetname?: string | null, streetnum?: string | null, style?: string | null, subdivision?: string | null, taxes?: number | null, unit?: string | null, updated_at?: string | null, year_built?: number | null, zipcode?: string | null, wr_resource_id?: number | null, agent_list?: { id?: string | null, name?: string | null, phone?: string | null, email?: string | null } | null, office_list?: { id?: string | null, name?: string | null, phone?: string | null, email?: string | null } | null, agent_sell?: { id?: string | null, name?: string | null, phone?: string | null, email?: string | null } | null, office_sell?: { id?: string | null, name?: string | null, phone?: string | null, email?: string | null } | null, raw_data?: { serialized?: string | null, raw?: string | null } | null }> | null } | null, agents?: { count?: number | null, results?: Array<{ active?: boolean | null, agent_id?: string | null, email?: string | null, firstname?: string | null, full_name?: string | null, id?: string | null, lastname?: string | null, login?: string | null, office_name?: string | null, phone?: string | null, updated_at?: string | null, wr_resource_id?: number | null, raw_data?: { serialized?: string | null, raw?: string | null } | null }> | null } | null, offices?: { count?: number | null, results?: Array<{ email?: string | null, id?: string | null, name?: string | null, office_id?: string | null, phone?: string | null, updated_at?: string | null, active?: boolean | null, wr_resource_id?: number | null, raw_data?: { serialized?: string | null, raw?: string | null } | null }> | null } | null } | null };

export type ResourceGroupSearchFieldsQueryVariables = Exact<{
  resourceGroupId?: InputMaybe<Scalars['ID']>;
}>;


export type ResourceGroupSearchFieldsQuery = { resourceGroup?: { fields?: Array<{ id: string, aliases?: Array<string> | null, displayName?: string | null, colName?: string | null, colType?: ColTypeEnum | null, fieldCategory?: { id: string } | null }> | null } | null };

export type FieldSearchValuesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type FieldSearchValuesQuery = { field?: { searchValues?: Array<string> | null } | null };

export type ResourceGroupStatsQueryVariables = Exact<{
  id: Scalars['ID'];
  job?: InputMaybe<StatJob>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type ResourceGroupStatsQuery = { resourceGroupStats?: { id: string, stats?: Array<{ id: string, job?: StatJob | null, status?: StatStatus | null, progress?: string | null, totalRecords?: number | null, createdAt?: string | null, createdAtIso?: string | null, updatedAt?: string | null, updatedAtIso?: string | null, tookHuman?: string | null, jsonData?: string | null, humanCreatedAgo?: string | null, accuracyRate?: number | null, resolvedRate?: number | null, logLine?: string | null, statable?: { __typename: 'Adapter', id: string, key?: string | null } | { __typename: 'Resource', id: string, name?: string | null, resourceGroup?: { id: string, adapter?: { id: string, key?: string | null } | null } | null } | { __typename: 'ResourceGroup', id: string, adapter?: { id: string, key?: string | null } | null } | { __typename: 'Stat', id: string } | null, stats?: Array<{ id: string, job?: StatJob | null, status?: StatStatus | null, updatedAtIso?: string | null, logLine?: string | null, tookHuman?: string | null, totalRecords?: number | null }> | null }> | null } | null };

export type UpdateResourceGroupMutationVariables = Exact<{
  action_type?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  searchData?: InputMaybe<Scalars['Boolean']>;
  indexData?: InputMaybe<Scalars['Boolean']>;
  auditData?: InputMaybe<Scalars['Boolean']>;
  skipPhotos?: InputMaybe<Scalars['Boolean']>;
  adapterId?: InputMaybe<Scalars['Int']>;
  updated_at_field?: InputMaybe<Scalars['String']>;
  populate_date_field?: InputMaybe<Scalars['String']>;
  photos_updated_at_field?: InputMaybe<Scalars['String']>;
  unique_id_field?: InputMaybe<Scalars['String']>;
  track_fields?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  photo_strategy?: InputMaybe<ResourceGroupPhotoStrategy>;
  photo_settings?: InputMaybe<PhotoSettingsInput>;
  status?: InputMaybe<ResourceGroupStatus>;
  replication?: InputMaybe<Scalars['Boolean']>;
  purge_listings_automatically?: InputMaybe<Scalars['Boolean']>;
  reverse_audit_interval?: InputMaybe<Scalars['Int']>;
  dom_calculation_v2?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateResourceGroupMutation = { updateResourceGroup?: { id: string, role?: ResourceGroupRole | null, status?: ResourceGroupStatus | null, replication?: boolean | null, updatesByHour?: string | null, loadingProgress?: string | null, skipPhotos?: boolean | null, replicationLag?: number | null, uniqueIdField?: string | null, updatedAtField?: string | null, trackFields?: Array<string> | null, populateDateField?: string | null, photosUpdatedAtField?: string | null, photoStrategy?: ResourceGroupPhotoStrategy | null, purgeListingsAutomatically?: boolean | null, domCalculationV2?: boolean | null, reverseAuditInterval?: number | null, fieldCategories?: Array<{ id: string, name?: string | null }> | null, deletesStatus?: { total?: number | null, pending?: number | null, last_purge?: string | null } | null, resources?: Array<{ id: string, name?: string | null, resourceGroupId?: number | null, updateData?: boolean | null }> | null, possibleSources?: Array<{ label?: string | null, value?: string | null }> | null, adapter?: { id: string, adapterType?: AdapterAdapterType | null, updateDom?: boolean | null, resources?: Array<{ id: string, name?: string | null, resourceGroupId?: number | null }> | null, resourceGroups?: Array<{ possibleSources?: Array<{ label?: string | null, value?: string | null }> | null }> | null } | null, photoSettings?: { listingIdField?: string | null, objectType?: string | null, orderField?: string | null, photosCountField?: string | null, photosUpdatedAtField?: string | null, resource?: string | null, resourceId?: string | null, urlField?: string | null } | null } | null };

export type CreateTransformMutationVariables = Exact<{
  fieldId?: InputMaybe<Scalars['Int']>;
  operation?: InputMaybe<OperationEnum>;
  order?: InputMaybe<Scalars['Int']>;
  data?: InputMaybe<Scalars['String']>;
  serializeOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateTransformMutation = { createTransform?: { id: string, field?: { id: string, transforms?: Array<{ id: string, order?: number | null, operation?: OperationEnum | null, data?: string | null, serialize_only?: boolean | null, field_id?: number | null }> | null } | null } | null };

export type DestroyTransformMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DestroyTransformMutation = { deleteTransform?: boolean | null };

export type ReorderTransformsMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type ReorderTransformsMutation = { reorderTransforms?: boolean | null };

export type TransformPipelineMutationVariables = Exact<{
  fieldId: Scalars['ID'];
  rawSource?: InputMaybe<Scalars['String']>;
}>;


export type TransformPipelineMutation = { transformPipeline?: { rawSource?: string | null, finalOutput?: string | null, steps?: Array<{ file?: string | null, input?: string | null, output?: string | null }> | null } | null };

export type UpdateTransformMutationVariables = Exact<{
  id: Scalars['ID'];
  fieldId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  operation?: InputMaybe<OperationEnum>;
  data?: InputMaybe<Scalars['String']>;
  serializeOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateTransformMutation = { updateTransform?: { id: string, order?: number | null, operation?: OperationEnum | null, data?: string | null, serialize_only?: boolean | null } | null };

export const DefaultSchemaPartsFragmentDoc = `
    fragment DefaultSchemaParts on DefaultSchemaField {
  colName: col_name
  colType: col_type
  standardName: standard_name
  path
}
    `;
export const AdapterFieldsFragmentDoc = `
    fragment adapterFields on Adapter {
  id
  adapterType: adapter_type
  key
  url
  username
  password
  retsVersion: rets_version
  status
  grantType: grant_type
  userAgent: user_agent
  userAgentPassword: user_agent_password
  requestTimeZone: request_time_zone
  responseTimeZone: response_time_zone
  currentJob: current_job
  authEndpoint: auth_endpoint
  scope
  updateDom: update_dom
  esVersion: es_version
  esStatus: es_status
  recordCounts: record_counts {
    today
    listings
    agents
    offices
  }
  useJwtAuth: use_jwt_auth
  resourceBasicAuth: resource_basic_auth
  useReplicationEndpoint: use_replication_endpoint
  replicationPrefix: replication_prefix
}
    `;
export const MetadataResourceFieldsFragmentDoc = `
    fragment MetadataResourceFields on MdResource {
  name
  objects {
    name
    description
  }
  classes {
    name
    fields
  }
}
    `;
export const MetadataFieldsFragmentDoc = `
    fragment MetadataFields on Metadata {
  systemInfo: system_info {
    connected
    date
    systemDescription: system_description
    systemId: system_id
    timezoneOffset: timezone_offset
    version
  }
  resources {
    ...MetadataResourceFields
  }
  logs
}
    ${MetadataResourceFieldsFragmentDoc}`;
export const StatFieldsFragmentDoc = `
    fragment statFields on Stat {
  id
  job
  totalRecords: total_records
  createdAt: created_at
  createdAtIso: created_at_iso
  updatedAt: updated_at
  updatedAtIso: updated_at_iso
  status
  tookHuman: took_human
  jsonData: json_data
  humanCreatedAgo: human_created_ago
  accuracyRate: accuracy_rate
  resolvedRate: resolved_rate
  progress
  logLine: log_line
  statable {
    ... on Stat {
      __typename
      id
    }
    ... on Adapter {
      __typename
      id
      key
    }
    ... on ResourceGroup {
      __typename
      id
      adapter {
        id
        key
      }
    }
    ... on Resource {
      __typename
      id
      name
      resourceGroup: resource_group {
        id
        adapter {
          id
          key
        }
      }
    }
  }
  stats(limit: 5000, sort: {field: "updated_at", dir: desc}) {
    id
    job
    updatedAtIso: updated_at_iso
    status
    logLine: log_line
    tookHuman: took_human
    totalRecords: total_records
  }
}
    `;
export const AdminFieldsFragmentDoc = `
    fragment AdminFields on Admin {
  id
  email
  name
  phone
  timezone
  role
  alerts
  resetUrl: reset_url
  lastLogin: last_login
  updatedAt: updated_at
}
    `;
export const AgentSearchResultFragmentDoc = `
    fragment AgentSearchResult on AgentResultType {
  active
  agent_id
  email
  firstname
  full_name
  id
  lastname
  login
  office_name
  phone
  updated_at
  wr_resource_id
  raw_data {
    serialized
    raw
  }
}
    `;
export const AgentSearchFieldPartsFragmentDoc = `
    fragment AgentSearchFieldParts on Field {
  aliases
  colName: col_name
  id
}
    `;
export const DefaultCriteriaFieldsFragmentDoc = `
    fragment defaultCriteriaFields on DefaultCriterium {
  id
  value
  scope
  parentId: parent_id
  parentType: parent_type
  fieldName: field_name
  casCriterium: cas_criterium
  createdAt: created_at
  updatedAt: updated_at
}
    `;
export const ApiUserFieldsFragmentDoc = `
    fragment apiUserFields on ApiUser {
  id
  name
  search
  replication
  jwt
  environment
  apiKey: api_key
  forgeApi: forge_api
  fullAccess: full_access
  percolatorNotifications: percolator_notifications
  percolatorEndpoint: percolator_endpoint
  defaultCriteria: default_criteria {
    ...defaultCriteriaFields
  }
  activations(limit: 10000) {
    id
    createdAtIso: created_at_iso
    updatedAt: updated_at
    listingService: listing_service {
      id
      key
      name
    }
  }
}
    ${DefaultCriteriaFieldsFragmentDoc}`;
export const AdminUserFragmentDoc = `
    fragment AdminUser on Admin {
  id
  name
  email
  role
}
    `;
export const LookupPartsFragmentDoc = `
    fragment LookupParts on Lookup {
  id
  order
  value
  mappedValue: mapped_value
  sourceId: source_id
  fieldId: field_id
}
    `;
export const TransformPartsFragmentDoc = `
    fragment TransformParts on Transform {
  id
  order
  operation
  data
  serializeOnly: serialize_only
  fieldId: field_id
}
    `;
export const FieldPartsFragmentDoc = `
    fragment FieldParts on Field {
  id
  aliases
  colName: col_name
  colType: col_type
  compose
  displayName: display_name
  fieldCategory: field_category {
    id
    name
    resourceGroupId: resource_group_id
    resourceGroup: resource_group {
      adapterId: adapter_id
    }
  }
  fieldCategoryId: field_category_id
  lookups(limit: 10000) {
    ...LookupParts
  }
  mapValues: map_values
  possibleCategories: possible_categories {
    id
    name
  }
  possileSources: possible_sources {
    label
    value
  }
  queryable
  autocomplete
  calculateDom: calculate_dom
  sourceNames: source_names
  searchValues: search_values
  isDraft: is_draft
  standardName: standard_name
  agentOnly: agent_only
  categoryName: category_name
  subcategoryName: subcategory_name
  sqft
  pendingChanges: pending_changes {
    aliases
    categoryName: category_name
    subcategoryName: subcategory_name
    colName: col_name
    colType: col_type
    compose
    displayName: display_name
    fieldCategory: field_category {
      id
      name
      resourceGroupId: resource_group_id
    }
    fieldCategoryId: field_category_id
    mapValues: map_values
    queryable
    agentOnly: agent_only
    autocomplete
    calculateDom: calculate_dom
    standardName: standard_name
    sourceNames: source_names
    sqft
  }
  transforms(limit: 1000, sort: {field: "order", dir: asc}) {
    ...TransformParts
  }
}
    ${LookupPartsFragmentDoc}
${TransformPartsFragmentDoc}`;
export const FieldTemplateFieldsFragmentDoc = `
    fragment FieldTemplateFields on FieldTemplate {
  id
  displayName: display_name
  name
  aliases
  alternateNames: alternate_names
  fieldCategoryName: field_category_name
  fieldType: field_type
  recordType: record_type
}
    `;
export const JumperDataListingServiceFragmentDoc = `
    fragment JumperDataListingService on ListingService {
  __typename
  id
  key
  name
}
    `;
export const JumperDataAdapterFragmentDoc = `
    fragment JumperDataAdapter on Adapter {
  __typename
  id
  key
  resourceGroups: resource_groups {
    id
  }
}
    `;
export const ListingSearchResultFragmentDoc = `
    fragment ListingSearchResult on ListingResultType {
  acres
  address
  area
  assoc_fee
  baths
  baths_full
  baths_half
  baths_search
  beds
  city
  county
  created_at
  date_list
  date_offmarket
  date_pending
  date_sold
  directions
  dom
  features
  features_stories_total
  full_address
  garages
  gps_loc
  id
  lat
  location
  lon
  lotdim
  lotsize
  mapped_prop_type
  mapped_status
  mlsnum
  parcel
  photo_count
  photos
  photos_updated_at
  price
  price_list
  price_list_orig
  price_list_per_sqft
  price_sold
  prop_sub_type
  prop_type
  remarks
  remarks_private
  school_district
  school_elementary
  school_high
  school_middle
  showing_inst
  sqft
  state
  status
  streetname
  streetnum
  style
  subdivision
  taxes
  unit
  updated_at
  year_built
  zipcode
  wr_resource_id
  agent_list {
    id
    name
    phone
    email
  }
  office_list {
    id
    name
    phone
    email
  }
  agent_sell {
    id
    name
    phone
    email
  }
  office_sell {
    id
    name
    phone
    email
  }
  raw_data {
    serialized
    raw
  }
}
    `;
export const ListingSearchFieldPartsFragmentDoc = `
    fragment ListingSearchFieldParts on Field {
  aliases
  colName: col_name
  id
}
    `;
export const ServiceAdapterFieldsFragmentDoc = `
    fragment serviceAdapterFields on ServiceAdapter {
  id
  adapter {
    id
    key
    recordCounts: record_counts {
      today
      listings
      agents
      offices
    }
  }
}
    `;
export const ListingServicesListingServiceFragmentDoc = `
    fragment ListingServicesListingService on ListingService {
  id
  key
  name
  lat
  lon
  address
  state
  activations(limit: 10000) {
    id
    apiUser: api_user {
      id
      name
    }
  }
}
    `;
export const OfficeSearchResultFragmentDoc = `
    fragment OfficeSearchResult on OfficeResultType {
  email
  id
  name
  office_id
  phone
  updated_at
  active
  wr_resource_id
  raw_data {
    serialized
    raw
  }
}
    `;
export const OfficeSearchFieldPartsFragmentDoc = `
    fragment OfficeSearchFieldParts on Field {
  aliases
  colName: col_name
  id
}
    `;
export const AdapterResourceGroupFragmentDoc = `
    fragment AdapterResourceGroup on ResourceGroup {
  id
  uid
  role
  version
  indexData: index_data
  searchData: search_data
  auditData: audit_data
  skipPhotos: skip_photos
  status
  needsSetup: needs_setup
  loadingProgress: loading_progress
  deletesStatus: deletes_status {
    lastPurge: last_purge
    pending
    status
    total
  }
  resources {
    id
    name
    populateStatus: populate_status
    updateData: update_data
  }
}
    `;
export const FieldCategoryPartsFragmentDoc = `
    fragment FieldCategoryParts on FieldCategory {
  id
  name
}
    `;
export const AdapterResourceGroupFieldsFragmentDoc = `
    fragment AdapterResourceGroupFields on ResourceGroup {
  id
  role
  updatesByHour: updates_by_hour
  status
  loadingProgress: loading_progress
  skipPhotos: skip_photos
  replication
  replicationLag: replication_lag
  fieldCategories: field_categories {
    ...FieldCategoryParts
  }
  deletesStatus: deletes_status {
    total
    pending
    last_purge
  }
  resources {
    resourceGroupId: resource_group_id
    id
    name
    updateData: update_data
  }
  possibleSources: possible_sources {
    label
    value
  }
  adapter {
    id
    adapterType: adapter_type
    updateDom: update_dom
    resources {
      id
      name
      resourceGroupId: resource_group_id
    }
    resourceGroups: resource_groups {
      possibleSources: possible_sources {
        label
        value
      }
    }
  }
  uniqueIdField: unique_id_field
  updatedAtField: updated_at_field
  trackFields: track_fields
  populateDateField: populate_date_field
  photosUpdatedAtField: photos_updated_at_field
  photoStrategy: photo_strategy
  photoSettings: photo_settings {
    listingIdField: listing_id_field
    objectType: object_type
    orderField: order_field
    photosCountField: photos_count_field
    photosUpdatedAtField: photos_updated_at_field
    resource: resource
    resourceId: resource_id
    urlField: url_field
  }
  purgeListingsAutomatically: purge_listings_automatically
  domCalculationV2: dom_calculation_v2
  reverseAuditInterval: reverse_audit_interval
}
    ${FieldCategoryPartsFragmentDoc}`;
export const ResourceGroupFieldsSearchValuesPartsFragmentDoc = `
    fragment ResourceGroupFieldsSearchValuesParts on Field {
  id
  aliases
  colName: col_name
  searchDisplay: search_display
  searchValues: search_values @include(if: $includeSearchValues)
}
    `;
export const ResourceGroupFieldPartsFragmentDoc = `
    fragment ResourceGroupFieldParts on Field {
  id
  aliases
  calculateDom: calculate_dom
  colName: col_name
  colType: col_type
  displayName: display_name
  fieldCategory: field_category {
    id
    name
  }
  fieldCategoryId: field_category_id
  isDraft: is_draft
  pendingChanges: pending_changes {
    aliases
    colName: col_name
    colType: col_type
    compose
    displayName: display_name
    fieldCategory: field_category {
      id
      name
      resourceGroupId: resource_group_id
    }
    fieldCategoryId: field_category_id
    mapValue: map_values
    queryable
    autocomplete
    calculateDom: calculate_dom
    sourceNames: source_names
  }
  queryable
  searchDisplay: search_display
  sourceNames: source_names
}
    `;
export const DefaultSchemaDocument = `
    query DefaultSchema($role: ResourceGroupRole) {
  defaultSchema: default_schema(role: $role) {
    ...DefaultSchemaParts
  }
}
    ${DefaultSchemaPartsFragmentDoc}`;
export const useDefaultSchemaQuery = <
      TData = DefaultSchemaQuery,
      TError = Error
    >(
      variables?: DefaultSchemaQueryVariables,
      options?: UseQueryOptions<DefaultSchemaQuery, TError, TData>
    ) =>
    useQuery<DefaultSchemaQuery, TError, TData>(
      variables === undefined ? ['DefaultSchema'] : ['DefaultSchema', variables],
      fetcher<DefaultSchemaQuery, DefaultSchemaQueryVariables>(DefaultSchemaDocument, variables),
      options
    );

useDefaultSchemaQuery.getKey = (variables?: DefaultSchemaQueryVariables) => variables === undefined ? ['DefaultSchema'] : ['DefaultSchema', variables];
;

export const AdapterDocument = `
    query Adapter($id: ID) {
  adapter(id: $id) {
    ...adapterFields
    updatesByHour: updates_by_hour
    alarms(active: true) {
      id
      description
      createdAtIso: created_at_iso
    }
    resourceGroups: resource_groups {
      id
      role
      status
      indexData: index_data
    }
    resources {
      id
      name
    }
    listingServices: listing_services {
      id
      key
      name
      address
      timeZone: time_zone
      lat
      lon
      state
      defaultSearch: default_search
      flags {
        key
        value
      }
      activations(limit: 10000) {
        id
        apiUser: api_user {
          id
          name
        }
      }
    }
  }
}
    ${AdapterFieldsFragmentDoc}`;
export const useAdapterQuery = <
      TData = AdapterQuery,
      TError = Error
    >(
      variables?: AdapterQueryVariables,
      options?: UseQueryOptions<AdapterQuery, TError, TData>
    ) =>
    useQuery<AdapterQuery, TError, TData>(
      variables === undefined ? ['Adapter'] : ['Adapter', variables],
      fetcher<AdapterQuery, AdapterQueryVariables>(AdapterDocument, variables),
      options
    );

useAdapterQuery.getKey = (variables?: AdapterQueryVariables) => variables === undefined ? ['Adapter'] : ['Adapter', variables];
;

export const CreateAdapterDocument = `
    mutation CreateAdapter($key: String!, $url: String, $username: String, $password: String, $retsVersion: String, $status: AdapterStatus!, $requestTimeZone: String, $responseTimeZone: String, $adapterType: AdapterAdapterType, $userAgent: String, $userAgentPassword: String, $authEndpoint: String, $scope: String, $grantType: AdapterGrantType, $updateDom: Boolean, $useJwtAuth: Boolean, $resourceBasicAuth: Boolean, $useReplicationEndpoint: Boolean, $replicationPrefix: Boolean) {
  createAdapter(
    key: $key
    url: $url
    username: $username
    password: $password
    rets_version: $retsVersion
    status: $status
    user_agent: $userAgent
    user_agent_password: $userAgentPassword
    request_time_zone: $requestTimeZone
    response_time_zone: $responseTimeZone
    adapter_type: $adapterType
    auth_endpoint: $authEndpoint
    scope: $scope
    update_dom: $updateDom
    use_jwt_auth: $useJwtAuth
    grant_type: $grantType
    resource_basic_auth: $resourceBasicAuth
    use_replication_endpoint: $useReplicationEndpoint
    replication_prefix: $replicationPrefix
  ) {
    ...adapterFields
  }
}
    ${AdapterFieldsFragmentDoc}`;
export const useCreateAdapterMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateAdapterMutation, TError, CreateAdapterMutationVariables, TContext>) =>
    useMutation<CreateAdapterMutation, TError, CreateAdapterMutationVariables, TContext>(
      ['CreateAdapter'],
      (variables?: CreateAdapterMutationVariables) => fetcher<CreateAdapterMutation, CreateAdapterMutationVariables>(CreateAdapterDocument, variables)(),
      options
    );
export const AdapterHealthDocument = `
    query AdapterHealth($adapterId: ID!) {
  adapter(id: $adapterId) {
    health {
      consumers
      sync
      audit
      auditResolution: audit_resolution
      weeklyAudit: weekly_audit
      monthlyAudit: monthly_audit
    }
  }
}
    `;
export const useAdapterHealthQuery = <
      TData = AdapterHealthQuery,
      TError = Error
    >(
      variables: AdapterHealthQueryVariables,
      options?: UseQueryOptions<AdapterHealthQuery, TError, TData>
    ) =>
    useQuery<AdapterHealthQuery, TError, TData>(
      ['AdapterHealth', variables],
      fetcher<AdapterHealthQuery, AdapterHealthQueryVariables>(AdapterHealthDocument, variables),
      options
    );

useAdapterHealthQuery.getKey = (variables: AdapterHealthQueryVariables) => ['AdapterHealth', variables];
;

export const AdapterMetadataDocument = `
    query AdapterMetadata($id: ID) {
  adapter(id: $id) {
    metadata {
      ...MetadataFields
    }
  }
}
    ${MetadataFieldsFragmentDoc}`;
export const useAdapterMetadataQuery = <
      TData = AdapterMetadataQuery,
      TError = Error
    >(
      variables?: AdapterMetadataQueryVariables,
      options?: UseQueryOptions<AdapterMetadataQuery, TError, TData>
    ) =>
    useQuery<AdapterMetadataQuery, TError, TData>(
      variables === undefined ? ['AdapterMetadata'] : ['AdapterMetadata', variables],
      fetcher<AdapterMetadataQuery, AdapterMetadataQueryVariables>(AdapterMetadataDocument, variables),
      options
    );

useAdapterMetadataQuery.getKey = (variables?: AdapterMetadataQueryVariables) => variables === undefined ? ['AdapterMetadata'] : ['AdapterMetadata', variables];
;

export const StopStatDocument = `
    mutation stopStat($id: ID!) {
  updateStat(id: $id, status: stopped) {
    ...statFields
  }
}
    ${StatFieldsFragmentDoc}`;
export const useStopStatMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<StopStatMutation, TError, StopStatMutationVariables, TContext>) =>
    useMutation<StopStatMutation, TError, StopStatMutationVariables, TContext>(
      ['stopStat'],
      (variables?: StopStatMutationVariables) => fetcher<StopStatMutation, StopStatMutationVariables>(StopStatDocument, variables)(),
      options
    );
export const AdapterStatsDocument = `
    query AdapterStats($id: ID!, $limit: Int, $page: Int) {
  adapterStats: adapter(id: $id) {
    id
    currentJob: current_job
    currentInProgress: current_in_progress {
      ...statFields
    }
    aggregatedStats: aggregated_stats(page: $page, limit: $limit) {
      ...statFields
    }
  }
}
    ${StatFieldsFragmentDoc}`;
export const useAdapterStatsQuery = <
      TData = AdapterStatsQuery,
      TError = Error
    >(
      variables: AdapterStatsQueryVariables,
      options?: UseQueryOptions<AdapterStatsQuery, TError, TData>
    ) =>
    useQuery<AdapterStatsQuery, TError, TData>(
      ['AdapterStats', variables],
      fetcher<AdapterStatsQuery, AdapterStatsQueryVariables>(AdapterStatsDocument, variables),
      options
    );

useAdapterStatsQuery.getKey = (variables: AdapterStatsQueryVariables) => ['AdapterStats', variables];
;

export const AdapterTimestampsDocument = `
    query AdapterTimestamps($resourceId: ID!) {
  adapterTimestamps: modification_timestamps(id: $resourceId) {
    oldestTimestamp: oldest_timestamp
    newestTimestamp: newest_timestamp
    timestampVariance: timestamp_variance
    totalRecords: total_records
    recommendedRequestTimezone: recommended_request_timezone
    recommendedResponseTimezone: recommended_response_timezone
  }
}
    `;
export const useAdapterTimestampsQuery = <
      TData = AdapterTimestampsQuery,
      TError = Error
    >(
      variables: AdapterTimestampsQueryVariables,
      options?: UseQueryOptions<AdapterTimestampsQuery, TError, TData>
    ) =>
    useQuery<AdapterTimestampsQuery, TError, TData>(
      ['AdapterTimestamps', variables],
      fetcher<AdapterTimestampsQuery, AdapterTimestampsQueryVariables>(AdapterTimestampsDocument, variables),
      options
    );

useAdapterTimestampsQuery.getKey = (variables: AdapterTimestampsQueryVariables) => ['AdapterTimestamps', variables];
;

export const AdaptersDocument = `
    query Adapters($limit: Int, $page: Int, $status: AdapterStatus) {
  adapters(limit: $limit, page: $page, status: $status) {
    id
    key
    status
    adapterType: adapter_type
    currentJob: current_job
  }
}
    `;
export const useAdaptersQuery = <
      TData = AdaptersQuery,
      TError = Error
    >(
      variables?: AdaptersQueryVariables,
      options?: UseQueryOptions<AdaptersQuery, TError, TData>
    ) =>
    useQuery<AdaptersQuery, TError, TData>(
      variables === undefined ? ['Adapters'] : ['Adapters', variables],
      fetcher<AdaptersQuery, AdaptersQueryVariables>(AdaptersDocument, variables),
      options
    );

useAdaptersQuery.getKey = (variables?: AdaptersQueryVariables) => variables === undefined ? ['Adapters'] : ['Adapters', variables];
;

export const AlarmProfileDocument = `
    query AlarmProfile($alarmProfileId: ID) {
  alarmProfile: alarm_profile(id: $alarmProfileId) {
    id
    name
    status
    role
    job
    jobStatus: job_status
    field
    operation
    maxThreshold: max_threshold
    minThreshold: min_threshold
    duration
  }
}
    `;
export const useAlarmProfileQuery = <
      TData = AlarmProfileQuery,
      TError = Error
    >(
      variables?: AlarmProfileQueryVariables,
      options?: UseQueryOptions<AlarmProfileQuery, TError, TData>
    ) =>
    useQuery<AlarmProfileQuery, TError, TData>(
      variables === undefined ? ['AlarmProfile'] : ['AlarmProfile', variables],
      fetcher<AlarmProfileQuery, AlarmProfileQueryVariables>(AlarmProfileDocument, variables),
      options
    );

useAlarmProfileQuery.getKey = (variables?: AlarmProfileQueryVariables) => variables === undefined ? ['AlarmProfile'] : ['AlarmProfile', variables];
;

export const AlarmProfilesDocument = `
    query AlarmProfiles($adapterId: Int) {
  alarmProfiles: alarm_profiles(adapter_id: $adapterId) {
    id
    name
    explain
    status
  }
}
    `;
export const useAlarmProfilesQuery = <
      TData = AlarmProfilesQuery,
      TError = Error
    >(
      variables?: AlarmProfilesQueryVariables,
      options?: UseQueryOptions<AlarmProfilesQuery, TError, TData>
    ) =>
    useQuery<AlarmProfilesQuery, TError, TData>(
      variables === undefined ? ['AlarmProfiles'] : ['AlarmProfiles', variables],
      fetcher<AlarmProfilesQuery, AlarmProfilesQueryVariables>(AlarmProfilesDocument, variables),
      options
    );

useAlarmProfilesQuery.getKey = (variables?: AlarmProfilesQueryVariables) => variables === undefined ? ['AlarmProfiles'] : ['AlarmProfiles', variables];
;

export const CreateAlarmProfileDocument = `
    mutation CreateAlarmProfile($adapterId: Int, $duration: Int, $field: AlarmProfileField, $job: AlarmProfileJob, $jobStatus: AlarmProfileJobStatus, $maxThreshold: Int, $minThreshold: Int, $name: String, $operation: AlarmProfileOperation, $role: AlarmProfileRole, $status: AlarmProfileStatus) {
  createAlarmProfile(
    adapter_id: $adapterId
    duration: $duration
    field: $field
    job: $job
    job_status: $jobStatus
    max_threshold: $maxThreshold
    min_threshold: $minThreshold
    name: $name
    operation: $operation
    role: $role
    status: $status
  ) {
    id
  }
}
    `;
export const useCreateAlarmProfileMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateAlarmProfileMutation, TError, CreateAlarmProfileMutationVariables, TContext>) =>
    useMutation<CreateAlarmProfileMutation, TError, CreateAlarmProfileMutationVariables, TContext>(
      ['CreateAlarmProfile'],
      (variables?: CreateAlarmProfileMutationVariables) => fetcher<CreateAlarmProfileMutation, CreateAlarmProfileMutationVariables>(CreateAlarmProfileDocument, variables)(),
      options
    );
export const DeleteAdapterDocument = `
    mutation deleteAdapter($id: ID!) {
  deleteAdapter(id: $id)
}
    `;
export const useDeleteAdapterMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteAdapterMutation, TError, DeleteAdapterMutationVariables, TContext>) =>
    useMutation<DeleteAdapterMutation, TError, DeleteAdapterMutationVariables, TContext>(
      ['deleteAdapter'],
      (variables?: DeleteAdapterMutationVariables) => fetcher<DeleteAdapterMutation, DeleteAdapterMutationVariables>(DeleteAdapterDocument, variables)(),
      options
    );
export const DeleteAlarmProfileDocument = `
    mutation DeleteAlarmProfile($id: ID!) {
  deleteAlarmProfile(id: $id)
}
    `;
export const useDeleteAlarmProfileMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteAlarmProfileMutation, TError, DeleteAlarmProfileMutationVariables, TContext>) =>
    useMutation<DeleteAlarmProfileMutation, TError, DeleteAlarmProfileMutationVariables, TContext>(
      ['DeleteAlarmProfile'],
      (variables?: DeleteAlarmProfileMutationVariables) => fetcher<DeleteAlarmProfileMutation, DeleteAlarmProfileMutationVariables>(DeleteAlarmProfileDocument, variables)(),
      options
    );
export const ResourceDebugDocument = `
    query ResourceDebug($adapterId: ID, $resourceId: ID) {
  adapter(id: $adapterId) {
    resources(id: $resourceId) {
      debug {
        error {
          request
          response
        }
        debugResult: debug_result {
          acres
          address
          agentList: agent_list {
            email
            id
            name
            phone
            agentId: agent_id
          }
          agentSell: agent_sell {
            id
            name
            phone
            agentId: agent_id
            email
          }
          area
          assocFee: assoc_fee
          baths
          bathsFull: baths_full
          bathsHalf: baths_half
          bathsQuarter: baths_quarter
          bathsSearch: baths_search
          bathsThreeQuarter: baths_three_quarter
          beds
          cdom
          changes
          city
          county
          createdAt: created_at
          dateExpired: date_expired
          dateList: date_list
          dateOffMarket: date_offmarket
          datePending: date_pending
          dateSold: date_sold
          directions
          dom
          featureCategories: feature_categories
          features
          featuresStoriesTotal: features_stories_total
          fullAddress: full_address
          garages
          gpsLoc: gps_loc
          lat
          location
          lockboxLocation: lockbox_location
          lockboxType: lockbox_type
          lon
          lotdim
          lotsize
          mappedPropType: mapped_prop_type
          mappedStatus: mapped_status
          mlsnum
          officeList: office_list {
            email
            id
            name
            phone
          }
          officeSell: office_sell {
            email
            id
            name
            phone
          }
          parcel
          photoCount: photo_count
          photos
          photosUpdatedAt: photos_updated_at
          price
          priceList: price_list
          priceListLow: price_list_low
          priceListOrig: price_list_orig
          priceListPerSqft: price_list_per_sqft
          priceSold: price_sold
          priceSoldPerSqft: price_sold_per_sqft
          propSubType: prop_sub_type
          propType: prop_type
          rawData: raw_data {
            raw
            serialized
          }
          remarks
          remarksPrivate: remarks_private
          saleRent: sale_rent
          schoolDistrict: school_district
          schoolElementary: school_elementary
          schoolHigh: school_high
          schoolMiddle: school_middle
          showingInst: showing_inst
          sqft
          sqftFields: sqft_fields
          sqftSource: sqft_source
          sqftTotal: sqft_total
          state
          status
          streetname
          streetnum
          style
          subdivision
          taxes
          unit
          updated_at
          wrResourceId: wr_resource_id
          yearBuilt: year_built
          zip
          zipcode
        }
      }
    }
  }
}
    `;
export const useResourceDebugQuery = <
      TData = ResourceDebugQuery,
      TError = Error
    >(
      variables?: ResourceDebugQueryVariables,
      options?: UseQueryOptions<ResourceDebugQuery, TError, TData>
    ) =>
    useQuery<ResourceDebugQuery, TError, TData>(
      variables === undefined ? ['ResourceDebug'] : ['ResourceDebug', variables],
      fetcher<ResourceDebugQuery, ResourceDebugQueryVariables>(ResourceDebugDocument, variables),
      options
    );

useResourceDebugQuery.getKey = (variables?: ResourceDebugQueryVariables) => variables === undefined ? ['ResourceDebug'] : ['ResourceDebug', variables];
;

export const UpdateAdapterDocument = `
    mutation updateAdapter($id: ID!, $key: String, $url: String, $username: String, $password: String, $retsVersion: String, $status: AdapterStatus, $adapterType: AdapterAdapterType, $userAgent: String, $userAgentPassword: String, $requestTimeZone: String, $responseTimeZone: String, $authEndpoint: String, $grantType: AdapterGrantType, $scope: String, $updateDom: Boolean, $esStatus: AdapterEsStatus, $useJwtAuth: Boolean, $resourceBasicAuth: Boolean, $useReplicationEndpoint: Boolean, $replicationPrefix: Boolean) {
  updateAdapter(
    id: $id
    key: $key
    url: $url
    username: $username
    password: $password
    rets_version: $retsVersion
    status: $status
    adapter_type: $adapterType
    user_agent: $userAgent
    user_agent_password: $userAgentPassword
    request_time_zone: $requestTimeZone
    response_time_zone: $responseTimeZone
    auth_endpoint: $authEndpoint
    scope: $scope
    update_dom: $updateDom
    es_status: $esStatus
    use_jwt_auth: $useJwtAuth
    grant_type: $grantType
    resource_basic_auth: $resourceBasicAuth
    use_replication_endpoint: $useReplicationEndpoint
    replication_prefix: $replicationPrefix
  ) {
    id
    adapterType: adapter_type
    key
    url
    username
    password
    retsversion: rets_version
    status
    userAgent: user_agent
    userAgentPassword: user_agent_password
    requestTimeZone: request_time_zone
    responseTimeZone: response_time_zone
    authEndPoint: auth_endpoint
    scope
    updateDom: update_dom
    esStatus: es_status
    recordCounts: record_counts {
      today
      listings
      agents
      offices
    }
    useJwtAuth: use_jwt_auth
    grantType: grant_type
    resourceBasicAuth: resource_basic_auth
    useReplicationEndpoint: use_replication_endpoint
    replicationPrefix: replication_prefix
  }
}
    `;
export const useUpdateAdapterMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAdapterMutation, TError, UpdateAdapterMutationVariables, TContext>) =>
    useMutation<UpdateAdapterMutation, TError, UpdateAdapterMutationVariables, TContext>(
      ['updateAdapter'],
      (variables?: UpdateAdapterMutationVariables) => fetcher<UpdateAdapterMutation, UpdateAdapterMutationVariables>(UpdateAdapterDocument, variables)(),
      options
    );
export const UpdateAlarmProfileDocument = `
    mutation UpdateAlarmProfile($alarmProfileId: ID!, $adapterId: Int, $duration: Int, $field: AlarmProfileField, $job: AlarmProfileJob, $jobStatus: AlarmProfileJobStatus, $maxThreshold: Int, $minThreshold: Int, $name: String, $operation: AlarmProfileOperation, $role: AlarmProfileRole, $status: AlarmProfileStatus) {
  updateAlarmProfile(
    id: $alarmProfileId
    adapter_id: $adapterId
    duration: $duration
    field: $field
    job: $job
    job_status: $jobStatus
    max_threshold: $maxThreshold
    min_threshold: $minThreshold
    name: $name
    operation: $operation
    role: $role
    status: $status
  ) {
    id
  }
}
    `;
export const useUpdateAlarmProfileMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAlarmProfileMutation, TError, UpdateAlarmProfileMutationVariables, TContext>) =>
    useMutation<UpdateAlarmProfileMutation, TError, UpdateAlarmProfileMutationVariables, TContext>(
      ['UpdateAlarmProfile'],
      (variables?: UpdateAlarmProfileMutationVariables) => fetcher<UpdateAlarmProfileMutation, UpdateAlarmProfileMutationVariables>(UpdateAlarmProfileDocument, variables)(),
      options
    );
export const AdminUserDocument = `
    query AdminUser($id: ID) {
  admin(id: $id) {
    id
    name
    email
    phone
    role
    alerts
    timezone
  }
}
    `;
export const useAdminUserQuery = <
      TData = AdminUserQuery,
      TError = Error
    >(
      variables?: AdminUserQueryVariables,
      options?: UseQueryOptions<AdminUserQuery, TError, TData>
    ) =>
    useQuery<AdminUserQuery, TError, TData>(
      variables === undefined ? ['AdminUser'] : ['AdminUser', variables],
      fetcher<AdminUserQuery, AdminUserQueryVariables>(AdminUserDocument, variables),
      options
    );

useAdminUserQuery.getKey = (variables?: AdminUserQueryVariables) => variables === undefined ? ['AdminUser'] : ['AdminUser', variables];
;

export const AdminsDocument = `
    query Admins {
  admins(limit: 1000) {
    ...AdminFields
  }
}
    ${AdminFieldsFragmentDoc}`;
export const useAdminsQuery = <
      TData = AdminsQuery,
      TError = Error
    >(
      variables?: AdminsQueryVariables,
      options?: UseQueryOptions<AdminsQuery, TError, TData>
    ) =>
    useQuery<AdminsQuery, TError, TData>(
      variables === undefined ? ['Admins'] : ['Admins', variables],
      fetcher<AdminsQuery, AdminsQueryVariables>(AdminsDocument, variables),
      options
    );

useAdminsQuery.getKey = (variables?: AdminsQueryVariables) => variables === undefined ? ['Admins'] : ['Admins', variables];
;

export const CreateAdminDocument = `
    mutation CreateAdmin($name: String!, $email: String!, $phone: String, $title: String, $timezone: String, $role: AdminRole!, $alerts: Boolean) {
  createAdmin(
    name: $name
    email: $email
    phone: $phone
    title: $title
    timezone: $timezone
    role: $role
    alerts: $alerts
  ) {
    id
  }
}
    `;
export const useCreateAdminMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateAdminMutation, TError, CreateAdminMutationVariables, TContext>) =>
    useMutation<CreateAdminMutation, TError, CreateAdminMutationVariables, TContext>(
      ['CreateAdmin'],
      (variables?: CreateAdminMutationVariables) => fetcher<CreateAdminMutation, CreateAdminMutationVariables>(CreateAdminDocument, variables)(),
      options
    );
export const DeleteAdminDocument = `
    mutation deleteAdmin($id: ID!) {
  deleteAdmin(id: $id)
}
    `;
export const useDeleteAdminMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteAdminMutation, TError, DeleteAdminMutationVariables, TContext>) =>
    useMutation<DeleteAdminMutation, TError, DeleteAdminMutationVariables, TContext>(
      ['deleteAdmin'],
      (variables?: DeleteAdminMutationVariables) => fetcher<DeleteAdminMutation, DeleteAdminMutationVariables>(DeleteAdminDocument, variables)(),
      options
    );
export const UpdateAdminDocument = `
    mutation updateAdmin($id: ID!, $name: String, $email: String, $phone: String, $title: String, $resetToken: String, $timezone: String, $role: AdminRole, $alerts: Boolean, $password: String, $passwordConfirmation: String) {
  updateAdmin(
    id: $id
    name: $name
    email: $email
    phone: $phone
    title: $title
    reset_token: $resetToken
    timezone: $timezone
    role: $role
    alerts: $alerts
    password: $password
    password_confirmation: $passwordConfirmation
  ) {
    id
  }
}
    `;
export const useUpdateAdminMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAdminMutation, TError, UpdateAdminMutationVariables, TContext>) =>
    useMutation<UpdateAdminMutation, TError, UpdateAdminMutationVariables, TContext>(
      ['updateAdmin'],
      (variables?: UpdateAdminMutationVariables) => fetcher<UpdateAdminMutation, UpdateAdminMutationVariables>(UpdateAdminDocument, variables)(),
      options
    );
export const AgentSearchDocument = `
    query AgentSearch($id: ID!, $limit: Int, $page: Int, $filter: [FilterQueryType], $sort: QuerySortType, $source: String) {
  agentRg: resource_group(id: $id) {
    id
    agents(
      limit: $limit
      page: $page
      filter: $filter
      sort: $sort
      source: $source
    ) {
      count
      explain
      results {
        ...AgentSearchResult
      }
    }
  }
  resourceGroupFieldsSearchValues: resource_group(id: $id) {
    id
    fields(limit: 10000) {
      ...AgentSearchFieldParts
    }
  }
}
    ${AgentSearchResultFragmentDoc}
${AgentSearchFieldPartsFragmentDoc}`;
export const useAgentSearchQuery = <
      TData = AgentSearchQuery,
      TError = Error
    >(
      variables: AgentSearchQueryVariables,
      options?: UseQueryOptions<AgentSearchQuery, TError, TData>
    ) =>
    useQuery<AgentSearchQuery, TError, TData>(
      ['AgentSearch', variables],
      fetcher<AgentSearchQuery, AgentSearchQueryVariables>(AgentSearchDocument, variables),
      options
    );

useAgentSearchQuery.getKey = (variables: AgentSearchQueryVariables) => ['AgentSearch', variables];
;

export const ApiUserDocument = `
    query ApiUser($id: ID) {
  apiUser: api_user(id: $id) {
    ...apiUserFields
  }
}
    ${ApiUserFieldsFragmentDoc}`;
export const useApiUserQuery = <
      TData = ApiUserQuery,
      TError = Error
    >(
      variables?: ApiUserQueryVariables,
      options?: UseQueryOptions<ApiUserQuery, TError, TData>
    ) =>
    useQuery<ApiUserQuery, TError, TData>(
      variables === undefined ? ['ApiUser'] : ['ApiUser', variables],
      fetcher<ApiUserQuery, ApiUserQueryVariables>(ApiUserDocument, variables),
      options
    );

useApiUserQuery.getKey = (variables?: ApiUserQueryVariables) => variables === undefined ? ['ApiUser'] : ['ApiUser', variables];
;

export const ApiUsersDocument = `
    query ApiUsers {
  apiUsers: api_users(limit: 100) {
    id
    name
    apiKey: api_key
    search
    replication
    forgeApi: forge_api
    jwt
    environment
    percolatorNotification: percolator_notifications
    percolatorEndpoint: percolator_endpoint
    activations {
      id
      createdAtIso: created_at_iso
      listingService: listing_service {
        id
        key
        name
      }
    }
  }
}
    `;
export const useApiUsersQuery = <
      TData = ApiUsersQuery,
      TError = Error
    >(
      variables?: ApiUsersQueryVariables,
      options?: UseQueryOptions<ApiUsersQuery, TError, TData>
    ) =>
    useQuery<ApiUsersQuery, TError, TData>(
      variables === undefined ? ['ApiUsers'] : ['ApiUsers', variables],
      fetcher<ApiUsersQuery, ApiUsersQueryVariables>(ApiUsersDocument, variables),
      options
    );

useApiUsersQuery.getKey = (variables?: ApiUsersQueryVariables) => variables === undefined ? ['ApiUsers'] : ['ApiUsers', variables];
;

export const CreateApiUserDocument = `
    mutation createApiUser($name: String, $apiKey: String!, $password: String, $environment: ApiUserEnvironment, $percolatorNotifications: ApiUserPercolatorNotification, $percolatorEndpoint: String) {
  createApiUser(
    name: $name
    api_key: $apiKey
    password: $password
    environment: $environment
    percolator_notifications: $percolatorNotifications
    percolator_endpoint: $percolatorEndpoint
  ) {
    id
    name
    apiKey: api_key
    updatedAt: updated_at
  }
}
    `;
export const useCreateApiUserMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateApiUserMutation, TError, CreateApiUserMutationVariables, TContext>) =>
    useMutation<CreateApiUserMutation, TError, CreateApiUserMutationVariables, TContext>(
      ['createApiUser'],
      (variables?: CreateApiUserMutationVariables) => fetcher<CreateApiUserMutation, CreateApiUserMutationVariables>(CreateApiUserDocument, variables)(),
      options
    );
export const DeleteApiUserDocument = `
    mutation deleteApiUser($id: ID!) {
  deleteApiUser(id: $id)
}
    `;
export const useDeleteApiUserMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteApiUserMutation, TError, DeleteApiUserMutationVariables, TContext>) =>
    useMutation<DeleteApiUserMutation, TError, DeleteApiUserMutationVariables, TContext>(
      ['deleteApiUser'],
      (variables?: DeleteApiUserMutationVariables) => fetcher<DeleteApiUserMutation, DeleteApiUserMutationVariables>(DeleteApiUserDocument, variables)(),
      options
    );
export const UpdateApiUserDocument = `
    mutation updateApiUser($id: ID!, $name: String, $search: Boolean, $replication: Boolean, $forgeApi: Boolean, $fullAccess: Boolean, $environment: ApiUserEnvironment, $percolatorNotifications: ApiUserPercolatorNotification, $percolatorEndpoint: String) {
  updateApiUser(
    id: $id
    name: $name
    search: $search
    replication: $replication
    forge_api: $forgeApi
    full_access: $fullAccess
    environment: $environment
    percolator_notifications: $percolatorNotifications
    percolator_endpoint: $percolatorEndpoint
  ) {
    ...apiUserFields
  }
}
    ${ApiUserFieldsFragmentDoc}`;
export const useUpdateApiUserMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateApiUserMutation, TError, UpdateApiUserMutationVariables, TContext>) =>
    useMutation<UpdateApiUserMutation, TError, UpdateApiUserMutationVariables, TContext>(
      ['updateApiUser'],
      (variables?: UpdateApiUserMutationVariables) => fetcher<UpdateApiUserMutation, UpdateApiUserMutationVariables>(UpdateApiUserDocument, variables)(),
      options
    );
export const CurrentUserDocument = `
    query CurrentUser {
  adapters(limit: 0) {
    id
  }
}
    `;
export const useCurrentUserQuery = <
      TData = CurrentUserQuery,
      TError = Error
    >(
      variables?: CurrentUserQueryVariables,
      options?: UseQueryOptions<CurrentUserQuery, TError, TData>
    ) =>
    useQuery<CurrentUserQuery, TError, TData>(
      variables === undefined ? ['CurrentUser'] : ['CurrentUser', variables],
      fetcher<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, variables),
      options
    );

useCurrentUserQuery.getKey = (variables?: CurrentUserQueryVariables) => variables === undefined ? ['CurrentUser'] : ['CurrentUser', variables];
;

export const LoginDocument = `
    mutation Login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    token
    admin {
      ...AdminUser
    }
  }
}
    ${AdminUserFragmentDoc}`;
export const useLoginMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<LoginMutation, TError, LoginMutationVariables, TContext>) =>
    useMutation<LoginMutation, TError, LoginMutationVariables, TContext>(
      ['Login'],
      (variables?: LoginMutationVariables) => fetcher<LoginMutation, LoginMutationVariables>(LoginDocument, variables)(),
      options
    );
export const ResetPasswordDocument = `
    mutation resetPassword($resetToken: String!, $password: String!, $passwordConfirmation: String!) {
  resetPassword(
    reset_token: $resetToken
    password: $password
    password_confirmation: $passwordConfirmation
  ) {
    id
    email
    name
    phone
    role
  }
}
    `;
export const useResetPasswordMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>) =>
    useMutation<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>(
      ['resetPassword'],
      (variables?: ResetPasswordMutationVariables) => fetcher<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, variables)(),
      options
    );
export const DashboardAlarmsDocument = `
    query DashboardAlarms($active: Boolean) {
  alarms(active: $active, limit: 1000) {
    id
    active
    description
    createdAtIso: created_at_iso
    clearedAtIso: cleared_at_iso
    urlPath: url_path
    alarmable {
      __typename
      ... on Adapter {
        id
        key
      }
      ... on ListingService {
        id
        key
      }
    }
  }
}
    `;
export const useDashboardAlarmsQuery = <
      TData = DashboardAlarmsQuery,
      TError = Error
    >(
      variables?: DashboardAlarmsQueryVariables,
      options?: UseQueryOptions<DashboardAlarmsQuery, TError, TData>
    ) =>
    useQuery<DashboardAlarmsQuery, TError, TData>(
      variables === undefined ? ['DashboardAlarms'] : ['DashboardAlarms', variables],
      fetcher<DashboardAlarmsQuery, DashboardAlarmsQueryVariables>(DashboardAlarmsDocument, variables),
      options
    );

useDashboardAlarmsQuery.getKey = (variables?: DashboardAlarmsQueryVariables) => variables === undefined ? ['DashboardAlarms'] : ['DashboardAlarms', variables];
;

export const GlobalCountsDocument = `
    query GlobalCounts {
  counts: global_counts {
    adapters
    listingServices: listing_services
    updatesToday: updates_today
    listings
    agents
    offices
  }
}
    `;
export const useGlobalCountsQuery = <
      TData = GlobalCountsQuery,
      TError = Error
    >(
      variables?: GlobalCountsQueryVariables,
      options?: UseQueryOptions<GlobalCountsQuery, TError, TData>
    ) =>
    useQuery<GlobalCountsQuery, TError, TData>(
      variables === undefined ? ['GlobalCounts'] : ['GlobalCounts', variables],
      fetcher<GlobalCountsQuery, GlobalCountsQueryVariables>(GlobalCountsDocument, variables),
      options
    );

useGlobalCountsQuery.getKey = (variables?: GlobalCountsQueryVariables) => variables === undefined ? ['GlobalCounts'] : ['GlobalCounts', variables];
;

export const DashboardResourceGroupsDocument = `
    query DashboardResourceGroups($status: ResourceGroupStatus) {
  resourceGroups: resource_groups(status: $status, limit: 1000) {
    id
    role
    status
    loadingProgress: loading_progress
    adapter {
      id
      key
    }
  }
}
    `;
export const useDashboardResourceGroupsQuery = <
      TData = DashboardResourceGroupsQuery,
      TError = Error
    >(
      variables?: DashboardResourceGroupsQueryVariables,
      options?: UseQueryOptions<DashboardResourceGroupsQuery, TError, TData>
    ) =>
    useQuery<DashboardResourceGroupsQuery, TError, TData>(
      variables === undefined ? ['DashboardResourceGroups'] : ['DashboardResourceGroups', variables],
      fetcher<DashboardResourceGroupsQuery, DashboardResourceGroupsQueryVariables>(DashboardResourceGroupsDocument, variables),
      options
    );

useDashboardResourceGroupsQuery.getKey = (variables?: DashboardResourceGroupsQueryVariables) => variables === undefined ? ['DashboardResourceGroups'] : ['DashboardResourceGroups', variables];
;

export const DashboardStatsByHourDocument = `
    query DashboardStatsByHour($jobs: [String]) {
  statsByHour: stats_by_hour(jobs: $jobs)
}
    `;
export const useDashboardStatsByHourQuery = <
      TData = DashboardStatsByHourQuery,
      TError = Error
    >(
      variables?: DashboardStatsByHourQueryVariables,
      options?: UseQueryOptions<DashboardStatsByHourQuery, TError, TData>
    ) =>
    useQuery<DashboardStatsByHourQuery, TError, TData>(
      variables === undefined ? ['DashboardStatsByHour'] : ['DashboardStatsByHour', variables],
      fetcher<DashboardStatsByHourQuery, DashboardStatsByHourQueryVariables>(DashboardStatsByHourDocument, variables),
      options
    );

useDashboardStatsByHourQuery.getKey = (variables?: DashboardStatsByHourQueryVariables) => variables === undefined ? ['DashboardStatsByHour'] : ['DashboardStatsByHour', variables];
;

export const ResourceGroupsDocument = `
    query ResourceGroups($adapterId: Int, $role: ResourceGroupRole) {
  resourceGroups: resource_groups(adapter_id: $adapterId, role: $role) {
    id
    uid
    role
    version
    indexData: index_data
    searchData: search_data
    auditData: audit_data
    skipPhotos: skip_photos
    status
    needsSetup: needs_setup
    loadingProgress: loading_progress
    deletesStatus: deletes_status {
      total
      pending
      lastPurge: last_purge
    }
    resources {
      resourceGroupId: resource_group_id
      id
      name
      updateData: update_data
      populateStatus: populate_status
      health {
        sync
        audit
        auditResolution: audit_resolution
        weeklyAudit: weekly_audit
        monthlyAudit: monthly_audit
      }
    }
  }
}
    `;
export const useResourceGroupsQuery = <
      TData = ResourceGroupsQuery,
      TError = Error
    >(
      variables?: ResourceGroupsQueryVariables,
      options?: UseQueryOptions<ResourceGroupsQuery, TError, TData>
    ) =>
    useQuery<ResourceGroupsQuery, TError, TData>(
      variables === undefined ? ['ResourceGroups'] : ['ResourceGroups', variables],
      fetcher<ResourceGroupsQuery, ResourceGroupsQueryVariables>(ResourceGroupsDocument, variables),
      options
    );

useResourceGroupsQuery.getKey = (variables?: ResourceGroupsQueryVariables) => variables === undefined ? ['ResourceGroups'] : ['ResourceGroups', variables];
;

export const CreateCriteriaDocument = `
    mutation CreateCriteria($parentId: Int, $parentType: String, $fieldName: String, $value: String, $scope: String, $actionType: String, $casCriterium: Boolean) {
  createDefaultCriterium(
    parent_id: $parentId
    parent_type: $parentType
    field_name: $fieldName
    value: $value
    scope: $scope
    action_type: $actionType
    cas_criterium: $casCriterium
  ) {
    parentId: parent_id
  }
}
    `;
export const useCreateCriteriaMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCriteriaMutation, TError, CreateCriteriaMutationVariables, TContext>) =>
    useMutation<CreateCriteriaMutation, TError, CreateCriteriaMutationVariables, TContext>(
      ['CreateCriteria'],
      (variables?: CreateCriteriaMutationVariables) => fetcher<CreateCriteriaMutation, CreateCriteriaMutationVariables>(CreateCriteriaDocument, variables)(),
      options
    );
export const DeleteCriteriumDocument = `
    mutation DeleteCriterium($id: ID!) {
  deleteDefaultCriterium(id: $id)
}
    `;
export const useDeleteCriteriumMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCriteriumMutation, TError, DeleteCriteriumMutationVariables, TContext>) =>
    useMutation<DeleteCriteriumMutation, TError, DeleteCriteriumMutationVariables, TContext>(
      ['DeleteCriterium'],
      (variables?: DeleteCriteriumMutationVariables) => fetcher<DeleteCriteriumMutation, DeleteCriteriumMutationVariables>(DeleteCriteriumDocument, variables)(),
      options
    );
export const CreateFieldDocument = `
    mutation createField($colName: String!, $colType: ColTypeEnum, $displayName: String, $queryable: Boolean, $autocomplete: Boolean, $calculateDom: Boolean, $fieldCategoryId: Int, $aliases: [String], $sourceNames: [String], $mapValues: FieldMapValue, $compose: Boolean, $standardName: String, $agentOnly: Boolean, $categoryName: String, $subcategoryName: String) {
  createField(
    display_name: $displayName
    col_name: $colName
    col_type: $colType
    aliases: $aliases
    queryable: $queryable
    autocomplete: $autocomplete
    calculate_dom: $calculateDom
    source_names: $sourceNames
    map_values: $mapValues
    field_category_id: $fieldCategoryId
    compose: $compose
    standard_name: $standardName
    agent_only: $agentOnly
    category_name: $categoryName
    subcategory_name: $subcategoryName
  ) {
    ...FieldParts
  }
}
    ${FieldPartsFragmentDoc}`;
export const useCreateFieldMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateFieldMutation, TError, CreateFieldMutationVariables, TContext>) =>
    useMutation<CreateFieldMutation, TError, CreateFieldMutationVariables, TContext>(
      ['createField'],
      (variables?: CreateFieldMutationVariables) => fetcher<CreateFieldMutation, CreateFieldMutationVariables>(CreateFieldDocument, variables)(),
      options
    );
export const DeleteFieldDocument = `
    mutation DeleteField($id: ID!) {
  deleteField(id: $id)
}
    `;
export const useDeleteFieldMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteFieldMutation, TError, DeleteFieldMutationVariables, TContext>) =>
    useMutation<DeleteFieldMutation, TError, DeleteFieldMutationVariables, TContext>(
      ['DeleteField'],
      (variables?: DeleteFieldMutationVariables) => fetcher<DeleteFieldMutation, DeleteFieldMutationVariables>(DeleteFieldDocument, variables)(),
      options
    );
export const FieldDocument = `
    query Field($id: ID!) {
  field(id: $id) {
    ...FieldParts
  }
}
    ${FieldPartsFragmentDoc}`;
export const useFieldQuery = <
      TData = FieldQuery,
      TError = Error
    >(
      variables: FieldQueryVariables,
      options?: UseQueryOptions<FieldQuery, TError, TData>
    ) =>
    useQuery<FieldQuery, TError, TData>(
      ['Field', variables],
      fetcher<FieldQuery, FieldQueryVariables>(FieldDocument, variables),
      options
    );

useFieldQuery.getKey = (variables: FieldQueryVariables) => ['Field', variables];
;

export const UpdateFieldDocument = `
    mutation UpdateField($id: ID!, $colName: String, $colType: ColTypeEnum, $displayName: String, $queryable: Boolean, $autocomplete: Boolean, $calculateDom: Boolean, $fieldCategoryId: Int, $aliases: [String], $sourceNames: [String], $mapValues: FieldMapValue, $compose: Boolean, $standardName: String, $agentOnly: Boolean, $categoryName: String, $subcategoryName: String, $sqft: Boolean) {
  updateField(
    id: $id
    display_name: $displayName
    col_name: $colName
    col_type: $colType
    aliases: $aliases
    queryable: $queryable
    autocomplete: $autocomplete
    calculate_dom: $calculateDom
    source_names: $sourceNames
    map_values: $mapValues
    field_category_id: $fieldCategoryId
    compose: $compose
    standard_name: $standardName
    agent_only: $agentOnly
    category_name: $categoryName
    subcategory_name: $subcategoryName
    sqft: $sqft
  ) {
    id
  }
}
    `;
export const useUpdateFieldMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateFieldMutation, TError, UpdateFieldMutationVariables, TContext>) =>
    useMutation<UpdateFieldMutation, TError, UpdateFieldMutationVariables, TContext>(
      ['UpdateField'],
      (variables?: UpdateFieldMutationVariables) => fetcher<UpdateFieldMutation, UpdateFieldMutationVariables>(UpdateFieldDocument, variables)(),
      options
    );
export const CreateFieldTemplateDocument = `
    mutation createFieldTemplate($recordType: FieldTemplateRecordType, $displayName: String, $name: String!, $fieldType: String!, $aliases: [String], $alternateNames: [String], $fieldCategoryName: FieldTemplateFieldCategoryName) {
  createFieldTemplate(
    display_name: $displayName
    name: $name
    field_type: $fieldType
    aliases: $aliases
    alternate_names: $alternateNames
    field_category_name: $fieldCategoryName
    record_type: $recordType
  ) {
    ...FieldTemplateFields
  }
}
    ${FieldTemplateFieldsFragmentDoc}`;
export const useCreateFieldTemplateMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateFieldTemplateMutation, TError, CreateFieldTemplateMutationVariables, TContext>) =>
    useMutation<CreateFieldTemplateMutation, TError, CreateFieldTemplateMutationVariables, TContext>(
      ['createFieldTemplate'],
      (variables?: CreateFieldTemplateMutationVariables) => fetcher<CreateFieldTemplateMutation, CreateFieldTemplateMutationVariables>(CreateFieldTemplateDocument, variables)(),
      options
    );
export const DeleteFieldTemplateDocument = `
    mutation deleteFieldTemplate($id: ID!) {
  deleteFieldTemplate(id: $id)
}
    `;
export const useDeleteFieldTemplateMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteFieldTemplateMutation, TError, DeleteFieldTemplateMutationVariables, TContext>) =>
    useMutation<DeleteFieldTemplateMutation, TError, DeleteFieldTemplateMutationVariables, TContext>(
      ['deleteFieldTemplate'],
      (variables?: DeleteFieldTemplateMutationVariables) => fetcher<DeleteFieldTemplateMutation, DeleteFieldTemplateMutationVariables>(DeleteFieldTemplateDocument, variables)(),
      options
    );
export const FieldTemplateDocument = `
    query FieldTemplate($id: ID) {
  fieldTemplate: field_template(id: $id) {
    ...FieldTemplateFields
  }
}
    ${FieldTemplateFieldsFragmentDoc}`;
export const useFieldTemplateQuery = <
      TData = FieldTemplateQuery,
      TError = Error
    >(
      variables?: FieldTemplateQueryVariables,
      options?: UseQueryOptions<FieldTemplateQuery, TError, TData>
    ) =>
    useQuery<FieldTemplateQuery, TError, TData>(
      variables === undefined ? ['FieldTemplate'] : ['FieldTemplate', variables],
      fetcher<FieldTemplateQuery, FieldTemplateQueryVariables>(FieldTemplateDocument, variables),
      options
    );

useFieldTemplateQuery.getKey = (variables?: FieldTemplateQueryVariables) => variables === undefined ? ['FieldTemplate'] : ['FieldTemplate', variables];
;

export const FieldTemplatesDocument = `
    query FieldTemplates($page: Int, $limit: Int, $name: String) {
  fieldTemplates: field_templates(page: $page, limit: $limit, name: $name) {
    ...FieldTemplateFields
  }
}
    ${FieldTemplateFieldsFragmentDoc}`;
export const useFieldTemplatesQuery = <
      TData = FieldTemplatesQuery,
      TError = Error
    >(
      variables?: FieldTemplatesQueryVariables,
      options?: UseQueryOptions<FieldTemplatesQuery, TError, TData>
    ) =>
    useQuery<FieldTemplatesQuery, TError, TData>(
      variables === undefined ? ['FieldTemplates'] : ['FieldTemplates', variables],
      fetcher<FieldTemplatesQuery, FieldTemplatesQueryVariables>(FieldTemplatesDocument, variables),
      options
    );

useFieldTemplatesQuery.getKey = (variables?: FieldTemplatesQueryVariables) => variables === undefined ? ['FieldTemplates'] : ['FieldTemplates', variables];
;

export const UpdateFieldTemplateDocument = `
    mutation UpdateFieldTemplate($id: ID!, $recordType: FieldTemplateRecordType, $displayName: String, $name: String!, $fieldType: String!, $aliases: [String], $alternateNames: [String], $fieldCategoryName: FieldTemplateFieldCategoryName) {
  updateFieldTemplate(
    id: $id
    display_name: $displayName
    name: $name
    field_type: $fieldType
    aliases: $aliases
    alternate_names: $alternateNames
    field_category_name: $fieldCategoryName
    record_type: $recordType
  ) {
    ...FieldTemplateFields
  }
}
    ${FieldTemplateFieldsFragmentDoc}`;
export const useUpdateFieldTemplateMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateFieldTemplateMutation, TError, UpdateFieldTemplateMutationVariables, TContext>) =>
    useMutation<UpdateFieldTemplateMutation, TError, UpdateFieldTemplateMutationVariables, TContext>(
      ['UpdateFieldTemplate'],
      (variables?: UpdateFieldTemplateMutationVariables) => fetcher<UpdateFieldTemplateMutation, UpdateFieldTemplateMutationVariables>(UpdateFieldTemplateDocument, variables)(),
      options
    );
export const JumperDataDocument = `
    query JumperData {
  listingServices: listing_services(limit: 1000) {
    ...JumperDataListingService
  }
  adapters(limit: 1000) {
    ...JumperDataAdapter
  }
}
    ${JumperDataListingServiceFragmentDoc}
${JumperDataAdapterFragmentDoc}`;
export const useJumperDataQuery = <
      TData = JumperDataQuery,
      TError = Error
    >(
      variables?: JumperDataQueryVariables,
      options?: UseQueryOptions<JumperDataQuery, TError, TData>
    ) =>
    useQuery<JumperDataQuery, TError, TData>(
      variables === undefined ? ['JumperData'] : ['JumperData', variables],
      fetcher<JumperDataQuery, JumperDataQueryVariables>(JumperDataDocument, variables),
      options
    );

useJumperDataQuery.getKey = (variables?: JumperDataQueryVariables) => variables === undefined ? ['JumperData'] : ['JumperData', variables];
;

export const ListingSearchDocument = `
    query ListingSearch($id: ID!, $limit: Int, $page: Int, $filter: [FilterQueryType], $sort: QuerySortType, $source: String) {
  listingRg: resource_group(id: $id) {
    id
    listings(
      limit: $limit
      page: $page
      filter: $filter
      sort: $sort
      source: $source
    ) {
      count
      explain
      results {
        ...ListingSearchResult
      }
    }
  }
  resourceGroupFieldsSearchValues: resource_group(id: $id) {
    id
    fields(limit: 10000) {
      ...ListingSearchFieldParts
    }
  }
}
    ${ListingSearchResultFragmentDoc}
${ListingSearchFieldPartsFragmentDoc}`;
export const useListingSearchQuery = <
      TData = ListingSearchQuery,
      TError = Error
    >(
      variables: ListingSearchQueryVariables,
      options?: UseQueryOptions<ListingSearchQuery, TError, TData>
    ) =>
    useQuery<ListingSearchQuery, TError, TData>(
      ['ListingSearch', variables],
      fetcher<ListingSearchQuery, ListingSearchQueryVariables>(ListingSearchDocument, variables),
      options
    );

useListingSearchQuery.getKey = (variables: ListingSearchQueryVariables) => ['ListingSearch', variables];
;

export const ActivateListingServiceApiUserDocument = `
    mutation ActivateListingServiceApiUser($listingServiceId: Int, $apiUserId: Int) {
  createActivation(listing_service_id: $listingServiceId, api_user_id: $apiUserId) {
    id
    createdAt: created_at
    apiUser: api_user {
      id
      name
    }
  }
}
    `;
export const useActivateListingServiceApiUserMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<ActivateListingServiceApiUserMutation, TError, ActivateListingServiceApiUserMutationVariables, TContext>) =>
    useMutation<ActivateListingServiceApiUserMutation, TError, ActivateListingServiceApiUserMutationVariables, TContext>(
      ['ActivateListingServiceApiUser'],
      (variables?: ActivateListingServiceApiUserMutationVariables) => fetcher<ActivateListingServiceApiUserMutation, ActivateListingServiceApiUserMutationVariables>(ActivateListingServiceApiUserDocument, variables)(),
      options
    );
export const CreateListingServiceDocument = `
    mutation createListingService($name: String!, $key: String!, $timeZone: String!, $address: String, $state: [String], $lat: Float, $lon: Float) {
  createListingService(
    name: $name
    key: $key
    time_zone: $timeZone
    address: $address
    state: $state
    lat: $lat
    lon: $lon
  ) {
    id
  }
}
    `;
export const useCreateListingServiceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateListingServiceMutation, TError, CreateListingServiceMutationVariables, TContext>) =>
    useMutation<CreateListingServiceMutation, TError, CreateListingServiceMutationVariables, TContext>(
      ['createListingService'],
      (variables?: CreateListingServiceMutationVariables) => fetcher<CreateListingServiceMutation, CreateListingServiceMutationVariables>(CreateListingServiceDocument, variables)(),
      options
    );
export const CreateServiceAdapterDocument = `
    mutation createServiceAdapter($listingServiceId: Int, $adapterId: Int) {
  createServiceAdapter(
    listing_service_id: $listingServiceId
    adapter_id: $adapterId
  ) {
    id
    adapter {
      id
      key
      recordCounts: record_counts {
        today
        listings
        agents
        offices
      }
    }
  }
}
    `;
export const useCreateServiceAdapterMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateServiceAdapterMutation, TError, CreateServiceAdapterMutationVariables, TContext>) =>
    useMutation<CreateServiceAdapterMutation, TError, CreateServiceAdapterMutationVariables, TContext>(
      ['createServiceAdapter'],
      (variables?: CreateServiceAdapterMutationVariables) => fetcher<CreateServiceAdapterMutation, CreateServiceAdapterMutationVariables>(CreateServiceAdapterDocument, variables)(),
      options
    );
export const DeleteListingServiceActivationDocument = `
    mutation DeleteListingServiceActivation($id: ID!) {
  deleteActivation(id: $id)
}
    `;
export const useDeleteListingServiceActivationMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteListingServiceActivationMutation, TError, DeleteListingServiceActivationMutationVariables, TContext>) =>
    useMutation<DeleteListingServiceActivationMutation, TError, DeleteListingServiceActivationMutationVariables, TContext>(
      ['DeleteListingServiceActivation'],
      (variables?: DeleteListingServiceActivationMutationVariables) => fetcher<DeleteListingServiceActivationMutation, DeleteListingServiceActivationMutationVariables>(DeleteListingServiceActivationDocument, variables)(),
      options
    );
export const DeleteListingServiceDocument = `
    mutation deleteListingService($id: ID!) {
  deleteListingService(id: $id)
}
    `;
export const useDeleteListingServiceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteListingServiceMutation, TError, DeleteListingServiceMutationVariables, TContext>) =>
    useMutation<DeleteListingServiceMutation, TError, DeleteListingServiceMutationVariables, TContext>(
      ['deleteListingService'],
      (variables?: DeleteListingServiceMutationVariables) => fetcher<DeleteListingServiceMutation, DeleteListingServiceMutationVariables>(DeleteListingServiceDocument, variables)(),
      options
    );
export const DeleteServiceAdapterDocument = `
    mutation deleteServiceAdapter($id: ID!) {
  deleteServiceAdapter(id: $id)
}
    `;
export const useDeleteServiceAdapterMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteServiceAdapterMutation, TError, DeleteServiceAdapterMutationVariables, TContext>) =>
    useMutation<DeleteServiceAdapterMutation, TError, DeleteServiceAdapterMutationVariables, TContext>(
      ['deleteServiceAdapter'],
      (variables?: DeleteServiceAdapterMutationVariables) => fetcher<DeleteServiceAdapterMutation, DeleteServiceAdapterMutationVariables>(DeleteServiceAdapterDocument, variables)(),
      options
    );
export const ListingServiceDocument = `
    query ListingService($id: ID) {
  listingService: listing_service(id: $id) {
    id
    key
    name
    address
    timeZone: time_zone
    lat
    lon
    state
    defaultSearch: default_search
    config
    flags {
      key
      value
    }
    activations(limit: 10000) {
      id
      apiUser: api_user {
        id
        name
      }
    }
    serviceAdapters: service_adapters {
      ...serviceAdapterFields
    }
  }
}
    ${ServiceAdapterFieldsFragmentDoc}`;
export const useListingServiceQuery = <
      TData = ListingServiceQuery,
      TError = Error
    >(
      variables?: ListingServiceQueryVariables,
      options?: UseQueryOptions<ListingServiceQuery, TError, TData>
    ) =>
    useQuery<ListingServiceQuery, TError, TData>(
      variables === undefined ? ['ListingService'] : ['ListingService', variables],
      fetcher<ListingServiceQuery, ListingServiceQueryVariables>(ListingServiceDocument, variables),
      options
    );

useListingServiceQuery.getKey = (variables?: ListingServiceQueryVariables) => variables === undefined ? ['ListingService'] : ['ListingService', variables];
;

export const ListingServicesDocument = `
    query ListingServices {
  listingServices: listing_services(limit: 1000) {
    ...ListingServicesListingService
  }
}
    ${ListingServicesListingServiceFragmentDoc}`;
export const useListingServicesQuery = <
      TData = ListingServicesQuery,
      TError = Error
    >(
      variables?: ListingServicesQueryVariables,
      options?: UseQueryOptions<ListingServicesQuery, TError, TData>
    ) =>
    useQuery<ListingServicesQuery, TError, TData>(
      variables === undefined ? ['ListingServices'] : ['ListingServices', variables],
      fetcher<ListingServicesQuery, ListingServicesQueryVariables>(ListingServicesDocument, variables),
      options
    );

useListingServicesQuery.getKey = (variables?: ListingServicesQueryVariables) => variables === undefined ? ['ListingServices'] : ['ListingServices', variables];
;

export const ReRegisterSavedSearchesDocument = `
    mutation reRegisterSavedSearches($id: Int!) {
  reRegisterSavedSearches(id: $id)
}
    `;
export const useReRegisterSavedSearchesMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<ReRegisterSavedSearchesMutation, TError, ReRegisterSavedSearchesMutationVariables, TContext>) =>
    useMutation<ReRegisterSavedSearchesMutation, TError, ReRegisterSavedSearchesMutationVariables, TContext>(
      ['reRegisterSavedSearches'],
      (variables?: ReRegisterSavedSearchesMutationVariables) => fetcher<ReRegisterSavedSearchesMutation, ReRegisterSavedSearchesMutationVariables>(ReRegisterSavedSearchesDocument, variables)(),
      options
    );
export const SavedSearchDocument = `
    query SavedSearch($listingServiceId: Int, $id: ID) {
  savedSearch: saved_search(id: $id, listing_service_id: $listingServiceId) {
    rawCriteria: raw_criteria
    queries
  }
}
    `;
export const useSavedSearchQuery = <
      TData = SavedSearchQuery,
      TError = Error
    >(
      variables?: SavedSearchQueryVariables,
      options?: UseQueryOptions<SavedSearchQuery, TError, TData>
    ) =>
    useQuery<SavedSearchQuery, TError, TData>(
      variables === undefined ? ['SavedSearch'] : ['SavedSearch', variables],
      fetcher<SavedSearchQuery, SavedSearchQueryVariables>(SavedSearchDocument, variables),
      options
    );

useSavedSearchQuery.getKey = (variables?: SavedSearchQueryVariables) => variables === undefined ? ['SavedSearch'] : ['SavedSearch', variables];
;

export const SavedSearchesDocument = `
    query SavedSearches($page: Int, $listingServiceId: ID) {
  listingService: listing_service(id: $listingServiceId) {
    id
    savedSearchHealth: saved_search_health {
      count
      registeredCount: registered_count
      unregistered(page: $page) {
        id
        matchCount: match_count
        lastMatchAt: last_match_at
      }
    }
  }
}
    `;
export const useSavedSearchesQuery = <
      TData = SavedSearchesQuery,
      TError = Error
    >(
      variables?: SavedSearchesQueryVariables,
      options?: UseQueryOptions<SavedSearchesQuery, TError, TData>
    ) =>
    useQuery<SavedSearchesQuery, TError, TData>(
      variables === undefined ? ['SavedSearches'] : ['SavedSearches', variables],
      fetcher<SavedSearchesQuery, SavedSearchesQueryVariables>(SavedSearchesDocument, variables),
      options
    );

useSavedSearchesQuery.getKey = (variables?: SavedSearchesQueryVariables) => variables === undefined ? ['SavedSearches'] : ['SavedSearches', variables];
;

export const UpdateListingServiceDocument = `
    mutation updateListingService($id: ID!, $key: String, $name: String, $address: String, $timeZone: String, $lat: Float, $lon: Float, $state: [String], $defaultSearch: [DefaultSearchInput], $config: String) {
  updateListingService(
    id: $id
    key: $key
    name: $name
    address: $address
    time_zone: $timeZone
    lat: $lat
    lon: $lon
    state: $state
    default_search: $defaultSearch
    config: $config
  ) {
    id
    key
    name
    createAt: created_at
    updateAt: updated_at
    config
  }
}
    `;
export const useUpdateListingServiceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateListingServiceMutation, TError, UpdateListingServiceMutationVariables, TContext>) =>
    useMutation<UpdateListingServiceMutation, TError, UpdateListingServiceMutationVariables, TContext>(
      ['updateListingService'],
      (variables?: UpdateListingServiceMutationVariables) => fetcher<UpdateListingServiceMutation, UpdateListingServiceMutationVariables>(UpdateListingServiceDocument, variables)(),
      options
    );
export const UpdateSavedSearchDocument = `
    mutation updateSavedSearch($id: ID!, $listingServiceId: Int, $rawCriteria: String) {
  updateSavedSearch(
    id: $id
    listing_service_id: $listingServiceId
    raw_criteria: $rawCriteria
  ) {
    id
  }
}
    `;
export const useUpdateSavedSearchMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSavedSearchMutation, TError, UpdateSavedSearchMutationVariables, TContext>) =>
    useMutation<UpdateSavedSearchMutation, TError, UpdateSavedSearchMutationVariables, TContext>(
      ['updateSavedSearch'],
      (variables?: UpdateSavedSearchMutationVariables) => fetcher<UpdateSavedSearchMutation, UpdateSavedSearchMutationVariables>(UpdateSavedSearchDocument, variables)(),
      options
    );
export const CreateLookupDocument = `
    mutation CreateLookup($fieldId: Int, $sourceId: String!, $value: String!, $mappedValue: String) {
  createLookup(
    field_id: $fieldId
    source_id: $sourceId
    value: $value
    mapped_value: $mappedValue
  ) {
    id
  }
}
    `;
export const useCreateLookupMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateLookupMutation, TError, CreateLookupMutationVariables, TContext>) =>
    useMutation<CreateLookupMutation, TError, CreateLookupMutationVariables, TContext>(
      ['CreateLookup'],
      (variables?: CreateLookupMutationVariables) => fetcher<CreateLookupMutation, CreateLookupMutationVariables>(CreateLookupDocument, variables)(),
      options
    );
export const CreateLookupsFromAggsDocument = `
    mutation CreateLookupsFromAggs($fieldId: ID!) {
  createLookupsFromAggs(field_id: $fieldId) {
    id
    lookups {
      id
      order
      value
      mappedValue: mapped_value
      sourceId: source_id
    }
  }
}
    `;
export const useCreateLookupsFromAggsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateLookupsFromAggsMutation, TError, CreateLookupsFromAggsMutationVariables, TContext>) =>
    useMutation<CreateLookupsFromAggsMutation, TError, CreateLookupsFromAggsMutationVariables, TContext>(
      ['CreateLookupsFromAggs'],
      (variables?: CreateLookupsFromAggsMutationVariables) => fetcher<CreateLookupsFromAggsMutation, CreateLookupsFromAggsMutationVariables>(CreateLookupsFromAggsDocument, variables)(),
      options
    );
export const CreateLookupsFromMetadataDocument = `
    mutation CreateLookupsFromMetadata($fieldId: ID!, $name: String!) {
  createLookupsFromMetadata(field_id: $fieldId, name: $name) {
    id
    lookups {
      id
      order
      value
      mappedValue: mapped_value
      sourceId: source_id
    }
  }
}
    `;
export const useCreateLookupsFromMetadataMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateLookupsFromMetadataMutation, TError, CreateLookupsFromMetadataMutationVariables, TContext>) =>
    useMutation<CreateLookupsFromMetadataMutation, TError, CreateLookupsFromMetadataMutationVariables, TContext>(
      ['CreateLookupsFromMetadata'],
      (variables?: CreateLookupsFromMetadataMutationVariables) => fetcher<CreateLookupsFromMetadataMutation, CreateLookupsFromMetadataMutationVariables>(CreateLookupsFromMetadataDocument, variables)(),
      options
    );
export const DestroyAllLookupsDocument = `
    mutation DestroyAllLookups($fieldId: ID!) {
  deleteAllLookups(field_id: $fieldId) {
    id
  }
}
    `;
export const useDestroyAllLookupsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DestroyAllLookupsMutation, TError, DestroyAllLookupsMutationVariables, TContext>) =>
    useMutation<DestroyAllLookupsMutation, TError, DestroyAllLookupsMutationVariables, TContext>(
      ['DestroyAllLookups'],
      (variables?: DestroyAllLookupsMutationVariables) => fetcher<DestroyAllLookupsMutation, DestroyAllLookupsMutationVariables>(DestroyAllLookupsDocument, variables)(),
      options
    );
export const DestroyLookupDocument = `
    mutation DestroyLookup($id: ID!) {
  deleteLookup(id: $id)
}
    `;
export const useDestroyLookupMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DestroyLookupMutation, TError, DestroyLookupMutationVariables, TContext>) =>
    useMutation<DestroyLookupMutation, TError, DestroyLookupMutationVariables, TContext>(
      ['DestroyLookup'],
      (variables?: DestroyLookupMutationVariables) => fetcher<DestroyLookupMutation, DestroyLookupMutationVariables>(DestroyLookupDocument, variables)(),
      options
    );
export const ReorderLookupsDocument = `
    mutation ReorderLookups($ids: [ID]!) {
  reorderLookups(ids: $ids)
}
    `;
export const useReorderLookupsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<ReorderLookupsMutation, TError, ReorderLookupsMutationVariables, TContext>) =>
    useMutation<ReorderLookupsMutation, TError, ReorderLookupsMutationVariables, TContext>(
      ['ReorderLookups'],
      (variables?: ReorderLookupsMutationVariables) => fetcher<ReorderLookupsMutation, ReorderLookupsMutationVariables>(ReorderLookupsDocument, variables)(),
      options
    );
export const UpdateLookupDocument = `
    mutation UpdateLookup($id: ID!, $fieldId: Int, $order: Int, $value: String, $sourceId: String, $mappedValue: String) {
  updateLookup(
    id: $id
    field_id: $fieldId
    order: $order
    value: $value
    source_id: $sourceId
    mapped_value: $mappedValue
  ) {
    id
    field {
      id
      lookups {
        id
        order
        value
        mappedValue: mapped_value
        sourceId: source_id
      }
    }
  }
}
    `;
export const useUpdateLookupMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateLookupMutation, TError, UpdateLookupMutationVariables, TContext>) =>
    useMutation<UpdateLookupMutation, TError, UpdateLookupMutationVariables, TContext>(
      ['UpdateLookup'],
      (variables?: UpdateLookupMutationVariables) => fetcher<UpdateLookupMutation, UpdateLookupMutationVariables>(UpdateLookupDocument, variables)(),
      options
    );
export const ImportMetadataDocument = `
    mutation importMetadata($adapterId: ID!, $resourceName: String!, $classNames: [String!], $role: ResourceGroupRole!) {
  importMetadata(
    adapter_id: $adapterId
    resource_name: $resourceName
    class_names: $classNames
    role: $role
  ) {
    id
    adapterId: adapter_id
  }
}
    `;
export const useImportMetadataMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<ImportMetadataMutation, TError, ImportMetadataMutationVariables, TContext>) =>
    useMutation<ImportMetadataMutation, TError, ImportMetadataMutationVariables, TContext>(
      ['importMetadata'],
      (variables?: ImportMetadataMutationVariables) => fetcher<ImportMetadataMutation, ImportMetadataMutationVariables>(ImportMetadataDocument, variables)(),
      options
    );
export const OfficeSearchDocument = `
    query OfficeSearch($id: ID!, $limit: Int, $page: Int, $filter: [FilterQueryType], $sort: QuerySortType, $source: String) {
  officeRg: resource_group(id: $id) {
    id
    offices(
      limit: $limit
      page: $page
      filter: $filter
      sort: $sort
      source: $source
    ) {
      count
      explain
      results {
        ...OfficeSearchResult
      }
    }
  }
  resourceGroupFieldsSearchValues: resource_group(id: $id) {
    id
    fields(limit: 10000) {
      ...OfficeSearchFieldParts
    }
  }
}
    ${OfficeSearchResultFragmentDoc}
${OfficeSearchFieldPartsFragmentDoc}`;
export const useOfficeSearchQuery = <
      TData = OfficeSearchQuery,
      TError = Error
    >(
      variables: OfficeSearchQueryVariables,
      options?: UseQueryOptions<OfficeSearchQuery, TError, TData>
    ) =>
    useQuery<OfficeSearchQuery, TError, TData>(
      ['OfficeSearch', variables],
      fetcher<OfficeSearchQuery, OfficeSearchQueryVariables>(OfficeSearchDocument, variables),
      options
    );

useOfficeSearchQuery.getKey = (variables: OfficeSearchQueryVariables) => ['OfficeSearch', variables];
;

export const DeleteResourceDocument = `
    mutation deleteResource($id: ID!) {
  deleteResource(id: $id)
}
    `;
export const useDeleteResourceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteResourceMutation, TError, DeleteResourceMutationVariables, TContext>) =>
    useMutation<DeleteResourceMutation, TError, DeleteResourceMutationVariables, TContext>(
      ['deleteResource'],
      (variables?: DeleteResourceMutationVariables) => fetcher<DeleteResourceMutation, DeleteResourceMutationVariables>(DeleteResourceDocument, variables)(),
      options
    );
export const PopulateDocument = `
    mutation Populate($resourceId: Int, $startDate: String, $filters: [PopulateFilterType!]) {
  startPopulate(
    resource_id: $resourceId
    start_date: $startDate
    filters: $filters
  ) {
    id
    totalRecords: total_records
    statableId: statable_id
  }
}
    `;
export const usePopulateMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<PopulateMutation, TError, PopulateMutationVariables, TContext>) =>
    useMutation<PopulateMutation, TError, PopulateMutationVariables, TContext>(
      ['Populate'],
      (variables?: PopulateMutationVariables) => fetcher<PopulateMutation, PopulateMutationVariables>(PopulateDocument, variables)(),
      options
    );
export const ResourceDocument = `
    query Resource($id: ID!, $limit: Int, $page: Int, $job: StatJob) {
  resource: resource(id: $id) {
    id
    name
    latestAudit: latest_audit
    defaultCriteria: default_criteria {
      casCriterium: cas_criterium
      createdAt: created_at
      fieldName: field_name
      id
      parentId: parent_id
      parentType: parent_type
      scope
      updatedAt: updated_at
      value
    }
    recentAudits: recent_audits {
      id
      createdAt: created_at
      humanCreatedAgo: human_created_ago
      accuracyRate: accuracy_rate
      resolvedRate: resolved_rate
      humanCreatedAgo: human_created_ago
      tookHuman: took_human
      totalRecords: total_records
      status
    }
    updatesByHour: updates_by_hour
    stats(page: $page, limit: $limit, job: $job) {
      ...statFields
    }
  }
}
    ${StatFieldsFragmentDoc}`;
export const useResourceQuery = <
      TData = ResourceQuery,
      TError = Error
    >(
      variables: ResourceQueryVariables,
      options?: UseQueryOptions<ResourceQuery, TError, TData>
    ) =>
    useQuery<ResourceQuery, TError, TData>(
      ['Resource', variables],
      fetcher<ResourceQuery, ResourceQueryVariables>(ResourceDocument, variables),
      options
    );

useResourceQuery.getKey = (variables: ResourceQueryVariables) => ['Resource', variables];
;

export const ResourceHealthDocument = `
    query ResourceHealth($id: ID!) {
  resource: resource(id: $id) {
    id
    name
    updateData: update_data
    health {
      audit
      auditResolution: audit_resolution
      monthlyAudit: monthly_audit
      sync
      weeklyAudit: weekly_audit
    }
  }
}
    `;
export const useResourceHealthQuery = <
      TData = ResourceHealthQuery,
      TError = Error
    >(
      variables: ResourceHealthQueryVariables,
      options?: UseQueryOptions<ResourceHealthQuery, TError, TData>
    ) =>
    useQuery<ResourceHealthQuery, TError, TData>(
      ['ResourceHealth', variables],
      fetcher<ResourceHealthQuery, ResourceHealthQueryVariables>(ResourceHealthDocument, variables),
      options
    );

useResourceHealthQuery.getKey = (variables: ResourceHealthQueryVariables) => ['ResourceHealth', variables];
;

export const ResourceSampleDocument = `
    query ResourceSample($id: ID!) {
  resource(id: $id) {
    id
    name
    sourceType: source_type
    sourceClass: source_class
    sampleData: sample_data {
      raw
      serialized
      translated
      normalized
      serializedDraft: serialized_draft
      translatedDraft: translated_draft
      normalizedDraft: normalized_draft
    }
  }
}
    `;
export const useResourceSampleQuery = <
      TData = ResourceSampleQuery,
      TError = Error
    >(
      variables: ResourceSampleQueryVariables,
      options?: UseQueryOptions<ResourceSampleQuery, TError, TData>
    ) =>
    useQuery<ResourceSampleQuery, TError, TData>(
      ['ResourceSample', variables],
      fetcher<ResourceSampleQuery, ResourceSampleQueryVariables>(ResourceSampleDocument, variables),
      options
    );

useResourceSampleQuery.getKey = (variables: ResourceSampleQueryVariables) => ['ResourceSample', variables];
;

export const ResumePopulateResourceDocument = `
    mutation ResumePopulateResource($statId: ID!) {
  resumePopulateResource(stat_id: $statId) {
    id
  }
}
    `;
export const useResumePopulateResourceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<ResumePopulateResourceMutation, TError, ResumePopulateResourceMutationVariables, TContext>) =>
    useMutation<ResumePopulateResourceMutation, TError, ResumePopulateResourceMutationVariables, TContext>(
      ['ResumePopulateResource'],
      (variables?: ResumePopulateResourceMutationVariables) => fetcher<ResumePopulateResourceMutation, ResumePopulateResourceMutationVariables>(ResumePopulateResourceDocument, variables)(),
      options
    );
export const SyncRecordsDocument = `
    query SyncRecords($id: ID, $recordIds: [String!]!) {
  resource(id: $id) {
    reloadRecord: reload_record(record_ids: $recordIds) {
      success
      logs
      records {
        ... on ListingResultType {
          acres
          address
          area
          assocFee: assoc_fee
          baths
          bathsFull: baths_full
          bathsHalf: baths_half
          bathsSearch: baths_search
          beds
          city
          county
          createdAt: created_at
          dateList: date_list
          dateOffmarket: date_offmarket
          datePending: date_pending
          dateSold: date_sold
          directions
          dom
          features
          featuresStoriesTotal: features_stories_total
          fullAddress: full_address
          garages
          gpsLoc: gps_loc
          id
          lat
          location
          lon
          lotdim
          lotsize
          mappedPropType: mapped_prop_type
          mappedStatus: mapped_status
          mlsnum
          parcel
          photoCount: photo_count
          photos
          photosUpdatedAt: photos_updated_at
          price
          priceList: price_list
          priceListOrig: price_list_orig
          priceListPerSqft: price_list_per_sqft
          priceSold: price_sold
          propSubType: prop_sub_type
          propType: prop_type
          remarks
          remarksPrivate: remarks_private
          schoolDistrict: school_district
          schoolElementary: school_elementary
          schoolHigh: school_high
          schoolMiddle: school_middle
          showingInst: showing_inst
          sqft
          state
          status
          streetname
          streetnum
          style
          subdivision
          taxes
          unit
          updated_at
          yearBuilt: year_built
          zip
          zipcode
          wrResourceId: wr_resource_id
          agentList: agent_list {
            id
            name
            phone
            email
          }
          officeList: office_list {
            id
            name
            phone
            email
          }
          agentSell: agent_sell {
            id
            name
            phone
            email
          }
          officeSell: office_sell {
            id
            name
            phone
            email
          }
          rawData: raw_data {
            serialized
            raw
          }
        }
        ... on AgentResultType {
          active
          agentId: agent_id
          email
          firstname
          fullName: full_name
          id
          lastname
          login
          officeName: office_name
          phone
          updatedAt: updated_at
          wrResourceId: wr_resource_id
          rawData: raw_data {
            serialized
            raw
          }
        }
        ... on OfficeResultType {
          email
          id
          name
          officeId: office_id
          phone
          updatedAt: updated_at
          active
          wrResourceId: wr_resource_id
          rawData: raw_data {
            serialized
            raw
          }
        }
      }
    }
  }
}
    `;
export const useSyncRecordsQuery = <
      TData = SyncRecordsQuery,
      TError = Error
    >(
      variables: SyncRecordsQueryVariables,
      options?: UseQueryOptions<SyncRecordsQuery, TError, TData>
    ) =>
    useQuery<SyncRecordsQuery, TError, TData>(
      ['SyncRecords', variables],
      fetcher<SyncRecordsQuery, SyncRecordsQueryVariables>(SyncRecordsDocument, variables),
      options
    );

useSyncRecordsQuery.getKey = (variables: SyncRecordsQueryVariables) => ['SyncRecords', variables];
;

export const UpdateResourceDocument = `
    mutation UpdateResource($id: ID!, $resourceGroupId: Int, $updateData: Boolean) {
  updateResource(
    id: $id
    resource_group_id: $resourceGroupId
    update_data: $updateData
  ) {
    id
  }
}
    `;
export const useUpdateResourceMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateResourceMutation, TError, UpdateResourceMutationVariables, TContext>) =>
    useMutation<UpdateResourceMutation, TError, UpdateResourceMutationVariables, TContext>(
      ['UpdateResource'],
      (variables?: UpdateResourceMutationVariables) => fetcher<UpdateResourceMutation, UpdateResourceMutationVariables>(UpdateResourceDocument, variables)(),
      options
    );
export const AdapterResourceGroupsDocument = `
    query AdapterResourceGroups($id: ID!, $adapterId: Int, $role: ResourceGroupRole) {
  adapter(id: $id) {
    id
    key
    resourceGroups: resource_groups(adapter_id: $adapterId, role: $role) {
      ...AdapterResourceGroup
    }
  }
}
    ${AdapterResourceGroupFragmentDoc}`;
export const useAdapterResourceGroupsQuery = <
      TData = AdapterResourceGroupsQuery,
      TError = Error
    >(
      variables: AdapterResourceGroupsQueryVariables,
      options?: UseQueryOptions<AdapterResourceGroupsQuery, TError, TData>
    ) =>
    useQuery<AdapterResourceGroupsQuery, TError, TData>(
      ['AdapterResourceGroups', variables],
      fetcher<AdapterResourceGroupsQuery, AdapterResourceGroupsQueryVariables>(AdapterResourceGroupsDocument, variables),
      options
    );

useAdapterResourceGroupsQuery.getKey = (variables: AdapterResourceGroupsQueryVariables) => ['AdapterResourceGroups', variables];
;

export const DeleteRecordDocument = `
    mutation DeleteRecord($id: ID!, $record_id: ID!) {
  deleteRecord(resource_group_id: $id, record_id: $record_id) {
    success
  }
}
    `;
export const useDeleteRecordMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteRecordMutation, TError, DeleteRecordMutationVariables, TContext>) =>
    useMutation<DeleteRecordMutation, TError, DeleteRecordMutationVariables, TContext>(
      ['DeleteRecord'],
      (variables?: DeleteRecordMutationVariables) => fetcher<DeleteRecordMutation, DeleteRecordMutationVariables>(DeleteRecordDocument, variables)(),
      options
    );
export const DeleteResourceGroupDocument = `
    mutation DeleteResourceGroup($id: ID!) {
  deleteResourceGroup(id: $id)
}
    `;
export const useDeleteResourceGroupMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteResourceGroupMutation, TError, DeleteResourceGroupMutationVariables, TContext>) =>
    useMutation<DeleteResourceGroupMutation, TError, DeleteResourceGroupMutationVariables, TContext>(
      ['DeleteResourceGroup'],
      (variables?: DeleteResourceGroupMutationVariables) => fetcher<DeleteResourceGroupMutation, DeleteResourceGroupMutationVariables>(DeleteResourceGroupDocument, variables)(),
      options
    );
export const ResourceGroupDocument = `
    query ResourceGroup($id: ID!) {
  resourceGroup: resource_group(id: $id) {
    ...AdapterResourceGroupFields
  }
}
    ${AdapterResourceGroupFieldsFragmentDoc}`;
export const useResourceGroupQuery = <
      TData = ResourceGroupQuery,
      TError = Error
    >(
      variables: ResourceGroupQueryVariables,
      options?: UseQueryOptions<ResourceGroupQuery, TError, TData>
    ) =>
    useQuery<ResourceGroupQuery, TError, TData>(
      ['ResourceGroup', variables],
      fetcher<ResourceGroupQuery, ResourceGroupQueryVariables>(ResourceGroupDocument, variables),
      options
    );

useResourceGroupQuery.getKey = (variables: ResourceGroupQueryVariables) => ['ResourceGroup', variables];
;

export const ResourceGroupFieldsSearchValuesDocument = `
    query ResourceGroupFieldsSearchValues($resourceGroupId: ID!, $includeSearchValues: Boolean!, $fields: [String!]) {
  resourceGroupFieldsSearchValues: resource_group(id: $resourceGroupId) {
    id
    fields(limit: 10000, filter: {field: "col_name", in: $fields}) {
      ...ResourceGroupFieldsSearchValuesParts
    }
  }
}
    ${ResourceGroupFieldsSearchValuesPartsFragmentDoc}`;
export const useResourceGroupFieldsSearchValuesQuery = <
      TData = ResourceGroupFieldsSearchValuesQuery,
      TError = Error
    >(
      variables: ResourceGroupFieldsSearchValuesQueryVariables,
      options?: UseQueryOptions<ResourceGroupFieldsSearchValuesQuery, TError, TData>
    ) =>
    useQuery<ResourceGroupFieldsSearchValuesQuery, TError, TData>(
      ['ResourceGroupFieldsSearchValues', variables],
      fetcher<ResourceGroupFieldsSearchValuesQuery, ResourceGroupFieldsSearchValuesQueryVariables>(ResourceGroupFieldsSearchValuesDocument, variables),
      options
    );

useResourceGroupFieldsSearchValuesQuery.getKey = (variables: ResourceGroupFieldsSearchValuesQueryVariables) => ['ResourceGroupFieldsSearchValues', variables];
;

export const ResourceGroupFieldsDocument = `
    query ResourceGroupFields($resourceGroupId: ID!) {
  resourceGroupFields: resource_group(id: $resourceGroupId) {
    id
    fields(limit: 10000) {
      ...ResourceGroupFieldParts
    }
  }
}
    ${ResourceGroupFieldPartsFragmentDoc}`;
export const useResourceGroupFieldsQuery = <
      TData = ResourceGroupFieldsQuery,
      TError = Error
    >(
      variables: ResourceGroupFieldsQueryVariables,
      options?: UseQueryOptions<ResourceGroupFieldsQuery, TError, TData>
    ) =>
    useQuery<ResourceGroupFieldsQuery, TError, TData>(
      ['ResourceGroupFields', variables],
      fetcher<ResourceGroupFieldsQuery, ResourceGroupFieldsQueryVariables>(ResourceGroupFieldsDocument, variables),
      options
    );

useResourceGroupFieldsQuery.getKey = (variables: ResourceGroupFieldsQueryVariables) => ['ResourceGroupFields', variables];
;

export const PurgeDeletesDocument = `
    mutation purgeDeletes($resourceGroupId: ID!) {
  purgeDeletes(resource_group_id: $resourceGroupId)
}
    `;
export const usePurgeDeletesMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<PurgeDeletesMutation, TError, PurgeDeletesMutationVariables, TContext>) =>
    useMutation<PurgeDeletesMutation, TError, PurgeDeletesMutationVariables, TContext>(
      ['purgeDeletes'],
      (variables?: PurgeDeletesMutationVariables) => fetcher<PurgeDeletesMutation, PurgeDeletesMutationVariables>(PurgeDeletesDocument, variables)(),
      options
    );
export const ClearPurgeDocument = `
    mutation ClearPurge($resourceGroupId: ID!) {
  clearDeletes(resource_group_id: $resourceGroupId)
}
    `;
export const useClearPurgeMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<ClearPurgeMutation, TError, ClearPurgeMutationVariables, TContext>) =>
    useMutation<ClearPurgeMutation, TError, ClearPurgeMutationVariables, TContext>(
      ['ClearPurge'],
      (variables?: ClearPurgeMutationVariables) => fetcher<ClearPurgeMutation, ClearPurgeMutationVariables>(ClearPurgeDocument, variables)(),
      options
    );
export const ResourceGroupSearchDocument = `
    query ResourceGroupSearch($id: ID) {
  resourceGroup: resource_group(id: $id) {
    id
    role
    needsSetup: needs_setup
    adapter {
      key
    }
  }
}
    `;
export const useResourceGroupSearchQuery = <
      TData = ResourceGroupSearchQuery,
      TError = Error
    >(
      variables?: ResourceGroupSearchQueryVariables,
      options?: UseQueryOptions<ResourceGroupSearchQuery, TError, TData>
    ) =>
    useQuery<ResourceGroupSearchQuery, TError, TData>(
      variables === undefined ? ['ResourceGroupSearch'] : ['ResourceGroupSearch', variables],
      fetcher<ResourceGroupSearchQuery, ResourceGroupSearchQueryVariables>(ResourceGroupSearchDocument, variables),
      options
    );

useResourceGroupSearchQuery.getKey = (variables?: ResourceGroupSearchQueryVariables) => variables === undefined ? ['ResourceGroupSearch'] : ['ResourceGroupSearch', variables];
;

export const ResourceGroupSearchResultsDocument = `
    query ResourceGroupSearchResults($resourceGroupId: ID, $page: Int, $limit: Int, $sort: QuerySortType, $filter: [FilterQueryType]) {
  resourceGroup: resource_group(id: $resourceGroupId) {
    role
    listings(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      count
      results {
        address
        baths
        beds
        city
        dom
        id
        lat
        lon
        mapped_status
        photos
        price
        sqft
        state
        status
        year_built
        zipcode
      }
    }
    agents(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      count
      results {
        active
        agent_id
        email
        firstname
        full_name
        id
        lastname
        office_name
        phone
      }
    }
    offices(page: $page, limit: $limit, sort: $sort, filter: $filter) {
      count
      results {
        id
        email
        name
        office_id
        phone
        active
      }
    }
  }
}
    `;
export const useResourceGroupSearchResultsQuery = <
      TData = ResourceGroupSearchResultsQuery,
      TError = Error
    >(
      variables?: ResourceGroupSearchResultsQueryVariables,
      options?: UseQueryOptions<ResourceGroupSearchResultsQuery, TError, TData>
    ) =>
    useQuery<ResourceGroupSearchResultsQuery, TError, TData>(
      variables === undefined ? ['ResourceGroupSearchResults'] : ['ResourceGroupSearchResults', variables],
      fetcher<ResourceGroupSearchResultsQuery, ResourceGroupSearchResultsQueryVariables>(ResourceGroupSearchResultsDocument, variables),
      options
    );

useResourceGroupSearchResultsQuery.getKey = (variables?: ResourceGroupSearchResultsQueryVariables) => variables === undefined ? ['ResourceGroupSearchResults'] : ['ResourceGroupSearchResults', variables];
;

export const ResourceGroupSearchDetailsDocument = `
    query ResourceGroupSearchDetails($id: ID, $page: Int, $limit: Int, $filter: [FilterQueryType]) {
  resourceGroup: resource_group(id: $id) {
    id
    role
    needsSetup: needs_setup
    listings(page: $page, limit: $limit, filter: $filter) {
      count
      results {
        acres
        address
        area
        assoc_fee
        baths
        baths_full
        baths_half
        baths_search
        beds
        city
        county
        created_at
        date_list
        date_offmarket
        date_pending
        date_sold
        directions
        dom
        features
        features_stories_total
        full_address
        garages
        gps_loc
        id
        lat
        location
        lon
        lotdim
        lotsize
        mapped_prop_type
        mapped_status
        mlsnum
        parcel
        photo_count
        photos
        photos_updated_at
        price
        price_list
        price_list_orig
        price_list_per_sqft
        price_sold
        prop_sub_type
        prop_type
        remarks
        remarks_private
        school_district
        school_elementary
        school_high
        school_middle
        showing_inst
        sqft
        state
        status
        streetname
        streetnum
        style
        subdivision
        taxes
        unit
        updated_at
        year_built
        zipcode
        wr_resource_id
        agent_list {
          id
          name
          phone
          email
        }
        office_list {
          id
          name
          phone
          email
        }
        agent_sell {
          id
          name
          phone
          email
        }
        office_sell {
          id
          name
          phone
          email
        }
        raw_data {
          serialized
          raw
        }
      }
    }
    agents(page: $page, limit: $limit, filter: $filter) {
      count
      results {
        active
        agent_id
        email
        firstname
        full_name
        id
        lastname
        login
        office_name
        phone
        updated_at
        wr_resource_id
        raw_data {
          serialized
          raw
        }
      }
    }
    offices(page: $page, limit: $limit, filter: $filter) {
      count
      results {
        email
        id
        name
        office_id
        phone
        updated_at
        active
        wr_resource_id
        raw_data {
          serialized
          raw
        }
      }
    }
  }
}
    `;
export const useResourceGroupSearchDetailsQuery = <
      TData = ResourceGroupSearchDetailsQuery,
      TError = Error
    >(
      variables?: ResourceGroupSearchDetailsQueryVariables,
      options?: UseQueryOptions<ResourceGroupSearchDetailsQuery, TError, TData>
    ) =>
    useQuery<ResourceGroupSearchDetailsQuery, TError, TData>(
      variables === undefined ? ['ResourceGroupSearchDetails'] : ['ResourceGroupSearchDetails', variables],
      fetcher<ResourceGroupSearchDetailsQuery, ResourceGroupSearchDetailsQueryVariables>(ResourceGroupSearchDetailsDocument, variables),
      options
    );

useResourceGroupSearchDetailsQuery.getKey = (variables?: ResourceGroupSearchDetailsQueryVariables) => variables === undefined ? ['ResourceGroupSearchDetails'] : ['ResourceGroupSearchDetails', variables];
;

export const ResourceGroupSearchFieldsDocument = `
    query ResourceGroupSearchFields($resourceGroupId: ID) {
  resourceGroup: resource_group(id: $resourceGroupId) {
    fields(limit: 9999) {
      id
      displayName: display_name
      colName: col_name
      colType: col_type
      aliases
      fieldCategory: field_category {
        id
      }
    }
  }
}
    `;
export const useResourceGroupSearchFieldsQuery = <
      TData = ResourceGroupSearchFieldsQuery,
      TError = Error
    >(
      variables?: ResourceGroupSearchFieldsQueryVariables,
      options?: UseQueryOptions<ResourceGroupSearchFieldsQuery, TError, TData>
    ) =>
    useQuery<ResourceGroupSearchFieldsQuery, TError, TData>(
      variables === undefined ? ['ResourceGroupSearchFields'] : ['ResourceGroupSearchFields', variables],
      fetcher<ResourceGroupSearchFieldsQuery, ResourceGroupSearchFieldsQueryVariables>(ResourceGroupSearchFieldsDocument, variables),
      options
    );

useResourceGroupSearchFieldsQuery.getKey = (variables?: ResourceGroupSearchFieldsQueryVariables) => variables === undefined ? ['ResourceGroupSearchFields'] : ['ResourceGroupSearchFields', variables];
;

export const FieldSearchValuesDocument = `
    query FieldSearchValues($id: ID) {
  field(id: $id) {
    searchValues: search_values
  }
}
    `;
export const useFieldSearchValuesQuery = <
      TData = FieldSearchValuesQuery,
      TError = Error
    >(
      variables?: FieldSearchValuesQueryVariables,
      options?: UseQueryOptions<FieldSearchValuesQuery, TError, TData>
    ) =>
    useQuery<FieldSearchValuesQuery, TError, TData>(
      variables === undefined ? ['FieldSearchValues'] : ['FieldSearchValues', variables],
      fetcher<FieldSearchValuesQuery, FieldSearchValuesQueryVariables>(FieldSearchValuesDocument, variables),
      options
    );

useFieldSearchValuesQuery.getKey = (variables?: FieldSearchValuesQueryVariables) => variables === undefined ? ['FieldSearchValues'] : ['FieldSearchValues', variables];
;

export const ResourceGroupStatsDocument = `
    query ResourceGroupStats($id: ID!, $job: StatJob, $limit: Int, $page: Int) {
  resourceGroupStats: resource_group(id: $id) {
    id
    stats(page: $page, limit: $limit, job: $job) {
      ...statFields
    }
  }
}
    ${StatFieldsFragmentDoc}`;
export const useResourceGroupStatsQuery = <
      TData = ResourceGroupStatsQuery,
      TError = Error
    >(
      variables: ResourceGroupStatsQueryVariables,
      options?: UseQueryOptions<ResourceGroupStatsQuery, TError, TData>
    ) =>
    useQuery<ResourceGroupStatsQuery, TError, TData>(
      ['ResourceGroupStats', variables],
      fetcher<ResourceGroupStatsQuery, ResourceGroupStatsQueryVariables>(ResourceGroupStatsDocument, variables),
      options
    );

useResourceGroupStatsQuery.getKey = (variables: ResourceGroupStatsQueryVariables) => ['ResourceGroupStats', variables];
;

export const UpdateResourceGroupDocument = `
    mutation updateResourceGroup($action_type: String, $id: ID!, $searchData: Boolean, $indexData: Boolean, $auditData: Boolean, $skipPhotos: Boolean, $adapterId: Int, $updated_at_field: String, $populate_date_field: String, $photos_updated_at_field: String, $unique_id_field: String, $track_fields: [String], $photo_strategy: ResourceGroupPhotoStrategy, $photo_settings: PhotoSettingsInput, $status: ResourceGroupStatus, $replication: Boolean, $purge_listings_automatically: Boolean, $reverse_audit_interval: Int, $dom_calculation_v2: Boolean) {
  updateResourceGroup(
    action_type: $action_type
    id: $id
    adapter_id: $adapterId
    updated_at_field: $updated_at_field
    photos_updated_at_field: $photos_updated_at_field
    populate_date_field: $populate_date_field
    unique_id_field: $unique_id_field
    track_fields: $track_fields
    photo_strategy: $photo_strategy
    photo_settings: $photo_settings
    search_data: $searchData
    index_data: $indexData
    audit_data: $auditData
    status: $status
    skip_photos: $skipPhotos
    replication: $replication
    purge_listings_automatically: $purge_listings_automatically
    reverse_audit_interval: $reverse_audit_interval
    dom_calculation_v2: $dom_calculation_v2
  ) {
    ...AdapterResourceGroupFields
  }
}
    ${AdapterResourceGroupFieldsFragmentDoc}`;
export const useUpdateResourceGroupMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateResourceGroupMutation, TError, UpdateResourceGroupMutationVariables, TContext>) =>
    useMutation<UpdateResourceGroupMutation, TError, UpdateResourceGroupMutationVariables, TContext>(
      ['updateResourceGroup'],
      (variables?: UpdateResourceGroupMutationVariables) => fetcher<UpdateResourceGroupMutation, UpdateResourceGroupMutationVariables>(UpdateResourceGroupDocument, variables)(),
      options
    );
export const CreateTransformDocument = `
    mutation CreateTransform($fieldId: Int, $operation: OperationEnum, $order: Int, $data: String, $serializeOnly: Boolean) {
  createTransform(
    field_id: $fieldId
    operation: $operation
    order: $order
    data: $data
    serialize_only: $serializeOnly
  ) {
    id
    field {
      id
      transforms {
        id
        order
        operation
        data
        serialize_only
        field_id
      }
    }
  }
}
    `;
export const useCreateTransformMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTransformMutation, TError, CreateTransformMutationVariables, TContext>) =>
    useMutation<CreateTransformMutation, TError, CreateTransformMutationVariables, TContext>(
      ['CreateTransform'],
      (variables?: CreateTransformMutationVariables) => fetcher<CreateTransformMutation, CreateTransformMutationVariables>(CreateTransformDocument, variables)(),
      options
    );
export const DestroyTransformDocument = `
    mutation DestroyTransform($id: ID!) {
  deleteTransform(id: $id)
}
    `;
export const useDestroyTransformMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<DestroyTransformMutation, TError, DestroyTransformMutationVariables, TContext>) =>
    useMutation<DestroyTransformMutation, TError, DestroyTransformMutationVariables, TContext>(
      ['DestroyTransform'],
      (variables?: DestroyTransformMutationVariables) => fetcher<DestroyTransformMutation, DestroyTransformMutationVariables>(DestroyTransformDocument, variables)(),
      options
    );
export const ReorderTransformsDocument = `
    mutation ReorderTransforms($ids: [ID]!) {
  reorderTransforms(ids: $ids)
}
    `;
export const useReorderTransformsMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<ReorderTransformsMutation, TError, ReorderTransformsMutationVariables, TContext>) =>
    useMutation<ReorderTransformsMutation, TError, ReorderTransformsMutationVariables, TContext>(
      ['ReorderTransforms'],
      (variables?: ReorderTransformsMutationVariables) => fetcher<ReorderTransformsMutation, ReorderTransformsMutationVariables>(ReorderTransformsDocument, variables)(),
      options
    );
export const TransformPipelineDocument = `
    mutation TransformPipeline($fieldId: ID!, $rawSource: String) {
  transformPipeline(field_id: $fieldId, raw_source: $rawSource) {
    rawSource: raw_source
    finalOutput: final_output
    steps {
      file
      input
      output
    }
  }
}
    `;
export const useTransformPipelineMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<TransformPipelineMutation, TError, TransformPipelineMutationVariables, TContext>) =>
    useMutation<TransformPipelineMutation, TError, TransformPipelineMutationVariables, TContext>(
      ['TransformPipeline'],
      (variables?: TransformPipelineMutationVariables) => fetcher<TransformPipelineMutation, TransformPipelineMutationVariables>(TransformPipelineDocument, variables)(),
      options
    );
export const UpdateTransformDocument = `
    mutation UpdateTransform($id: ID!, $fieldId: Int, $order: Int, $operation: OperationEnum, $data: String, $serializeOnly: Boolean) {
  updateTransform(
    id: $id
    field_id: $fieldId
    order: $order
    operation: $operation
    data: $data
    serialize_only: $serializeOnly
  ) {
    id
    order
    operation
    data
    serialize_only
  }
}
    `;
export const useUpdateTransformMutation = <
      TError = Error,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTransformMutation, TError, UpdateTransformMutationVariables, TContext>) =>
    useMutation<UpdateTransformMutation, TError, UpdateTransformMutationVariables, TContext>(
      ['UpdateTransform'],
      (variables?: UpdateTransformMutationVariables) => fetcher<UpdateTransformMutation, UpdateTransformMutationVariables>(UpdateTransformDocument, variables)(),
      options
    );